import React, { Component, useEffect, useState } from 'react';
import { FetchGroups } from './FetchGroups';
import { MediaCard } from './MediaCard';
import Sticky from 'react-stickynode';
import Alert from '@material-ui/lab/Alert';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import { withStyles, ThemeProvider, createMuiTheme, styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import TextField from '@material-ui/core/TextField';
import { Button as MuiButton } from '@material-ui/core/Button';
import { ActionCard } from './MediaCard';

import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import * as QueryString from "query-string"

import CryptoJS from 'crypto-js';
import aes from 'crypto-js/aes';

import settings from "./settings.json";
import parsePN, { addToCart } from "../code/parsers.js";
import { includeFilter, includesFilter, internalFilter } from "../code/filters.js";
import {
    setScript, utilityFunction, invalidAction,
    sessGetObj, sessSetObj, checkRequired, calcSC, isBNC
} from "../code/utility.js";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import WidgetsIcon from '@material-ui/icons/Widgets';
import DnsIcon from '@material-ui/icons/Dns';
import PersonPinIcon from '@material-ui/icons/PersonPin';

import PropTypes from 'prop-types';

import { Stepper, Step, StepLabel, StepConnector } from '@material-ui/core';
import stepConnectorClasses from '@material-ui/core/StepConnector';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import CheckIcon from '@material-ui/icons/Check';

import { Input, Button } from 'reactstrap';

import * as M from 'mathjs';
import { unstable_batchedUpdates } from 'react-dom';
import { forEach } from 'mathjs';

import ReactHtmlParser from 'react-html-parser';

//#region Styles and Themes

const useStyles = withStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    grandTot: {
        fontWeight: 'bold',
    },
}));    

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

// currently unsed - done through css overrides in common.css
const PCStepConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 24,
        left: 'calc(-50% + 33px)',
        right: 'calc(50% + 33px)'
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main
        }
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main
        }
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderTopWidth: 2
    }
}));

const PCStepIconRoot = styled('div')(({ theme, ownerstate }) => ({
    backgroundColor: '#bdbdbd',
    zIndex: 1,
    color: theme.palette.primary.contrastText,
    fontSize: '1.5rem',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerstate.active && {
        backgroundColor: theme.palette.primary.main,
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
    }),    
    '&.PCStepIcon-circle': {
        borderRadius: '50%',
        backgroundColor: 'currentColor'        
    },
    '&.PCStepIcon-completed': {
        color: theme.palette.primary.main,        
        zIndex: 1
    },
    ...(ownerstate.completed && {
        backgroundColor: theme.palette.primary.main,
        fontSize: '3rem'
    })
}));

function PCStepIcon(props) {
    const { active, completed, className, icon } = props;
    
    return (
        <PCStepIconRoot ownerstate={{ completed, active }} className={className}>
            {
                completed
                    ? (<CheckCircleIcon className='PCStepIcon-completed' />)
                    : (<div className='PCStepIcon-circle'>{icon}</div>)
            }
        </PCStepIconRoot>
    );
}

PCStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node
};

const ctcTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#C8102E',
            contrastText: '#fff'
        }
    }
});

const proTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#1B365D',
            contrastText: '#fff'
        }
    }
});

const tmpTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#00843D',
            contrastText: '#fff'
        }
    }
});

const connectTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#F2BE22',
            contrastText: '#fff'
        }
    }
})

// Theme defaults
let themeClass = 'ctc';
let activeTheme = themeClass;
let themeButton = 'ctc-btn';

//#endregion
const PCImg = (props) => {

    let [ hidden, setHidden ] = useState('');

    let { img, h, w, split, p, i, pw } = props;
    let nullimg = false;
    if (!img) nullimg = true;

    if (img && !img.endsWith('.png')) img = img + '.png';
    p = p ? p : 'left';

    let mainurl = "https://www.ctconline.com/img/WEBREADY/PC_IMAGES/";
    let url = mainurl + img + "";
    if (nullimg) url = '';

    //let ix = new Image();
    //ix.src = url;

    const onImageError = (e) => {
        setHidden('none')
    }

    w = (hidden == 'none' ? '14' : w);
    if (w && !w.endsWith('%')) w = w + 'px';

    return (
        <div className="pc-cell" style={{
            backgroundImage: 'url(' + url + ')',
            height: h + 'px', width: w, backgroundPosition: p, textAlign: p=='right'?'left':'right'
        }}>
            {!i ? null : <img src={mainurl + i + '.png'} style={{ verticalAlign: 'unset', display: hidden }} onError={onImageError} />}
        </div>

    );
}

const RenderCableOutput = (props) => {
    let {
        style, leftL, armor, equal, sfflip, coiled, cable, ccposright, rightL,
        con1, csl, cc1, cc2, acl, sfc, sf, cal, cc1r, cc2r, acr, car, csr, con2, IMGDIAG
    } = props;

    return (<>
        <div className="io-row" style={style}>
            {!con1 ? null : <div className="io-cell"><PCImg i={con1} h="200" /></div>}
            {!leftL ? null : <div className="io-cell"><PCImg img={csl} h="200" w="14" /></div>}

            {!armor || equal || !leftL ? null : <>
                {!cc1 ? null : <div className="io-cell"><PCImg img={cc1} h="200" w="25" /></div>}
                {!cc2 ? null : <div className="io-cell"><PCImg img={cc2} h="200" w="25" /></div>}
                {!csl ? null : <div className="io-cell"><PCImg img={csl} h="200" w="50" /></div>}
            </>}

            {!armor ? null : <div className="io-cell"><PCImg img={acl} h="200" w="6" /></div>}

            {!armor || equal || !leftL ? <>
                {!cc1 ? null : <div className="io-cell"><PCImg img={cc1} h="200" w="25" /></div>}
                {!cc2 ? null : <div className="io-cell"><PCImg img={cc2} h="200" w="25" /></div>}
            </> : null}

            {sfflip ? <>
                {!sfc ? null : <div className="io-cell"><PCImg img={sfc} h="200" w="50" /></div>}
                {!sf ? null : <div className="io-cell"><PCImg i={sf} h="200" /></div>}
            </> : null}

            {!coiled ? null : <div className="io-cell"><PCImg img={csl} h="200" w="50" /></div>}
            {!coiled ? null : <div className="io-cell"><PCImg i={cal} h="200" /></div>}

            {!cable ? null : <div className="io-cell" style={{ width: '50%' }}>
                <PCImg img={cable} h="200" w="100%" i="split_L" />
            </div>}
            {!cable ? null : <div className="io-cell" style={{ width: '50%' }}>
                <PCImg img={cable} h="200" w="100%" p="right" i="split_R" />
            </div>}

            {ccposright ? <>
                {!cc1r ? null : <div className="io-cell"><PCImg img={cc1r} h="200" w="25" /></div>}
                {!cc2r ? null : <div className="io-cell"><PCImg img={cc2r} h="200" w="25" /></div>}
            </> : null}

            {!armor ? null : <div className="io-cell"><PCImg img={acr} h="200" w="6" /></div>}

            {!coiled ? null : <div className="io-cell"><PCImg i={car} h="200" /></div>}
            {!coiled ? null : <div className="io-cell"><PCImg img={csr} h="200" w="50" /></div>}

            {!armor || equal ? null : <div className="io-cell"><PCImg img={csr} h="200" w="50" /></div>}

            {sfflip ? null : <>
                {!sf ? null : <div className="io-cell"><PCImg i={sf} h="200" /></div>}
                {!sfc ? null : <div className="io-cell"><PCImg img={sfc} h="200" w="50" /></div>}
            </>}

            {ccposright ? null : <>
                {!cc1r ? null : <div className="io-cell"><PCImg img={cc1r} h="200" w="25" /></div>}
                {!cc2r ? null : <div className="io-cell"><PCImg img={cc2r} h="200" w="25" /></div>}
            </>}

            {!rightL ? null : <div className="io-cell"><PCImg img={sfc ? sfc : csr} h="200" w="14" /></div>}
            {!con2 ? null : <div className="io-cell"><PCImg i={con2} h="200" /></div>}
        </div>

        {!IMGDIAG ? null :
            <div className="io-row">
                {!con1 ? null : <div className="io-cell"><div className="pc-desc">{con1}</div></div>}
                {!leftL ? null : <div className="io-cell"><div className="pc-desc">{csl}</div></div>}

                {!armor || equal || !leftL ? null : <>
                    {!cc1 ? null : <div className="io-cell"><div className="pc-desc">{cc1}</div></div>}
                    {!cc2 ? null : <div className="io-cell"><div className="pc-desc">{cc2}</div></div>}
                    {!csl ? null : <div className="io-cell"><div className="pc-desc">{csl}</div></div>}
                </>}

                {!armor ? null : <div className="io-cell"><div className="pc-desc">{acl}</div></div>}

                {!armor || equal || !leftL ? <>
                    {!cc1 ? null : <div className="io-cell"><div className="pc-desc">{cc1}</div></div>}
                    {!cc2 ? null : <div className="io-cell"><div className="pc-desc">{cc2}</div></div>}
                </> : null}

                {!coiled ? null : <div className="io-cell"><div className="pc-desc">{csl}</div></div>}
                {!coiled ? null : <div className="io-cell"><div className="pc-desc">{cal}</div></div>}

                {!cable ? null : <div className="io-cell"><div className="pc-desc">{cable}</div></div>}
                {!cable ? null : <div className="io-cell"><div className="pc-desc">{cable}</div></div>}

                {ccposright ? <>
                    {!cc1r ? null : <div className="io-cell"><div className="pc-desc">{cc1r}</div></div>}
                    {!cc2r ? null : <div className="io-cell"><div className="pc-desc">{cc2r}</div></div>}
                </> : null}


                {!armor ? null : <div className="io-cell"><div className="pc-desc">{acr}</div></div>}

                {!coiled ? null : <div className="io-cell"><div className="pc-desc">{car}</div></div>}
                {!coiled ? null : <div className="io-cell"><div className="pc-desc">{csr}</div></div>}

                {!armor || equal ? null : <div className="io-cell"><div className="pc-desc">{csr}</div></div>}

                {!sf ? null : <div className="io-cell"><div className="pc-desc">{sf}</div></div>}
                {!sfc ? null : <div className="io-cell"><div className="pc-desc">{sfc}</div></div>}

                {ccposright ? null : <>
                    {!cc1r ? null : <div className="io-cell"><div className="pc-desc">{cc1r}</div></div>}
                    {!cc2r ? null : <div className="io-cell"><div className="pc-desc">{cc2r}</div></div>}
                </>}

                {!rightL ? null : <div className="io-cell"><div className="pc-desc">{sfc ? sfc : csr}</div></div>}
                {!con2 ? null : <div className="io-cell"><div className="pc-desc">{con2}</div></div>}
            </div>
        }
    </>);
}


const getPreferredCurrency = (countryCode, curiso, cintlMult, cconversion, currencies, USD) => {
    let preferredCurrency = null;

    // Filter the currencies that include the given country code
    let currenciesUsed = currencies.filter(currency => currency.isoCode == curiso);

    //let USD = currencies.find(currency => currency.isoCode == 'USD');

    if (currenciesUsed.length > 0) {
        // Sort the currencies by the number of countries they are used in (descending)
        //currenciesUsed.sort((a, b) => b.countries.length - a.countries.length);
        // The preferred currency is the first item in the sorted array
        preferredCurrency = currenciesUsed[0];
    }
    preferredCurrency = preferredCurrency ? preferredCurrency : USD;

    if (countryCode == 'US' || countryCode == 'CA') {
        preferredCurrency = USD;
        preferredCurrency.cintlMult = 1.00;
        preferredCurrency.cconversion = 1.00;
    } else
    {
        preferredCurrency.cintlMult = cintlMult;
        preferredCurrency.cconversion = cconversion;
    }

    return preferredCurrency;
};


const fixedTo = (n, digits) => {
    if (digits === undefined) {
        digits = 0;
    }

    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    var rtn = Math.round(n) / multiplicator;

    rtn = rtn.toFixed(digits);

    return rtn;
};

export class FetchData extends Component {

    //#region Startup

    static displayName = FetchData.name;

    /**
     * The constructor
     * @param {any} props - any properties passed in from the parent
     */
    constructor(props) {
        super(props);

        // Data related to the part
        this.DIAG = settings.DIAG;
        this.IMGDIAG = false;
        this.basestate = {};
        this.reset = false;
        this.parsersran = false;
        this.timers = {};

        let y = window.location.hostname;

        if (y.startsWith("localhost")) this.DIAG = true;
        if (y.startsWith("test")) this.DIAG = true;

        if (y.startsWith("localhost")) this.IMGDIAG = true;
        if (y.startsWith("test")) this.IMGDIAG = true;

        this.SERVER_URL = settings.SERVER_URL;
        this.params = QueryString.parse(window.location.search);

        this.newdata = [];
        this.configlist = [];
        this.partlookup = {};

        this.group = "Cable";
        this.partnum = "CB103";

        this.parttemp = 'Please Select a Part';
        this.partdesc = '';
        this.comptemplate = '';
        this.colstemp = '';
        this.includespassed = true;

        this.steps_last = false;
        this.steps_iid = [];
        this.steps = ['Configure Your Part', 'Recommendations', 'Another', 'Finish'];

        this.parens = /\(([0-9+\-*/\^ .]+)\)/;             // Regex for identifying parenthetical expressions
        this.exp = /(\d+(?:\.\d+)?) ?\^ ?(\d+(?:\.\d+)?)/; // Regex for identifying exponentials (x ^ y)
        this.mul = /(\d+(?:\.\d+)?) ?\* ?(\d+(?:\.\d+)?)/; // Regex for identifying multiplication (x * y)
        this.div = /(\d+(?:\.\d+)?) ?\/ ?(\d+(?:\.\d+)?)/; // Regex for identifying division (x / y)
        this.add = /(\d+(?:\.\d+)?) ?\+ ?(\d+(?:\.\d+)?)/; // Regex for identifying addition (x + y)
        this.sub = /(\d+(?:\.\d+)?) ?- ?(\d+(?:\.\d+)?)/;  // Regex for identifying subtraction (x - y)

        // This data will come from the customer account.
        this.flatDiscPct = 10;
        this.qtyDiscPct = 10;
        this.pricelist = '';
        this.cart = false;
        this.quote = false;

        this.showprices = false;

        this.currencies = [{
            currency: 'United States dollar',
            symbol: '$',
            isoCode: 'USD',
            countries: ['US'],
            symbolBeforeAmount: true,
            decimalPlaces: 2
        }];
        this.curr = {
            currency: 'United States dollar',
            symbol: '$',
            isoCode: 'USD',
            countries: ['US'],
            symbolBeforeAmount: true,
            decimalPlaces: 2
        };
        this.USD = {
            currency: 'United States dollar',
            symbol: '$',
            isoCode: 'USD',
            countries: ['US'],
            symbolBeforeAmount: true,
            decimalPlaces: 2
        };


        this.request = false;
        this.kpn = '';

        this.state = {
            profiles: [], selected: '', selectedObj: {},
            data: [], selections: {}, 
            loading: true, loadingp: true, waiting: '',
            value: 0, activeStep: 0, noprofile: false
        };

    }

    /** Decides whether to gather the data or fill it from the parent */
    async componentDidMount() {

        if (this.props.root) {
            //let key = CryptoJS.enc.Base64.parse(settings.C79);
            //let iv = CryptoJS.enc.Base64.parse(settings.C39);
            //let ciphertext = this.props.data;
            //let incoming = ciphertext.replaceAll('_', '/').replaceAll('-', '+');
            //switch (ciphertext.Length % 4) {
            //    case 2: incoming += "=="; break;
            //    case 3: incoming += "="; break;
            //}

            //var decrypted = CryptoJS.AES.decrypt(incoming, key, { iv: iv });
            //var text = decrypted.toString(CryptoJS.enc.Utf8);

            this.props_pn = '';
            this.props_pc = '';
            this.props_filt = '';
            this.props_parts = '';
            this.props_binding = '';
            this.props_tags = '';
            this.props_pc_embed = '';
            this.props_show = '';
            this.props_pc_pctincrease = '';
            this.props_pc_priceadd = '';
            this.props_pc_priceoverride = '';
            this.props_showmsg = false;;

            await this.populateData(this.props.data, this.props.pn);

            if (this.props_pc_embed) {
                if (this.props.pc) this.props_pc = this.props.pc;
                if (this.props.filt) this.props_filt = this.props.filt;
                if (this.props.parts) this.props_parts = this.props.parts;
                if (this.props.binding) this.props_binding = this.props.binding;
                if (this.props.tags) this.props_tags = this.props.tags;
                if (this.props.pn) this.props_pn = this.props.pn;

                // When PC is set, this function will execute
                this.state.profiles.filter(x => x.name == this.props_pc).forEach(p => {

                    // Pass the binding to tell which properties we are going to set
                    this.setProfile(p.id,
                        { id: '', name: '', part: this.props_parts, filt: this.props_filt },
                        true, '', 0, null, this.props_binding, this.props_tags);
                });

                if (this.props_pn) {
                    let v = this.props_pn;
                    let noprofile = await parsePN({}, v, this);

                    //let rtn = this.reCalcOutput(pc, this.state, this.params, g, i);
                    let rtn = await this.fixPrice(this.state, this.params);
                    rtn.noprofile = noprofile;

                    this.setState(rtn);
                }
            }

        } else {
            this.setState({
                profiles: [], selected: '', data: this.props.data.configs,
                selections: this.props.selections, loading: this.props.root
            });
        }

    }

    //#endregion

    //#region Profile Selection

    /**
     * Populates the profiles
     * @param {any} data
     */
    async populateData(data, pn) {
        this.newdata = [];
        let hash = 0;
        let dat = {};

        if (this.params.mode && this.params.mode == 'pldata') {
            var ctcpn = this.params.ctcpn;
            let _url = 'PCProfileImpl/partcreator/getpldata/' + ctcpn;
            
            let _subdata = sessGetObj(_url + "/" + hash);
            if (_subdata && !this.props.nocache) {
                dat = _subdata;
            } else {
                // else run the wide open request
                let response = await fetch(this.SERVER_URL + _url);
                dat = await response.json();
                sessSetObj(_url + "/" + hash, dat);
            }
            this.setState((s, p) => {
                return {
                    pldata: dat
                };
            });
            return;
        }

        let url = 'PCProfileImpl/partcreator/getprofiles/' + data;
        let subdata = sessGetObj(url + "/" + hash);
        if (subdata && !this.props.nocache) {
            dat = subdata;
        } else {
            // else run the wide open request
            let response = await fetch(this.SERVER_URL + url);
            dat = await response.json();
            sessSetObj(url + "/" + hash, dat);
        }

        // Filter out any profiles that are archived
        dat.pros = dat.pros.filter(x => !x.archive);

        this.props_pc_embed = dat.pc_embed;

        if (this.props_pc_embed) {
            let _profiles = dat.pros;
            this.flatDiscPct = dat.disc;
            this.qtyDiscPct = 0;
            this.pricelist = dat.plst ? dat.plst.split('~~~').map(x => x.split(':')) : [['']];

            this.request = dat.request;
            this.cart = dat.cart;
            this.quote = dat.quote;
            this.request = dat.request;
            this.showprices = dat.show;
            this.currencies = dat.currencies;

            this.curr = getPreferredCurrency(dat.iso, dat.curiso, dat.upchg, dat.rate, this.currencies, this.USD);

            this.props_showmsg = !dat.show && !dat.intl && !dat.custnum;

            this.props_pc_embed = dat.pc_embed;
            if (this.props_pc_embed) {
                this.props_pc_pctincrease = dat.pc_pctincrease = '';
                this.props_pc_priceadd = dat.pc_priceadd = '';
                this.props_pc_priceoverride = dat.pc_priceoverride = '';
            }

            // when the parameters are embedded this way, the "know your part number" feature breaks
            // this if statement prevents the parameters from being filled in in that circumstance.
            if (!pn) {
                this.props_pc = dat.pc;
                this.props_filt = dat.filter;
                this.props_parts = dat.parts;
                this.props_binding = dat.binding;
                this.props_tags = dat.tags;
            }

            this.setState((s, p) => {
                return {
                    profiles: _profiles, loadingp: false, email: { state: '', name: '', phone: '', email: '' }
                };
            });
        } else {
            this.setState((s, p) => {
                return {
                    loadingp: false, email: { state: '', name: '', phone: '', email: '' }
                };
            });
        }
    }

    //#region Part Creator Logic

    /**
     * Builds the newdata array which is a list of profiles
     * @param {any} id
     */
    async populateData2(id, newid, idat, parent, maxqty, binding, tags, unseltitle, inittemplate, replace) {

        //binding = '';

        // #region Modify Data
        // We reach to the server to get more data about the selected group
        let newdata = [];

        // #region Get the data from API with optional parts and filters
        let _data = {};

        // A comma seperated list of parts can be provided
        let parts = [];
        if (idat.part) {
            parts = idat.part.replaceAll(' ', '').split(',');
            parts = parts.filter(e => e);
        }

        // a comma seperated list of filters can be provided
        let filters = [];
        if (idat.filt) {
            filters = idat.filt.replaceAll(' ', '').split(',');
            filters = filters.filter(e => e);
        }

        // create the object for selececting specific parts or folters
        let json = { parts, filters };
        let hash = 0;

        let url = 'PCProfileImpl/partcreator/' + id;

        // if the filter object has something in it
        if (parts.length > 0 || filters.length > 0) {

            //var subdata = JSON.parse(window.sessionStorage.getItem("saved"));

            let obj = JSON.stringify(json);
            hash = this.hashCode(obj);

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: obj
            };

            var subdata = sessGetObj(url + "/" + hash);
            if (subdata && !this.props.nocache) {
                _data = subdata;
            } else {
                // run the filtered reques
                let response = await fetch(this.SERVER_URL + url, requestOptions);
                _data = await response.json();
                sessSetObj(url + "/" + hash, _data);
            }
        } else {

            var subdata = sessGetObj(url + "/" + hash);
            if (subdata && !this.props.nocache) {
                _data = subdata;
            } else {
                // else run the wide open request
                let response = await fetch(this.SERVER_URL + url);
                _data = await response.json();
                sessSetObj(url + "/" + hash, _data);
            }
        }

        //Give every config option a new id, so they dont collide later
        _data.configgroup.forEach(c => {
            c.configs.forEach(cc => {
                let newid = this.uuidv4();

                cc.id = newid;
            });
        });

        // This code allows the override of the includes to add items
        // of the target part creator, this was useful in creating an
        // additional item for the vibration pole for connector compatiblity
        // with a specific selected sensor.
        let _ans = this.getNested(idat, 'ans');
        _ans?.ovr?.forEach(ov => {
            ov.configs?.forEach(o => {
                let cg = _data.configgroup.find(c => c.shortcode == ov.group);
                let opt = cg.configs.find(cc => cc.name == o.name);
                if (!opt)
                {
                    if (!o.id) o.id = this.uuidv4();
                    if (!o.bl) o.bl = [];
                    if (!o.bp) o.bp = [];
                    cg.configs.push(o);
                }else
                {
                	if(o.when) opt.when = o.when;
				}
            });
        });

        if (unseltitle) {
            _data.unseltitle = unseltitle;
        }

        if (inittemplate) {
            _data.inittemplate = inittemplate;
        }

        if (idat) {
            _data.idat = idat;
        }


        // put the result in the new data array -- eventually refactor, as doing this isnt needed anymore.
        if (newdata.length == 0)
            newdata.push(_data);

        // #endregion

        // the part creator data can be requested with additional data called idat. this is used with 
        // requests where the part creator has been invoked as part of an included part
        // I.E. not the originally created part but a "recommended part to add to order"
        if (idat.filterfield) {
            includeFilter(idat.filterfield, newdata, parent, this);
        }

        // Collect all of the configurations and make a master list of configurations and groups
        let configgroups = [];
        let configlist = [];

        // each group in the part creator is created with an id to identigy which part creator it is
        // intially the id is driven by the database, but in this code we reassign it to a new id, so that
        // more than one part creator of the same kind may be on the screen simultaneously, also the way
        // the part creator is invoked can provide several overrides based on its "include" implementation (idat)
        newdata.forEach(d => {
            d.configlist = [];

            d.orgid = id;
            d.id = newid;
            d.qty = maxqty ? maxqty : 1;
            d.parent = parent ? parent : '';
            d.max = maxqty;
            d.iid = idat.id;
            d.iname = idat.name;

            // loop all the config groups
            d.configgroup.forEach(e => {

                // create a collection of config groups
                configgroups.push({ id: e.id, val: e.name, sc: e.shortcode, pc: newid, inverted: e.blInverted });

                // assign the config group the pc id
                e.pcprofile = d.id;

                // loop the block options and set the fix the config id
                e.bl.forEach(b => {
                    b.config = d.id + '_' + b.config;
                });

                // loop the configs/options and 
                e.configs.forEach(f => {

                    // hard code some values from the parent config group
                    f.blInverted = e.blInverted;
                    f.configgroup = e.id;

                    //f._pcprofile = '';
                    //Object.defineProperty(
                    //    f,
                    //    'pcprofile',
                    //    {
                    //        get: function () {
                    //            return this._pcprofile;
                    //        },
                    //        set: function (val) {
                    //            this._pcprofile = val;
                    //        }
                    //    }
                    //);

                    f.pcprofile = d.id;
                    f.parent = e.id;

                    // loop the block options and fix the config id
                    f.bl.forEach(b => {
                        b.config = d.id + '_' + b.config;
                    });

                    //create a list of configs/options
                    this.configlist.push(f);
                    d.configlist.push(f);
                    configlist.push(f);

                });
            });
        });

        // Generate the copies
        // this is used for cables where there are 2 connectors groups present
        let inc = 0;

        // loop each of the groups
        newdata.forEach(d => {
            d.configgroup.forEach(e => {

                //if the group is designated as a copy
                if (e.type == '2') {

                    // find the group 'g' that this group is a copy of
                    let g = d.configgroup.filter(f => f.name == e.copyof)[0] || {};

                    // set variables
                    e.blInverted = g.blInverted;
                    if (g.id) {

                        // copy all of the groups configs, rename the id, add the copies to the config list
                        g.configs.forEach(f => {
                            let id = this.uuidv4();
                            let _f = JSON.parse(JSON.stringify(f));
                            _f.blockoptions = _f.blockoptions ? _f.blockoptions.replaceAll(e.id, g.id) : '';
                            _f.blInverted = e.blInverted;
                            _f.id = "copy_" + id;
                            _f.configgroup = e.id;
                            _f.parent = e.id;
                            e.configs.push(_f);
                            this.configlist.push(_f);
                            d.configlist.push(_f);
                            configlist.push(_f);
                        });

                        // if the block list of the copy includes the group being copied
                        // to, flip the block ids (Example, Connector 1 and 2 block each other)
                        // since connector 1 calls out a block against connector 2, 
                        // connector 2 could call out a block against connector 1
                        // loop the blocks and implement the switch
                        g.bl.forEach(f => {
                            let _f = JSON.parse(JSON.stringify(f));
                            let cfg = _f.config.split('_')
                            if (cfg[0] == e.pcprofile && cfg[1] == e.id) {
                                _f.config = g.id;
                            }
                            e.bl.push(_f);
                        });
                    }
                }
            });
        });

        // a copy of the config list
        //configlist = this.configlist;

        // apply block options if they are provided in the idat
        // This code is executed here, as where it is normally exected is too late for the blocking properties.
        // usually this foreignPropMod code is invoked as a result of selecting something, and not available in the initial load.
        let ans = this.getNested(idat, 'ans');
        if (ans && ans.id && ans.id.length > 0) {
            let json = ans.ovr || '';

            if (json) {
                json.forEach(j => {
                    let sc = j.group;

                    newdata.forEach(d => {
                        let grp = d.configgroup.find(e => e.shortcode == sc);
                        if (grp) {
                            this.foreignPropModWGrp(j, grp);
                        }
                    });
                });
            }

        }

        //#region typed blockoptions implemention here
        // Generate the block lists since there are too many to pass thru in the data fetch.
        // loop all the config groups
        newdata.forEach(d => {
            d.configgroup.forEach(group => {

                // if there are some tags set, push them into a tagopts property
                group.tagopts = [];
                group.tags && group.tags.split(',').forEach(e => group.tagopts.push({ v: e.trim(), sel: false }));

                // for each of the options/configs
                group.configs.forEach(option => {
                    let x = 0;

                    // Check if there are any blockoptions available, THE NEW "BETTER AND LESS CONVOLUTED" WAY OF BLOCKING
                    if (option.blockoptions) {

                        // Get the text list of blocked options ids
                        let ar = option.blockoptions.split(';');

                        // loop the  blocked options
                        ar.forEach(a => {

                            // as long as a is not empty
                            if (a.trim() != '') { 

                                // get the name of the blocked option
                                let pid = a.split(':')[0].trim();
                                if (pid.length < 10) {
                                    let temp = configgroups.filter(c => c.sc == pid)
                                    pid = temp.length > 0 ? temp[0].id : pid;
                                }

                                // Get the blocked options
                                let _blopts = a.split(':')[1];

                                // if blocked options are filled in
                                if (_blopts) {

                                    // get the list of options
                                    let tmpblopts = _blopts.split(',').map(e => e.trim());
                                    let blopts = [...new Set(tmpblopts)];

                                    let tmpblopts2 = this.trim(_blopts, '-').split(',').map(e => e.trim());
                                    let blopts2 = [...new Set(tmpblopts2)];

                                    // a temp array of blocked options for the code below
                                    let tempbl = [];

                                    // If the list contains '-' it means that we are removing options from a complete list
                                    // I.E. Everything except for - we will start with a full list and delete from there
                                    if (_blopts.startsWith('-')) {
                                        configlist.filter(blconfig => blconfig.configgroup == pid).forEach(o => {
                                            // add it to the blocked list
                                            tempbl.push({
                                                config: o.pcprofile + '_' + pid, val: o.id,
                                                name: o.name, pid: pid
                                            });
                                        });
                                    }

                                    // filter the full list based on the blocked list
                                    if (_blopts.startsWith('-')) {
                                        tempbl = tempbl.filter(b => !blopts2.includes(b.name));
                                        // cancat the full the block list since we may get multiple block list from multiple options
                                        option.bl = option.bl.concat(tempbl);
                                    }

                                    // for each blocked opt id
                                    blopts.forEach(blockid => {
                                        if (blockid != '') {

                                            // If the list contains '-' we are starting with a full list
                                            if (_blopts.startsWith('-')) {
                                                blockid = this.trim(blockid, '-');//blockid.replaceAll('-', '');
                                                let _blockid = blockid.replaceAll('*', '');

                                                // This part of the code may need refactoring - as i think 
                                                // the previous part is doing this
                                                // you can designate a list of parts by wildcard
                                                if (blockid.startsWith('*')) {
                                                    tempbl = tempbl.filter(b => !b.name.endsWith(_blockid));
                                                    option.bl = option.bl.concat(tempbl);
                                                }
                                                else if (blockid.endsWith('*')) {
                                                    tempbl = tempbl.filter(b => !b.name.startsWith(_blockid));
                                                    option.bl = option.bl.concat(tempbl);
                                                }
                                                else {
                                                    //tempbl = tempbl.filter(b => b.name != _blockid);
                                                }
                                                let _x = 0;
                                            }

                                            // this chunk is the oposite of aboe, where blocked items 
                                            // are added to an empty list.
                                            else {
                                                let _blockid = blockid.replaceAll('*', '');
                                                if (blockid.startsWith('*')) {
                                                    // match each blocked id to an option of a matching group and option id
                                                    configlist.filter(blconfig => blconfig.configgroup == pid &&
                                                        blconfig.name.endsWith(_blockid)).forEach(o => {
                                                            // add it to the blocked list
                                                            option.bl.push({
                                                                config: o.pcprofile + '_' + pid, val: o.id,
                                                                name: o.name, pid: pid
                                                            });
                                                        });
                                                }
                                                else if (blockid.endsWith('*')) {
                                                    // match each blocked id to an option of a matching group and option id
                                                    configlist.filter(blconfig => blconfig.configgroup == pid &&
                                                        blconfig.name.startsWith(_blockid)).forEach(o => {
                                                            // add it to the blocked list
                                                            option.bl.push({
                                                                config: o.pcprofile + '_' + pid, val: o.id,
                                                                name: o.name, pid: pid
                                                            });
                                                        });
                                                }
                                                else {
                                                    // match each blocked id to an option of a matching group and option id

                                                    configlist.filter(blconfig => blconfig.configgroup == pid &&
                                                        blockid == blconfig.name).forEach(o => {
                                                            // add it to the blocked list
                                                            option.bl.push({
                                                                config: o.pcprofile + '_' + pid, val: o.id,
                                                                name: o.name, pid: pid
                                                            });
                                                        });
                                                }
                                            }
                                        }
                                    });
                                } else {
                                    // if blocked options was blank
                                    // then block the entire group, and additionally i beleive this will
                                    // make the group disappear from the output (I.E. Options PN and description)
                                    option.bl.push({
                                        config: newid + '_' + pid, val: '',
                                        name: '', pid: pid
                                    });
                                }
                            }
                        });
                    }
                });
            });
        });
        //#endregion

        // Convert the typed blocks into real ones -- Another area to refactor,
        // i dont think the code ever used the typed blocks as designed by the next chunk
        configlist.forEach(d => {

            let _bl = [];
            d.bl.forEach(g => {
                if (!g.val && g.typed) {
                    g.typed.split(',').map(t => t.trim()).forEach(e => {
                        if (g.config.split('_').length > 1) {
                            let _x = g.config.split('_')[1];
                            configlist.filter(x => x.configgroup == _x && x.name == e).forEach(h => {
                                let _b = { ...g };
                                _b.typed = '';
                                _b.val = h.id;
                                _bl.push(_b);
                            });
                        }
                    });
                } else {
                    let _b = { ...g };
                    _bl.push(_b);
                }
            });
            if (_bl.length > 0) {
                d.bl = _bl;
            }
        });


        // check to see if we are populating a inverted inverse...
        // if so fill it with everything from the other side
        configlist.forEach(d => {

            // for every blocked option
            d.bl.forEach(g => {
                //get that option e
                configlist.filter(e => e.id == g.val).forEach(e => {
                    // if the inverted property does not match
                    if (d.blInverted != e.blInverted) {
                        // if this is the side of the operation where nothing is entered
                        // the filter is to match the specific group
                        if (e.bl.filter(b => b.config = d.pcprofile + '_' + d.configgroup).length == 0) {
                            e.fulllist = true;
                            let _bl = configlist.filter(ci => ci.configgroup == d.configgroup)
                                .map(ci => {
                                    return { config: ci.pcprofile + '_' + ci.configgroup, val: ci.id, pid: d.configgroup };
                                });
                            e.bl = e.bl.concat(_bl);
                        }
                    }
                });
            });
        });

        // the openclose field has been recycled here we are using it to
        // tell if the option is selectable or not, loop and reopen all options
        // also normalize the selection lists by populating any inverse of each selection
        configlist.forEach(d => {

            // Also reset the variable price
            // INACTIVE
            d.openclose = !d.inactive ? 0 : -100;
            d.ord = parseFloat(d.varprice);
            if (isNaN(d.ord)) { d.ord = 0; }

            // for every blocked option
            d.bl.forEach(g => {
                //get that option e
                configlist.filter(e => e.id == g.val).forEach(e => {
                    // if the inverse was inverted remove options.
                    if (d.blInverted != e.blInverted) {
                        // if d is in the other options block list 
                        if (e.bl.filter(f => f.val == d.id).length > 0) {
                            if (e.fulllist) {
                                e.bl = e.bl.filter(f => f.val != d.id);
                            }
                        }
                        // FIll it with all the options and remove them 1 by 1
                        let b = e.bl.filter(e => e.id === d.id);
                        b.forEach(f => e.bl.splice(e.bl.findIndex(e => e.id === f.id), 1));
                    } else {
                        // if d is not already in the other options block list 
                        if (e.bl.filter(f => f.val == d.id).length == 0) {
                            // put it there
                            e.bl.push({ config: d.pcprofile + '_' + d.configgroup, val: d.id, pid: d.configgroup });
                        }
                    }
                });
            });
        });

        newdata.forEach(d => {
            d.configgroup.forEach(e => {
                e.bl.forEach(f => {
                    let cfg = f.config.split('_');
                    d.configgroup.filter(g => g.pcprofile == cfg[0] && g.id == cfg[1]).forEach(h => {
                        if (h.bl.filter(i => {
                            let _cfg = i.config.split('_');
                            return _cfg[0] == e.pcprofile && _cfg[1] == e.id
                        }).length == 0) {
                            h.bl.push({ config: d.id + '_' + e.id, val: '' })
                        }
                    });
                });
            });
        });

        // something in the loop at 580 messes up the confignames, havent been able 
        // figure out the root cause
        // fix the confignames because they get messed up somewhere above
        configlist.forEach(d => {
            // for every blocked option
            d.bl.forEach(g => {
                // fix the configname
                let ar = g.config.split('_')

                if (g.pid) {
                    g.config = newid + '_' + g.pid;
                } else if (ar.length > 1 && !g.pid) {
                    g.pid = ar[1];
                }
            });
        });

        newdata.forEach(d => {
            d.configgroup.forEach(e => {

                e.blcount = 0;
                d.configgroup.filter(_e => _e.id != e.id).forEach(f => f.bl.forEach(g => {
                    g.hit = false;
                    if (g.config == e.id) {
                        e.blcount++;
                    }
                }));
            });
        });

        //this.co.nfiglist = co.nfiglist;
        //this.co.nfiglist = { ...this.co.nfiglist, ...co.nfiglist };

        //set defaults
        let newselections = {};
        let _newselections = {};
        let cfg = {};
        newdata.forEach(d => {

            d._parttemp = 'Please Select a Part';
            d._partdesc = '';

            //d.configgroup.forEach(cfg => {
            //    if (cfg.defaultval) {
            //        //if (cfg.defaultval == '_') { cfg.defaultval = ''; }
            //        this.setOptionVal(d.id, newdata, newselections, cfg.id, '', cfg.defaultval)
            //    }
            //});
        });

        // #endregion


        //console.log(this.co.nfiglist.length);

        let sets = null;
        newdata.forEach(d => {
            d.configgroup.forEach(cfg => {
                if (cfg.defaultval) {
                    let resp = this.setOptionVal(d.id, newdata, newselections, _newselections, cfg.id, '', cfg.defaultval);
                    if (!sets) sets = [];
                    sets.push({ gid: resp.id, lid: resp.v });
                }
            });
        });

        newdata[0].binding = binding;
        this.setPopulatedData2(newdata, newselections, binding, sets, tags, replace);
        
        return newdata;
    }

    /**
     * 
     * @param {any} newdata
     * @param {any} newselections
     * @param {any} binding
     * @param {any} sets
     * @param {any} tags
     * @param {any} replace
     */
    setPopulatedData2(newdata, newselections, binding, sets, tags, replace) {

        if (replace > 0) {
            this.newdata[replace] = newdata[0];
        }
        else {
            this.newdata.push(...newdata);
        }

        this.setState((s, p) => {


            s.data = this.newdata;
            s.selections = { ...s.selections, ...newselections };

            let _basestate =
            {
                ...this.reCalcOutput1(newdata[0].id, s, p, '', '',
                    null, null, null, null, null, binding, sets, tags), loading: false
            };

            // This is a way to remove options with the binding
            let _binding = _basestate.data[0].binding;//binding;//this.props_binding;
            if (_binding) {
                _binding.split(',').forEach(b => {
                    let _b = b.split(':');
                    if (_b[1].startsWith('-')) {
                        let _b1 = _b[1].replace('-', '').split('~');
                        let cfgs = _basestate.data[0].configgroup.find(x => x.shortcode == _b[0]);
                        cfgs.configs = cfgs.configs.filter(x => _b1.includes(x.name));
                    }
                });
            }

            return _basestate;

        });
    }

    //#endregion

    /**
     * Recalculates the view state everytime something changes.
     * @param {any} pc
     * @param {any} s
     * @param {any} p
     * @param {any} g
     * @param {any} i
     * @param {any} gsch
     * @param {any} sch
     * @param {any} gflt
     * @param {any} flt
     * @param {any} dflt
     * @param {any} binding
     */
    reCalcOutput(pc, s, p, g, i, gsch, sch, gflt, flt, dflt, binding) {
        return this.reCalcOutput1(pc, s, p, g, i, gsch, sch, gflt, flt, dflt, binding, null, null);
    }

    /**
     * Recalculates the view state everytime something changes.
     * @param {any} pc
     * @param {any} s
     * @param {any} p
     * @param {any} g
     * @param {any} i
     * @param {any} gsch
     * @param {any} sch
     * @param {any} gflt
     * @param {any} flt
     * @param {any} dflt
     * @param {any} binding
     * @param {any} sets
     * @param {any} tags
     */
    reCalcOutput1(pc, s, p, g, i, gsch, sch, gflt, flt, dflt, binding, sets, tags)
    {
        let _pc = s.data.find(e => e.id == pc);

        let _binding = _pc.binding;//binding;//this.props_binding;

        let ans = this.getNested(_pc, 'idat', 'ans');
        if (ans && ans.id && ans.id.length > 0) {
            _binding = ans.binding || '';
        }

        if (_binding) {
            _binding.split(',').forEach(b => {
                let _b = b.split(':');
                if (!_b[1].startsWith('-')) {
                    this.setOptionValX(pc, s, '', '', _b[1], '', _b[0]);
                }
            });
        }

        // Recalculate the output based on the current selection
        let obj = this.reCalcOutput2(pc, s, p, g, i, gsch, sch, gflt, flt, dflt, tags);

        //let sets = null;
        while (!sets || sets.length > 0) {
            // if something was set from the previous iteration, racalculate the output again
            if (sets) {
                sets.forEach(set => {
                    obj = this.reCalcOutput2(pc, obj, p, set.gid, set.lid);
                });
            }
            sets = [];

            // iterate through the rest of the selections to see if there are any other
            // auto selection s that need to be made. add them to a sets list
            obj.data.forEach(d => {
                if (d.id == pc) {
                    let l = {};
                    d.configgroup.forEach(cg => {
                        l = cg.configs.filter(dat =>
                            !(dat.blInverted ? dat.openclose < cg.blcount : dat.openclose));

                        // if there is only one option available, auto select it
                        if (l.length == 1) {
                            if (!obj.selections[pc + '_' + cg.id]) {
                                let r = 0;

                                // The following block of of code allows the administrator
                                // to set a condition that otherwise prevents the auto selection of a 
                                // certain group: only when the condition is true will it autoselect
                                // true is the default if this field is not filled in.
                                let autocond = true;
                                if (cg.autocond && cg.autocond.trim()) {
                                    let o_ac = cg.autocond.split(':');
                                    let o_acfield = o_ac[0];
                                    let o_acvalue = o_ac.length > 1 ? o_ac[1] : '';

                                    this.getOptionValueWithSC(pc, s, o_acfield, (g, o) => {
                                        if (o_acvalue != o.name) {
                                            autocond = false;
                                        }
                                    });
                                }

                                // As long as we are allowed to autoselect, add it to the list
                                if (autocond) {
                                    sets.push({ gid: cg.id, lid: l[0].id });
                                }
                            }
                        }
                    });
                }
            });
        }

        // fix the text of the include tabs
        includesFilter(s, s.data[0]).forEach(inc => {
            let inneridx = 1;
            this.state.data.filter(dat => inc.id == dat.iid).forEach(dat => {
                if (inc.unseltitle) {
                    dat.unseltitle = inc.unseltitle.replaceAll('{i}', inneridx);
                    dat.block_delete = inc.block_delete;
                    dat.allow_reset = inc.allow_reset;
                    dat.block_qty = inc.block_qty;
                }
                inneridx++;
            });
        });

        //return the result
        return obj;
    }

    /**
     * 
     * @param {any} obj
     * @param {...any} args
     */
    getNested(obj, ...args) {
        let rtn = args.reduce((obj, level) => obj && obj[level], obj)
        return rtn;
    }

    /**
     * Recalculates the view state everytime something changes.
     * @param {any} pc
     * @param {any} s
     * @param {any} p
     * @param {any} g
     * @param {any} i
     * @param {any} gsch
     * @param {any} sch
     * @param {any} gflt
     * @param {any} flt
     * @param {any} dflt
     */
    reCalcOutput2(pc, s, p, g, i, gsch, sch, gflt, flt, dflt, tags) {
        let pre = '';

        // assign the current selection
        if (g != '') {

            // Record the previous selection for reference
            pre = s.selections[pc + '_' + g];
            this.setSelections(s, pc, g, i);

            if (!s._selections) s._selections = {};
            s._selections[pc + '_' + g] = i;

            // testing logic for the sensor selection
            this.getOptionValue2(pc, s, g, (grp, opt) => {

                //if (grp.selectscript) { eval(grp.selectscript); }
                utilityFunction(grp.selectscript, this, pc, s, opt);




                // if its the main group and the clearlist is blank, set the clearlist to ALL
                if (grp.maincomp && !grp.clearlist) {
                    grp.clearlist = "RESET";
                }

                // If this is a 'clear' operation and the clearlist is filled in.
                if (grp.clearlist && i == '')
                {
                    if (grp.clearlist == 'RESET') {
                        this.reset = true;
                    }
                    if (grp.clearlist == 'ALL') {
                        // If the clearlist is ALL, clear everything
                        for (const property in s.selections) {
                            if (property.startsWith(grp.pcprofile)) {
                                this.setSelectionsP(s, property, '');

                                if (!s._selections) s._selections = {};
                                s._selections[property] = '';
                            }
                        }

                        // Assign the defaults
                        s.data.forEach(d => {
                            if (d.id == pc) {
                                d._parttemp = 'Please Select a Part';
                                d._partdesc = '';

                                d.configgroup.forEach(cfg => {
                                    if (cfg.defaultval) {
                                        this.setOptionValX(d.id, s, cfg.id, '', cfg.defaultval)
                                    }
                                });
                            }
                        });
                    } else {
                        // Else just clear what the current group says to
                        grp.clearlist.split(',').forEach(cl => {
                            s.data.forEach(d => {
                                if (d.id == pc) {
                                    d.configgroup.filter(f => f.name == cl.trim() || f.shortcode == cl.trim()).forEach(opt => {
                                        this.setSelections(s, pc, opt.id, '');

                                        if (!s._selections) s._selections = {};
                                        s._selections[pc + '_' + opt.id] = '';
                                    });
                                }
                            });
                        });
                    }
                }
            });
        }

        // Loop the selections to create a colletion of option change variables
        // Specifically the conversion value for Meters and Feet
        let numops = [];
        for (const property in s.selections) {

            let group = {};
            let option = {};

            // Get the group
            s.data.forEach(d => {
                if (d.id == pc) {
                    let g = d.configgroup.find(f => f.id == property)
                    group = g || { name: '', type: '1' };
                }
            });

            // get the option
            let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[property]);
            option = _o || { name: '', grouptitle: '', ord: 0 };

            //this.getOptionValue(pc, s, property, (_g, _o) => {
                //group = _g || { name: '', type: '1' };
                //option = _o;
            //});

            // if the numoperatorvar is available add it to the numops list
            if (option.numoperatorvar) {
                numops.push({ grp: group, val: option.numoperatorvar, fld: option.numoperatorfields.split(',') });
            }
        }

        // If a search value is typed in, apply it
        // gsch is the group that the search was typed in on
        if (gsch && gsch != '') {

            // Get the value of the current option
            this.getOptionValue2(pc, s, gsch, (selGrp, selOpt) => {
                selGrp.sch = sch;
            });
        }

        // if a filter value is provided, add/delete it from the filter
        // gflt is the group that the filter was applied to
        if (gflt && gflt != '') {

            // Get the value of the current option
            this.getOptionValue2(pc, s, gflt, (selGrp, selOpt) => {
                selGrp.flt = flt;
                selGrp.tagopts.forEach(e => {
                    if (e.v == flt) {
                        if (dflt) {
                            e.sel = false;
                        } else {
                            e.sel = true;
                        }
                    }
                });
            });
        }

        if (tags) {
            tags.split(';').forEach(t => {
                let tagval = t.split(':');

                if (tagval.length > 1 && tagval[1]) {
                    this.getGroupWithShortCode(pc, s, tagval[0], grp => {
                        grp.tagopts && grp.tagopts.forEach(to => {
                            let sel = tagval[1].split(',').filter(e => e.trim() == to.v.trim()).length > 0;
                            to.sel = sel;
                        });
                    });
                }
            });
        }

        // This block of code serves to apply changes based on the selection of a specific option
        // Notably: the applying of a numeric multipler for converting between Meters and Feet
        if (g != '') {

            // Get the value of the current option
            this.getOptionValue2(pc, s, g, (selGrp, selOpt) => {

                // Get the previous option chosen
                let _o = this.getConfigList(s, pc).find(f => f.id == pre);
                let preOpt = _o || { name: '', grouptitle: '', ord: 0 };

                // remove the multiplier if there was one
                preOpt.numoperatorfields && preOpt.numoperatorfields.split(',').forEach(x => {
                    this.getOptionValue(pc, s, x, (g, o) => {
                        this.setOptionValue2(pc, s, g, (parseFloat(o.name) * parseFloat(preOpt.numoperatorvar)).toString());
                    });
                });

                // Apply the multipler of the new option if there is one
                selOpt.numoperatorfields && selOpt.numoperatorfields.split(',').forEach(x => {
                    this.getOptionValue(pc, s, x, (g, o) => {
                        this.setOptionValue2(pc, s, g, (parseFloat(o.name) / parseFloat(selOpt.numoperatorvar)).toString());
                    });
                });

            });
        }

        // assign any hardcoded selection
        // USE SET OPT VAL
        let _grp = '';
        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.name == this.group);
                let _id = (_g || { id: '' }).id;
                if (_id != '') _grp = _id;
            }
        });
        let _o = this.getConfigList(s, pc).find(f => f.name == this.partnum);
        let _opt = (_o || { id: '' }).id;
        if (_grp != '' && _opt != '') {
            //    s.selectiodns[_grp] = _opt;
        }

        let prodcode = '';

        // Get the templates for the partnumber and description
        s.data.forEach(d => {
            if (d.id == pc) {

                // reset invalid message
                d.invalidMsg = "";
                d.invalidAction = "";
                d.invalidActionTxt = "";

                d.partnum = '';
                d.parttemp = '';
                d.ctemplate = '';
                d.partdesc = '';
                d.priceinfo = '';
                d.renderinfo = '';
                d.colstemp = '';

                let priceinfo = [];
                let renderinfo = [];
                let _parttemp = this.parttemp;
                let _partdesc = this.partdesc;
                let _comptemplate = this.comptemplate;
                let _colstemplate = this.colstemp;
                let selected = true;
                let currstep = 0;
                let _num = '';

                // build a variable to pass to the functions
                let x = { _parttemp, _partdesc, _comptemplate, priceinfo, renderinfo, _colstemplate, _num }

                let tempdata = d.configgroup;
                //let tempdata = [...d.configgroup].sort((x, y) => x.procstep > y.procstep ? 1 : -1);
                tempdata.forEach(e => {

                    // This code is similar to that of line 62 of fetchgroup
                    // it tracks the process steps, if the lower process step
                    // is not chosen, the template will not be overwritten by a 
                    // template from a hardcoded option with a higher process step.
                    let dat_procstep = 0;
                    if (e.procstep) { dat_procstep = e.procstep; }
                    let val = s.selections[pc + '_' + e.id]

                    if (selected) {
                        if (dat_procstep > currstep) {
                            currstep = dat_procstep;
                        }
                        if (!val) {
                            selected = false;
                        }
                    }
                    //});

                    //d.configgroup.forEach(e => {
                    // as long as the current process step is valid
                    if (selected) {
                        if (s.selections[pc + '_' + e.id]) {
                            this.getOptionValue2(pc, s, e.id, (g, o) => {
                                if (e.maincomp) { prodcode = o.prodcode; }
                                //console.log(o.name+":"+o.template);
                                this.fillTemplate(pc, s, g, o, e.maincomp, e.ignoretemplate, e.tempcond, x, d);
                            });
                        }
                    }
                });

                if (d.inittemplate) {
                    let inittemplate = d.inittemplate.replaceAll(' ','');
                    let _inittemplate = inittemplate.split(':');
                    if (_inittemplate[0] && _inittemplate.length>2) {
                        this.getOptionValueWithSC(pc, s, _inittemplate[0], (g, o) => {
                            let vals = _inittemplate[2].split(',');
                            if (!o.name || vals.includes(o.name)) {
                                o.template = _inittemplate[1];
                                this.fillTemplate(pc, s, g, o, false, false, '', x, d);
                            }
                        });
                    }
                }

                // Template adjustments, if the teamplate contains <> then there are dependencies
                // for instance if a component templates says {Input<Terminal>} then the 'Input' selector
                // is depended on the 'Terminal' selector being selected

                let X_ctemplate = x._comptemplate;
                let X_colstemplate = x._comptemplate;

                if (!X_ctemplate) X_ctemplate = "";
                if (!X_ctemplate) X_ctemplate = X_ctemplate.replaceAll('/', '').replaceAll('-', '');
                if (!X_ctemplate) X_ctemplate = X_ctemplate.replaceAll('\r', '').replaceAll('\n', '');
                let eles = X_ctemplate.replaceAll('\r', '').replaceAll('\n', '').split('}{');

                eles.forEach(tempele => {
                    tempele = tempele.replaceAll('{', '').replaceAll('}', '');
                    let dependenton = ''
                    if (tempele.includes('<')) {
                        dependenton = tempele.split('<')[1].replaceAll('>', '');
                        let _tempele = tempele.split('<')[0];
                        d.ctemplate = d.ctemplate.replaceAll('{' + tempele + '}', '{' + _tempele + '}');
                        tempele = _tempele;

                        //if (tempele == 'Input') { dependenton = 'Inputa'; }
                        if (dependenton) {
                            this.getOptionValue(pc, s, dependenton, (g, o) => {
                                if (!o.name) {
                                    d.ctemplate = d.ctemplate.replaceAll('{' + tempele + '}', '');
                                }
                            });
                        }
                    }
                });

                d.prodcode = prodcode;

                //console.log('Template:'+x._num);
            }
        });

        //let g_pm1 = {}; let _pm1 = {}; this.getOptionValueWithSC(pc, s, "PM1", (g, o) => { _pm1 = o; g_pm1 = g; });
        //if (_pm1.name)
        //{
        //    s.data.forEach(d => {
        //        if (d.id == pc) {
        //            if (d.ctemplate)
        //                d.ctemplate = d.ctemplate.replaceAll('{Pre Measurement 1}', '{Measurement 1}');
        //        }
        //    });
        //}

        //let g_pm2 = {}; let _pm2 = {}; this.getOptionValueWithSC(pc, s, "PM2", (g, o) => { _pm2 = o; g_pm2 = g; });
        //if (_pm1.name) {
        //    s.data.forEach(d => {
        //        if (d.id == pc) {
        //            if (d.ctemplate)
        //                d.ctemplate = d.ctemplate.replaceAll('{Pre Measurement 2}', '{Measurement 2}');
        //        }
        //    });
        //}

        // Remove groups that have been blocked by the selection of an option
        for (const property in s.selections) {
            let _pc = property.split('_')[0];
            let _id = property.split('_')[1];
            let g_x = {}; let _x = {}; this.getOptionValue2(_pc, s, _id, (g, o) => { _x = o; g_x = g; });

            //let _extemp = _x.extemp || g_x.extemp;
            let _extemp = g_x.extemp;
            if (_extemp) { _extemp = _extemp.trim(); }
            if (_extemp && _x.name) {
                let extemps = _extemp.split('\r\n');
                extemps.forEach(ex => {
                    if (ex.trim()) {
                        let _ex = ex.split(',');
                        s.data.forEach(d => {
                            if (d.id == _pc) {
                                if (_ex[0]) {
                                    let ex0 = _ex[0].trim();
                                    let ex1 = (_ex.length > 1 ? _ex[1] : '').trim();
                                    d.ctemplate = d.ctemplate.replaceAll(ex0, ex1);
                                }
                            }
                        });
                    }
                });
            }


            if (property.split('_')[0] == pc) {
                let group = {};
                let option = {};

                // Get the group
                s.data.forEach(d => {
                    if (d.id == pc) {
                        let _g = d.configgroup.find(f => f.id == property);
                        group = _g || { name: '', type: '1' };
                    }
                });

                // get the option
                let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[property]);
                option = _o || { name: '', grouptitle: '', ord: 0, bl:[] };

                let xyz = option.bl.filter(x => !x.val);

                // An option can have a template exclude string
                if (option.extemp)
                {
                    let extemps = option.extemp.split(',');
                    extemps.forEach(ex => {

                        let _ex = ex.trim();
                        s.data.forEach(d => {
                            if (d.id == pc) {
                                d.partnum = d.parttemp.replaceAll('{' + _ex + '}', '');
                                d.parttemp = d.parttemp.replaceAll('{' + _ex + '}', '');
                                d.partdesc = d.partdesc.replaceAll('{' + _ex + '}', '');
                                if (d.ctemplate)
                                    d.ctemplate = d.ctemplate.replaceAll('{' + _ex + '}', '');
                            }
                        });
                    });
                }

                // Also an option can have a group listed without any options,
                // This is the same as a template exclude.
                if (xyz.length > 0) {
                    let _xyz = xyz[0].config.split('_')
                    if (_xyz[0] == pc) {
                        s.data.forEach(d => {
                            if (d.id == pc) {
                                let _g = d.configgroup.find(f => f.id == _xyz[1]);
                                group = _g;

                                //group = d.configgroup.filter(f => f.id == _xyz[1])[0];
                                d.partnum = d.parttemp.replaceAll('{' + group.name + '}', '');
                                d.parttemp = d.parttemp.replaceAll('{' + group.name + '}', '');
                                d.partdesc = d.partdesc.replaceAll('{' + group.name + '}','');
                                if (d.ctemplate)
                                    d.ctemplate = d.ctemplate.replaceAll('{' + group.name + '}', '');
                            }
                        });
                        let asd = 0;
                    }
                }
            }
        }

        s.data.forEach((d,i) => {
            d.configgroup.forEach(e => {
                // for the block inversion feature, tally a list of allowed
                // for each option based on the current selections
                e.blcount = 0;

                
                for (const property in s.selections) {

                    // for each selected value
                    let p = s.selections[property];

                    // as long as it has a value
                    if (p != '' && p != '?') {

                        // get the full option value
                        this.getOptionValue3(s, property, (a, b) => {
                            let j = 0;

                            // if the option has a block list
                            // and the blocklist of for the current group we are inspecting
                            // increment the block count.
                            if (b.bl && b.bl.filter(_b => _b.config == d.id + '_' + e.id).length > 0) {
                                // DEBUG_POINT - This is a good place to debug block lists for part driven
                                // part creators, for best use use a conditional debugger (I.E. e.name=='Cable')
                                if (b.pcprofile == e.pcprofile) {
                                    //if (a.shortcode != "ZZ") {
                                        e.blcount++;
                                        let i = 0;
                                    //}
                                }
                            }
                        });
                    }
                }
            });
        });

        //s.data.forEach(d => {
        //    d.configgroup.forEach(e => {
        for (const property in s.selections) {
            let p = s.selections[property];
            let arprop = property.split('_');
            let proppc = arprop[0];

            // Make sure the property we are looking up an override for is 
            // of the same part creator that we are currently observing
            // Also make sure the property has a non empty value
            if (p != '' && p != '?' && proppc == pc) {
                this.getOptionValue3(s, property, (a, b) => {
                    

                    this.foreignPropModStr(pc, s, b.foreignpropmod);


                });
            }
        }

        s.data.forEach((_pc, i) => {

            let ans = this.getNested(_pc, 'idat', 'ans');
            if (ans && ans.id && ans.id.length > 0) {
                let ovr = ans.ovr || '';
                this.foreignPropMod(_pc.id, s, ovr);
            }

        });
        //    });
        //});

        // check to see if anything is selected - DEPRECATED
        let anyselected = false;
        for (const property in s.selections) {
            if (s.selections[property]) anyselected = true;
        }

        // Reset the openclose variable
        this.getConfigList(s, pc).forEach(d => {

            d.openclose = !d.inactive ? 0 : -100;
        });

        // reset the variable pricing
        this.getConfigList(s, pc).forEach(d => {
            d.ord = parseFloat(d.varprice);
            if (isNaN(d.ord)) { d.ord = 0; }


        });

        // set images based on selections
        this.getConfigList(s, pc).forEach(d => {
            // Extract the image from the chosen option
            // The image format looks like this:
            // {Short Code}:{Value}:{Image Path};
            // BS:1:/asdf/asdf/ghh.jpg;
            // BS:2:/asdf/asdf/ghh1.jpg;

            d._image = '';
            let _image = '';
            if (d.image) {
                var _img = d.image.split(';');
                _img.forEach((i) => {
                    if (i) {
                        let _i = i.split(':');
                        if (_i.length > 2) {
                            if (!_image) _image = _i[2];
                            this.getOptionValueWithSC(pc, s, _i[0].trim(), (g, o) => {
                                if (o.name == _i[1]) {
                                    d._image = _i[2];
                                }
                            });
                        } else {
                            _image = i;
                        }
                    }
                });
            }
            if (!d._image) {
                d._image = _image;
            }
        });




        // An array of pricing components - DEPRECATED
        let pricing = {};

        let priceblocks = [];
        // loop all the selections and disable other options based on selection
        //s.data.forEach(d => {
        for (const property in s.selections) {
            this.disableSelections(pc, s, property);

            let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[property]);
            let _option = _o || { name: '', grouptitle: '', ord: 0 };
            if (_option.bp)
                priceblocks.push(..._option.bp);
        }
        //});

        let partcreator = { partnum: 'pick a part', parttemp: 'pick a part', partdesc: '', priceinfo: [], renderinfo: [] };
        let outprice = 0;

        // Clean up the part description
        //partcreator.partdesc = partcreator.partdesc.replaceAll('/').replaceAll('-');

        // Reset the disabled state as it will be recalculated below
        s.data.forEach(d => {
            d.disabled = false;
        });

        // Loop again to compile prices descriptions and partnumber
        let iteration = 0;
        
        do {

            let anyzero = false;
            let anyzeroprice = 0;
            for (const property in s.selections) {



                let group = {};
                let option = {};

                s.data.forEach(d => {
                    if (d.id == pc) {
                        partcreator = d;
                        let _g = d.configgroup.find(f => pc + '_' + f.id == property);
                        group = _g || { name: '', type: '1' };
                    }
                });

                // This if statement along with the 'do' above forces any groups with a set script to execute first.
                if ((iteration == 0 && group.setscript) || (iteration == 1 && !group.setscript)) {

                    let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[property]);
                    option = _o || { name: '', grouptitle: '', ord: 0 };

                    if (group.type == '3' || group.type == '4' || group.type == '6' || s.selections[property] == "?") {
                        option = { name: s.selections[property], grouptitle: s.selections[property], ord: 0 };
                    }

                    let mult = 1;
                    // if we are working with numbers
                    if (group.type == '3') {

                        let ops = numops.filter(x => x.fld.includes(group.name));
                        ops.forEach(x => {
                            mult = mult * x.val;
                        });

                        let num = option.name;

                        // check for a qty max
                        if (group.qtymax) {

                            // Get the original qtymax
                            let group_qtymax = parseFloat(group.qtymax / mult).toString();

                            // the qty limit is a refence to another numeric property
                            if (group.qtylimit) {
                                this.getOptionValue(pc, s, group.qtylimit, (g, o) => {
                                    if (parseFloat(o.name) < parseFloat(group_qtymax)) {
                                        group_qtymax = o.name
                                    }
                                });
                            }

                            if (parseFloat(num) > parseFloat(group_qtymax)) {
                                num = group_qtymax;
                            }
                        }

                        // check for a qty min
                        if (group.qtymin) {

                            // Get the original qtymin
                            let group_qtymin = parseFloat(group.qtymin / mult).toString();

                            if (parseFloat(num) < parseFloat(group_qtymin)) {
                                num = group_qtymin;
                            }
                        }

                        // Three properties that allow the adjustment of an incremental value
                        // I.E. increment by .5 up to qty of 10 then increment by 1
                        let group_qtyinc = parseFloat(group.qtyinc);
                        let group_qtyincoth = parseFloat(group.qtyincoth);
                        let group_qtyincpt = parseFloat(group.qtyincpt);


                        //let _u = {}; self.getOptionValueWithSC(pc, s, "U", (g, o) => { _u = o; });
                        let _u = {}; this.getOptionValueWithSC(pc, s, "UN", (g, o) => { _u = o; });
                        if (_u.name == 'M') {
                            group_qtyincoth = group_qtyinc;
                        }


                        if (!isNaN(group_qtyinc)) {
                            group_qtyinc = 1 / group_qtyinc;
                            if (isNaN(group_qtyincpt) || isNaN(group_qtyincoth) || num < group_qtyincpt) {
                                num = (Math.round(parseFloat(num) * group_qtyinc) / group_qtyinc).toString();
                            }
                        }
                        if (!isNaN(group_qtyincpt) && !isNaN(group_qtyincoth)) {
                            if (num >= group_qtyincpt) {
                                group_qtyincoth = 1 / group_qtyincoth;
                                num = (Math.round(parseFloat(num) * group_qtyincoth) / group_qtyincoth).toString();
                            }
                        }

                        // Reasign the number value as it could have been affected by the increment code.
                        option.name = num;
                        this.setOptionValue2(pc, s, group, num);

                    }

                    // Gather up som evariables for the generation of a partnum / price and description.
                    let option_name = option.pnfragment;
                    if (!option_name) option_name = option.name;

                    let option_title = option.altdescription;
                    if (option.altdescription2) option_title += ', ' + option.altdescription2;

                    //if (!option_title) option_title = option.grouptitle;
                    if (!option_title) option_title = option.name;

                    let option_gendescription = option.gendescription;
                    if (option_gendescription) option_title = option_gendescription;

                    let group_name = group.name;
                    let group_grouptitle = group.grouptitle;
                    let option_price = parseFloat(option.alwaysprice);


                    let option_varprice = option.ord;

                    let pov_mult = 1;
                    let option_priceoperatorvar = option.priceoperatorvar;
                    let option_priceoperatormod = option.priceoperatormod;
                    if (option_priceoperatorvar) {

                        // Get the multiplier
                        this.getOptionValueWithSC(pc, s, option_priceoperatorvar, (grp, opt) => {
                            if (!isNaN(opt.name)) {
                                pov_mult = opt.name;
                            }
                        });
                    }
                    if (option_priceoperatormod) {

                        // Get and apply the price modifiers
                        let mods = option_priceoperatormod.split(';');
                        mods.forEach(x => {
                            let mod = x.split(':');
                            if (mod.length > 3) {
                                this.getOptionValueWithSC(pc, s, mod[0], (grp, opt) => {
                                    let modops = mod[1].split(',');
                                    if (modops.includes(opt.name)) {
                                        option_price += parseFloat(mod[3]);
                                    }
                                });
                            }
                        });

                    }

                    option_varprice = priceblocks.filter(pb => pb.config == option.configgroup && !pb.val ||
                        pb.config == option.configgroup && pb.val == option.id).length > 0 ?
                        0 : option_varprice;

                    let _price = 0;//this.partprice;

                    // Add the constant price
                    //_price += ;

                    let __price = option_price + option_varprice;

                    // Add the optional price
                    _price += __price * pov_mult;

                    // Check to see if the qty field has a multiplier
                    let ops = numops.filter(x => x.fld.includes(group.qtyfld));
                    ops.forEach(x => {
                        mult = mult * x.val;
                    });

                    // An array of pricing components - DEPRECATED
                    pricing[property] = _price;

                    // calculate the qty
                    let qty = 1;
                    if (group.qtyfld) {
                        this.getOptionValue(pc, s, group.qtyfld, (g, o) => {
                            qty = parseFloat(o.name) * mult;
                        });
                    }

                    // calculate the min price qty
                    let _qtyfldmin = parseFloat(group.qtyfldmin);
                    if (group.qtyfldmin && qty < _qtyfldmin) {
                        qty = _qtyfldmin;
                    }

                    // Get the free qty variable
                    let freeqty = 0;
                    if (group.qtyminprice) {
                        freeqty = parseFloat(group.qtyminprice);
                        freeqty = isNaN(freeqty) ? 0 : freeqty;
                    }

                    // if the qty is less than the free qty the, free qty is the qty
                    let adjustqty = (freeqty > qty) ? qty : freeqty;
                    // calc the actual qty to use in pricing
                    adjustqty = qty - adjustqty;

                    // cal the price
                    let tot_price = isNaN(_price) ? 0 : _price * adjustqty;

                    if (isNaN(tot_price)) tot_price = 0;

                    if (group.pcprofile == pc) {
                        // Add to the price info array

                        let zero_price = option.zero_price;
                        if (zero_price) {
                            anyzero = true;
                        }
                        if (zero_price) anyzeroprice += tot_price;

                        let form_price = option.formulaprice;
                        if (!form_price) form_price = 0;

                        let gendescription = option.gendescription
                        if (!gendescription) gendescription = '';

                        let mesdescription = option.mesdescription
                        if (mesdescription) gendescription = mesdescription;

                        if (partcreator.priceinfo) {
                            partcreator.priceinfo.push({
                                property: group.name, option: option.name, qty: adjustqty, price: _price,
                                tot_price: tot_price, shortcode: group.shortcode, procstep: group.procstep,
                                id: option.id, gid: group.id, bl: option.blockoptions,
                            });
                        }

                        if (partcreator.renderinfo) {
                            let z = 0;
                            z++;
                            partcreator.renderinfo.push({
                                property: group.name, option: option.name, qty: adjustqty, price: _price,
                                tot_price: tot_price, shortcode: group.shortcode, image: option.renimage,
                                layers: option.renlayeract, renimage: option.renimage, partimage: option._image,
                                description: gendescription, diameter: option.diameter
                            });
                        }

                        // Pad this chunk of the partnumber
                        if (group.chars && group.padwith) {
                            let _group_chars = parseInt(group.chars);
                            if (!isNaN(_group_chars)) {
                                option_name = option_name.padStart(_group_chars, group.padwith);
                            }
                        }

                        //if (group.name == "Grey Cordgrips" || group.name == "Black Cordgrips" || group.name == "Stainless Cordgrips")
                        //{
                        //    let val = parseInt(option.name);
                        //    val = option.name == 'A' ? 10 : val;
                        //    val = option.name == 'B' ? 11 : val;
                        //    val = option.name == 'C' ? 12 : val;

                        //    getGroupID(pc, s, 'Black Cordgrips', x => {

                        //    });

                        //    getGroupID(pc, s, 'Stainless Cordgrips', x => {

                        //    });
                        //}


                        // run any special calculations (less armor discount, formatting of the partnum output, etc.)
                        if (group.setscript) {
                            let self = this;

                            let ssi = {
                                option_name,
                                option_title,
                                mult,
                                freeqty,
                                adjustqty,
                                tot_price,
                                form_price,
                                repeat: false
                            };

                            if (group.setscript.length < 25) {
                                if (setScript(group.setscript, this, pc, s, ssi)) {
                                    option_name = ssi.option_name;
                                    option_title = ssi.option_title;
                                    mult = ssi.mult;
                                    freeqty = ssi.freeqty;
                                    adjustqty = ssi.adjustqty;
                                    tot_price = ssi.tot_price;
                                    form_price = ssi.form_price;
                                    //if (ssi.repeat) repeat.push(property);
                                }
                            } else {
                                eval(group.setscript);
                            }



                            //let obj = {
                            //    pc,
                            //    newdata: this.newdata,
                            //    option_name,
                            //    option_title,
                            //    tot_price,
                            //}

                            //import("./utility").then(math => {
                            //    //console.log(math[group.setscript](this, obj));
                            //    math['test'].call(this);
                            //});
                        }

                        

                        group.warningMsg = "";
                        let altcomp = option.altcomponent;//group.configs.fil_ter(x => x.name == option.altcomponent)[0];
                        let alttext = option.altredirect;// group.configs.fil_ter(x => x.name == option.altredirect)[0];

                        if (altcomp || alttext) {
                            //// check if the alternate componet has a blocking condition
                            //let oc = altcomp.openclose;
                            //if (oc < 50) { oc += 100; }
                            let block = false;//altcomp.blInverted ? oc < group.blcount : oc;
                            if (!alttext) {
                                group.warningMsg = group.name +
                                    " - There is a material shortage, which is causing extended lead times. " +
                                    "Please consider our recomended alternative " + option.altcomponent + ".";

                                if (group.maincomp && !group.clearlist) {
                                    group.clearlist = "RESET";
                                    group.invalidActionTxt = "";
                                    group.invalidAction = "";
                                    group.invalidArg1 = "";
                                    group.invalidArg2 = "";
                                    group.invalidArg3 = "";
                                }
                                if (group.clearlist != "RESET") {
                                    group.invalidActionTxt = "Switch";
                                    group.invalidAction = "CHOOSEALT";
                                    group.invalidArg1 = option.name;
                                    group.invalidArg2 = altcomp;
                                    group.invalidArg3 = group.shortcode;
                                }
                            }
                            else {
                                group.warningMsg = "There is a material shortage, which is causing extended lead times. " +
                                    alttext;
                                group.invalidActionTxt = "";
                                group.invalidAction = "";
                                group.invalidArg1 = "";
                                group.invalidArg2 = "";
                                group.invalidArg3 = "";
                            }
                        }




                        //partcreator.image = '';
                        if (group.imagecomp) {
                            partcreator.image = option._image;
                        }

                        // Compile the part number and description
                        // ? means the value value is optional, so if the value is ? just blank it out
                        if (option_title != "?") {
                            if (option_name) {
                                if (!partcreator.partnum) partcreator.partnum = '';
                                //partcreator.partnum = partcreator.partnum.replaceAll('{' + group.name + '}', option_name);
                                partcreator.partnum = this.myFunction(partcreator.partnum, group.name, option_name);
                            }

                            if (option_title) {
                                if (!partcreator.partdesc) partcreator.partdesc = '';

                                let tit = option_title.split('_')[0];
                                tit = this.trim(tit, ';');
                                tit = tit.trim();

                                let group_title = group.name;
                                if (group.maincomp && !group.desctitle) group_title = "NONAME";
                                if (group.desctitle) group_title = group.desctitle;

                                let removeSemi = group_title.includes("-;");
                                let removeColon = group_title.includes("-:");
                                group_title = group_title.replaceAll("-:", "").replaceAll("-;", "");

                                let _desc = '';

                                if (group_title == "HIDE") {
                                    _desc = "";
                                } else if (group_title == "NONAME") {
                                    _desc = tit + (removeSemi ? " " : "; ");
                                } else {
                                    _desc = group_title + (removeColon ? " " : ": ") + tit + (removeSemi ? " " : "; ");
                                }

                                //partcreator.partdesc = partcreator.partdesc.replaceAll('{' + group.name + '}', _desc);
                                partcreator.partdesc = this.myFunction(partcreator.partdesc, group.name, _desc);
                            }
                        } else {
                            //partcreator.partnum = partcreator.partnum.replaceAll('{' + group.name + '}', '');
                            //partcreator.partdesc = partcreator.partdesc.replaceAll('{' + group.name + '}', '');
                            partcreator.partnum = this.myFunction(partcreator.partnum, group.name, '');
                            partcreator.partdesc = this.myFunction(partcreator.partdesc, group.name, '');
                        }

                        // Repace special characters in the partnum and trim any / and -
                        partcreator.partnum = partcreator.partnum.replaceAll('_', '');
                        partcreator.partnum = partcreator.partnum.replaceAll('@', '');
                        partcreator.partnum = partcreator.partnum.replaceAll('#', '');
                        partcreator.partnum = partcreator.partnum.replaceAll('$', '');
                        partcreator.partnum = partcreator.partnum.replace(/(<([^>]+)>)/gi, "");



                        partcreator.partnum = partcreator.partnum.replaceAll('--', '-');
                        partcreator.partnum = partcreator.partnum.replaceAll('--', '-');
                        partcreator.partnum = partcreator.partnum.replaceAll('//', '/');
                        partcreator.partnum = partcreator.partnum.replaceAll('//', '/');
                        partcreator.partnum = partcreator.partnum.replaceAll('/-', '-');
                        partcreator.partnum = partcreator.partnum.replaceAll('-/', '/');
                        partcreator.partnum = partcreator.partnum.replaceAll('\r', '');
                        partcreator.partnum = partcreator.partnum.replaceAll('\n', '');
                        //partcreator.partnum = partcreator.partnum.replaceAll(' ', '');
                        partcreator.partnum = this.trim(partcreator.partnum, ' ');
                        partcreator.partnum = this.trim(partcreator.partnum, '/');
                        partcreator.partnum = this.trim(partcreator.partnum, '-');
                        partcreator.partnum = this.trim(partcreator.partnum, '/');
                        partcreator.partnum = this.trim(partcreator.partnum, '-');

                        // Trim any / and - in the description
                        partcreator.partdesc = partcreator.partdesc.replaceAll('\r', '');
                        partcreator.partdesc = partcreator.partdesc.replaceAll('\n', '');
                        partcreator.partdesc = this.trim(partcreator.partdesc, ' ');
                        partcreator.partdesc = this.trim(partcreator.partdesc, '/');
                        partcreator.partdesc = this.trim(partcreator.partdesc, '-');
                        partcreator.partdesc = this.trim(partcreator.partdesc, '/');
                        partcreator.partdesc = this.trim(partcreator.partdesc, '-');

                        let _disabled = option.blInverted ? option.openclose < group.blcount : option.openclose;
                        partcreator.disabled = partcreator.disabled || _disabled ? true : false
                        partcreator.invalid = partcreator.partnum.includes("}") || partcreator.partdesc.includes("}");

                        outprice += tot_price;
                    }
                }
            }


            partcreator.anyzero = anyzero;
            if (anyzero) outprice = anyzeroprice;

            iteration++;
        } while (iteration<2);

        // Evaluate the calculated fields
        s.data.forEach(d => {

            // Evaluate calc fields
            d.configgroup.forEach(x => {
                let i = x;

                // if the field/group is of type calc
                if (x.type == '6') {
                    // first get the default value
                    let x_val = calcSC(x.setscript, this, x, d, s);
                    this.setSelections(s, x.pcprofile, x.id, x_val);
                }
            });
        });

        // Setscript has been reused
        //partcreator.partnum = partcreator && partcreator.parttemp;
        //if (this.newdata.setscript) { eval(this.newdata.setscript); }

        partcreator.priceinfo2 = [];

        let fp = -1;
        let pf = partcreator.priceformula;
        let vars = '';

        if (pf) {
            var splitted = pf.split("\n");
            pf = "";
            splitted.forEach(x => {
                if (!x.trim().startsWith("//")) { pf += x; }
                if (x.trim().startsWith("//VARS:")) { vars += x.trim().split(':')[1]+','; }
            });

            // scope can contain both variables and functions
            const scope = {};

            if (vars.trim()) {
                vars.split(',').forEach(x => {
                    if (x.trim()) {
                        scope[x.trim()] = '';
                    }
                });
            }

            partcreator.priceinfo.forEach(x => {
                scope[x.shortcode] = x.option;
                scope[x.shortcode+'_P'] = parseFloat(x.price) || 0;
            });



            scope.log = function (v) {
                console.log(v);
                return 0;
            }
            scope.equals = function (a,b,_t,_f) {
                return a==b ? _t : _f;
            }
            scope.includes = function (a, b, _t, _f) {
                return a._data.includes(b) ? _t : _f;
            }

            var splitted = pf.split(";");
            splitted.forEach(x => {
                if (x) {
                    try {
                        fp = M.evaluate(x, scope);
                        let y = 0;
                    } catch (e) {
                        if (!partcreator.invalid) {
                            fp = 1000000;
                            console.log(e.message);
                            //throw e;
                        }
                    }
                }
            });//this.evaluate(pf);


            if (scope._a) { partcreator.priceinfo2.push({ price: scope._a, note: scope._a_note }); }
            if (scope._b) { partcreator.priceinfo2.push({ price: scope._b, note: scope._b_note }); }
            if (scope._c) { partcreator.priceinfo2.push({ price: scope._c, note: scope._c_note }); }
            if (scope._d) { partcreator.priceinfo2.push({ price: scope._d, note: scope._d_note }); }
            if (scope._e) { partcreator.priceinfo2.push({ price: scope._e, note: scope._e_note }); }
            if (scope._f) { partcreator.priceinfo2.push({ price: scope._f, note: scope._f_note }); }
            if (scope._g) { partcreator.priceinfo2.push({ price: scope._g, note: scope._g_note }); }
            if (scope._h) { partcreator.priceinfo2.push({ price: scope._h, note: scope._h_note }); }
            if (scope._i) { partcreator.priceinfo2.push({ price: scope._i, note: scope._i_note }); }
            if (scope._j) { partcreator.priceinfo2.push({ price: scope._j, note: scope._j_note }); }
            if (scope._k) { partcreator.priceinfo2.push({ price: scope._k, note: scope._k_note }); }
            if (scope._l) { partcreator.priceinfo2.push({ price: scope._l, note: scope._l_note }); }
            if (scope._m) { partcreator.priceinfo2.push({ price: scope._m, note: scope._m_note }); }
            if (scope._n) { partcreator.priceinfo2.push({ price: scope._n, note: scope._n_note }); }
            if (scope._o) { partcreator.priceinfo2.push({ price: scope._o, note: scope._o_note }); }
            if (scope._p) { partcreator.priceinfo2.push({ price: scope._p, note: scope._p_note }); }
            if (scope._q) { partcreator.priceinfo2.push({ price: scope._q, note: scope._q_note }); }
            if (scope._r) { partcreator.priceinfo2.push({ price: scope._r, note: scope._r_note }); }
            if (scope._s) { partcreator.priceinfo2.push({ price: scope._s, note: scope._s_note }); }


            let y = 0;
            //partcreator.priceinfo.push({
            //    property: group.name, option: option.name, qty: adjustqty, price: _price,
            //    tot_price: tot_price, shortcode: group.shortcode
            //});
            //}
        }

        outprice = (fp == -1) ? outprice : fp;

        // Calculate the discounts
        let __price = outprice;

        // get the price list discount
        this.calcDiscounts(partcreator, outprice);

        // Return the data
        return {
            data: this.newdata, selections: s.selections,
        }
    }

    /**
     * 
     * @param {any} pc
     * @param {any} s
     * @param {any} b_foreignpropmod
     */
    foreignPropModStr(pc, s, b_foreignpropmod) {
        let _j = false;
        if (b_foreignpropmod && b_foreignpropmod.trim()) {
            try { _j = JSON.parse(b_foreignpropmod); } catch { }

            try { _j = JSON.parse(b_foreignpropmod); } catch { }

            if (!_j || !Array.isArray(_j)) {
                try { _j = JSON.parse("[" + b_foreignpropmod + "]"); } catch { }
            }

            // if there are modifiers, iterate through them
            if (_j) {
                this.foreignPropMod(pc, s, _j);
            }
        }
    }

    /**
     * 
     * @param {any} pc
     * @param {any} s
     * @param {any} json
     */
    foreignPropMod(pc, s, json) {
        if (json) {
            json.forEach(j => {
                let sc = j.group;

                // get matching groups and configs for each property modifier
                this.getOptionValueWithSC(pc, s, sc, (grp, opt) => {
                    this.foreignPropModWGrp(j, grp)
                });
            });
        }
    }

    /**
     * 
     * @param {any} j
     * @param {any} grp
     */
    foreignPropModWGrp(j, grp) {
        if (j.configs) {
            j.configs.forEach(_c => {
                //let _o = grp.configs.filter(c => c.name == _c.name)[0];
                let _o = grp.configs.find(c => c.name == _c.name);
                if (!_o) {
                    _o = { name: _c.name };
                    try {
                        //grp.configs.push(_o);
                    } catch (e)
                    {
                        let asdf = 0;
                    }
                }
                _c.props.forEach(_p => {
                    for (const prop in _p) {
                        // overwrite the config property
                        if (_o)
                        {
                            _o[prop] = _p[prop];
                        }
                    }
                });
                if (!_o) {
                //    grp.configs.push(_c);
                }
            });
        }
        for (const prop in j) {
            if (prop != "configs" && prop != "group") {
                // overwrite the group property
                grp[prop] = j[prop];
            }
        }
    }

    /**
     * 
     * @param {any} pc
     * @param {any} s
     * @param {any} g
     * @param {any} o
     * @param {any} e_maincomp
     * @param {any} e_ignoretemplate
     * @param {any} x
     * @param {any} d
     */
    fillTemplate(pc, s, g, o, e_maincomp, e_ignoretemplate, e_tempcond, x, d) {

        // There is a field that will validate a template under a certian condition
        // if this field is blank, the template will always be valid if it is provided
        let tempcond = true;
        if (o.tempcond)
        {
            let o_tc = o.tempcond.split(':');
            let o_tcfield = o_tc[0];
            let o_tcvalue = o_tc.length > 1 ? o_tc[1] : '';

            this.getOptionValueWithSC(pc, s, o_tcfield, (g, o) => {
                if (o_tcvalue != o.name) {
                    tempcond = false;
                }
            });
        }

        // if the option is of the main component, or it is another component with the template field filled in
        // and not ignored and not invalidated by a condition -- set the template
        if (e_maincomp || (o.template && !e_ignoretemplate && tempcond)) {
            // Decide which part template to use
            // based on the selected part template property
            if (!o.template || o.template == '0') {
                x._parttemp = d.pntemplate;
                x._partdesc = d.desctemplate;
                x._comptemplate = d.comptemplate;
                x._colstemplate = d.colstemplate;
                x._num = '0';
            } else if (o.template == '1') {
                x._parttemp = d.pntemplate2;
                x._partdesc = d.desctemplate2;
                x._comptemplate = d.comptemplate2;
                x._colstemplate = d.colstemplate2;
                x._num = '1';
            } else if (o.template == '2') {
                x._parttemp = d.pntemplate3;
                x._partdesc = d.desctemplate3;
                x._comptemplate = d.comptemplate3;
                x._colstemplate = d.colstemplate3;
                x._num = '2';
            } else if (o.template == '3') {
                x._parttemp = d.pntemplate4;
                x._partdesc = d.desctemplate4;
                x._comptemplate = d.comptemplate4;
                x._colstemplate = d.colstemplate4;
                x._num = '3';
            } else if (o.template == '4') {
                x._parttemp = d.pntemplate5;
                x._partdesc = d.desctemplate5;
                x._comptemplate = d.comptemplate5;
                x._colstemplate = d.colstemplate5;
                x._num = '4';
            } else if (o.template == '5') {
                x._parttemp = d.pntemplate6;
                x._partdesc = d.desctemplate6;
                x._comptemplate = d.comptemplate6;
                x._colstemplate = d.colstemplate6;
                x._num = '5';
            } else if (o.template == '6') {
                x._parttemp = d.pntemplate7;
                x._partdesc = d.desctemplate7;
                x._comptemplate = d.comptemplate7;
                x._colstemplate = d.colstemplate7;
                x._num = '6';
            } else if (o.template == '7') {
                x._parttemp = d.pntemplate8;
                x._partdesc = d.desctemplate8;
                x._comptemplate = d.comptemplate8;
                x._colstemplate = d.colstemplate8;
                x._num = '7';
            } else if (o.template == '8') {
                x._parttemp = d.pntemplate9;
                x._partdesc = d.desctemplate9;
                x._comptemplate = d.comptemplate9;
                x._colstemplate = d.colstemplate9;
                x._num = '8';
            } else if (o.template == '9') {
                x._parttemp = d.pntemplate10;
                x._partdesc = d.desctemplate10;
                x._comptemplate = d.comptemplate10;
                x._colstemplate = d.colstemplate10;
                x._num = '9';
            } else if (o.template == '10') {
                x._parttemp = "{" + d.name + "}";
                x._partdesc = "{" + d.name + "}";
                x._comptemplate = "{" + d.name + "}";
                x._colstemplate = "";
                x._num = '10';
            }


            else if (o.template == '11') {
                x._parttemp = d.pntemplate12;
                x._partdesc = d.desctemplate12;
                x._comptemplate = d.comptemplate12;
                x._colstemplate = d.colstemplate12;
                x._num = '9';
            } else if (o.template == '12') {
                x._parttemp = d.pntemplate13;
                x._partdesc = d.desctemplate13;
                x._comptemplate = d.comptemplate13;
                x._colstemplate = d.colstemplate13;
                x._num = '9';
            } else if (o.template == '13') {
                x._parttemp = d.pntemplate14;
                x._partdesc = d.desctemplate14;
                x._comptemplate = d.comptemplate14;
                x._colstemplate = d.colstemplate14;
                x._num = '9';
            } else if (o.template == '14') {
                x._parttemp = d.pntemplate15;
                x._partdesc = d.desctemplate15;
                x._comptemplate = d.comptemplate15;
                x._colstemplate = d.colstemplate15;
                x._num = '9';
            } else if (o.template == '15') {
                x._parttemp = d.pntemplate16;
                x._partdesc = d.desctemplate16;
                x._comptemplate = d.comptemplate16;
                x._colstemplate = d.colstemplate16;
                x._num = '9';
            } else if (o.template == '16') {
                x._parttemp = d.pntemplate17;
                x._partdesc = d.desctemplate17;
                x._comptemplate = d.comptemplate17;
                x._colstemplate = d.colstemplate17;
                x._num = '9';
            } else if (o.template == '17') {
                x._parttemp = d.pntemplate18;
                x._partdesc = d.desctemplate18;
                x._comptemplate = d.comptemplate18;
                x._colstemplate = d.colstemplate18;
                x._num = '9';
            } else if (o.template == '18') {
                x._parttemp = d.pntemplate19;
                x._partdesc = d.desctemplate19;
                x._comptemplate = d.comptemplate19;
                x._colstemplate = d.colstemplate19;
                x._num = '9';
            } else if (o.template == '19') {
                x._parttemp = d.pntemplate20;
                x._partdesc = d.desctemplate20;
                x._comptemplate = d.comptemplate20;
                x._colstemplate = d.colstemplate20;
                x._num = '9';
            }


            // Fill some defaults if no value was fround
            if (!x._parttemp) x._parttemp = "";
            if (!x._partdesc) x._partdesc = x._parttemp.replaceAll('/', '').replaceAll('-', '');
            if (!x._partdesc) x._partdesc = x._partdesc.replaceAll('\r', '').replaceAll('\n', '');

            // Fill some defaults if no value was fround
            if (!x._parttemp) x._parttemp = "";
            if (!x._partdesc) x._partdesc = x._parttemp.replaceAll('/', '').replaceAll('-', '');
            if (!x._partdesc) x._partdesc = x._partdesc.replaceAll('\r', '').replaceAll('\n', '');

            let eles = x._partdesc.replaceAll('\r', '').replaceAll('\n', '').split('}{')

            let dependenton = '';
            if (dependenton)
            {
                dependenton = '';
            }

            // a collection of property overrides can be provided with
            // the data that is returne from the server, it property 
            // overrides are found, they are applied here, I.E. max armor
            // override for cable
            o.propertyoverrides &&
                o.propertyoverrides.split('^^^').forEach((si, i) => {
                    let ar = si.split('~~~');
                    if (ar[0]) {
                        this.setGroupProp(pc, s, ar[0], ar[1], ar[2]);
                    }
                });

            // assign the part, description and price info
            d.partnum = x._parttemp;
            d.parttemp = x._parttemp;
            d.ctemplate = x._comptemplate;
            d.partdesc = x._partdesc;
            d.priceinfo = x.priceinfo;
            d.renderinfo = x.renderinfo;
            d.colstemp = x._colstemplate;
        }
    }

    /**
     * As the known PN is typed in this field sets the state variable
     * @param {any} dat
     * @param {any} val
     */
    async setKnow2(val) {
        let v = '';
        await this.setState((s, p) => {
            v = s.know;
            this.kpn = v;
            return { know: val };
        });
        return v;
    }

    /**
     * Handles the submit button after you have typed a part number
     * @param {any} dat
     */
    async handelKnowPN2() {
        let v = await this.setKnow2('');
        let noprofile = await parsePN({}, v, this);

        let rtn = await this.fixPrice(this.state, this.params)
        rtn.noprofile = noprofile;

        this.setState(rtn);
    }

    /** */
    addCart() {
        let _parts = [];

        this.state.data.forEach((x,i) => {
            if (!x.partnum.includes("{") && (this.getStyle(0) || x.sysadded || i==0)) {
                addToCart(x.partnum, x.qty, x.id, x.parent, _parts);
            }
        });

        let parts = _parts.join(',');
        this.sendMessage('O;' + parts);
        this.setState({ waiting: 'Adding Parts to Order' });
    }

    /** */
    addQuote() {
        let _parts = [];
        this.state.data.forEach((x, i) => {
            if (!x.partnum.includes("{") && (this.getStyle(0) || x.sysadded || i == 0)) {
                let p = x.partnum + ":" + x.qty + ":" + x.id + ":" + x.parent;
                _parts.push(p);
            }
        });

        let parts = _parts.join(',');
        this.sendMessage('Q;' + parts);
        this.setState({ waiting: 'Adding Parts to Quote' });
    }

    compileRequestedParts()
    {
        let _parts = [];
        this.state.data.forEach((x, i) => {
            if (!x.partnum.includes("{") && (this.getStyle(0) || x.sysadded || i == 0)) {
                let p = { partnum: x.partnum, description: x.partdesc, qty: x.qty, id: x.id, parent: x.parent };
                _parts.push(p);
            }
        });

        return JSON.stringify(_parts);
    }

    /**
     * 
     * @param {any} f
     * @param {any} v
     */
    setField(f, v) {
        let email = this.state.email;
        email[f] = v;
        this.setState({ email });
    }

    /** */
    setupEmail() {
        this.setField('state', 'email');
    }

    /** */
    async sentEmail() {
        let parts = this.state.data.map((x) => x.partnum + ":" + x.qty + "").join(',');

        let dat = await this.postData('PCProfileImpl/partcreator/sendemail/' + this.props.data,
            {
                parts: parts,
                name: this.state.email.name,
                phone: this.state.email.phone,
                email: this.state.email.email
            });

        if (!dat || dat.error) {
            this.setField('state', 'error');
        } else {
            this.setField('state', 'sent');
        }

        //this.sendMessage('E;' + parts);
    }

    /** */
    startEmail() {
        let parts = this.state.data.map((x) => x.partnum + ":" + x.qty + "").join(',');
        this.setState({ email: { state: 'email', name: '', phone: '', email: '' } });
    }

    /** */
    sendEmail() {
        let parts = this.state.data.map((x) => x.partnum + ":" + x.qty + "").join(',');
        this.sendMessage('E;' + parts);
        this.setState({ waiting: 'Sending Request' });
    }

    /**
     * 
     * @param {any} url
     * @param {any} data
     * @param {any} cache
     */
    async postData(url, data, cache) {
        let obj = JSON.stringify(data);
        let hash = this.hashCode(obj);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: obj
        };

        var subdata = '';
        if (cache && !this.props.nocache) {
            subdata = sessGetObj(url + "/" + hash);
        }

        let _data = {};
        if (subdata) {
            _data = subdata;
        } else {
            // run the filtered reques
            let response = await fetch(this.SERVER_URL + url, requestOptions)
                .then((x) => {
                    _data = x.json();
                })
                .catch((x) => {
                    _data = false;
                });

            if (cache) {
                try {
                    sessSetObj(url + "/" + hash, _data);
                }
                catch (e) {
                }
            }
        }

        return _data;
    }

    /** */
    sendMessage(msg) {
        if (window.parent.postMessage) {
            window.parent.postMessage(msg, '*');
        }
        if (window.getMessage) {
            window.getMessage(msg);
        }
    }

    /**
     * Handles when the user chooses a profile from the profile screen
     * @param {any} id
     */
    async setProfiles(id, idat, newpc, parent, maxqty, e, binding, tags, iter, unseltitle, inittemplate) {
        let _1st = '';
        for (let i = 0; i < iter; i++)
        {
            let __1st = await this.setProfile(id, idat, newpc, parent, maxqty, e, binding, tags, unseltitle, inittemplate)
            if (!_1st) _1st = __1st;
        }

        // Set the selected index to 1st
        if (_1st) {
            let selectedObj = this.state.selectedObj;
            selectedObj[idat.id] = _1st;
            this.setState({ selectedObj });
        }
    }

    /**
     * Handles when the user chooses a profile from the profile screen
     * @param {any} id
     */
    async setProfile(id, idat, newpc, parent, maxqty, e, binding, tags, unseltitle, inittemplate) {

        let rtn = '';

        // When the max qty is -1, this indicates that the customer does not 
        // want the suggestion / recommendation
        if (parent && maxqty == -1) {
            this.setState((s, p) => {
                s.data.filter(dat => dat.id == parent).forEach(dat => {
                    let _i = includesFilter(s, dat).find(dat => dat.id == idat.id);
                    _i.declined = true;
                });
                return s;
            });
        }

        // When the max qty is 0, this indicates that the customer had undone not
        // wanting the suggestion / recommendation
        else if (parent && maxqty == 0) {
            this.setState((s, p) => {
                s.data.filter(dat => dat.id == parent).forEach(dat => {
                    let _i = includesFilter(s,dat).find(dat => dat.id == idat.id);
                    _i.declined = false;
                });
                return s;
            });

        // Else create a new instance of the part creator
        } else {
            // we create a new id so we can have multiple copies of the same PC.
            if (newpc) {
                let newid = this.uuidv4();

                let selectedObj = this.state.selectedObj;
                selectedObj[idat.id] = newid;
                this.setState({ selectedObj });

                rtn = newid;
                if (!idat.id) this.setState({ selected: newid });
                
                await this.populateData2(id, newid, idat, parent, maxqty, binding, tags, unseltitle, inittemplate, 0);


            // The last scenario is the user selecting a specific PC for focus.
            } else {
                let selectedObj = this.state.selectedObj;
                selectedObj[idat.id] = id;
                this.setState({ selectedObj });

                rtn = id;
            }

            if (!idat.id) this.setState({ selected: rtn });
        }
        if (e) e.preventDefault();

        return rtn;
    }

    /**
     * Answer the leadin questions for the includes tab
     * @param {any} questionid
     * @param {any} parent
     * @param {any} answer
     */
    async answerLeadInQuestions(questionid, parent, answer) {

        let rtn = '';

        this.setState((s, p) => {
            s.data.filter(dat => dat.id == parent).forEach(dat => {
                if (!dat.leadInQuestions) dat.leadInQuestions = {};
                dat.leadInQuestions[questionid] = answer;
                //dat.includes.filter(dat => dat.id == idat.id)[0].declined = true;
            });


            if (answer != '') {
                s.activeStep = s.activeStep + (this.getStyle(0)?1:2);
            }
            if (answer != '' && answer != '-1') {
                s.loadingi = true;
            }

            return s;
        });

        setTimeout(async () => {
            if (answer != '' && answer != '-1') {
                await this.includesRunner(false);
            }

            this.setState({ loadingi: false });
        }, 100);


    }

    /**
     * 
     * @param {any} input
     * @param {any} pattern
     * @param {any} replace
     */
    replaceCodes(input, pattern, replace)
    {
        input = input.replaceAll('{' + pattern + '}', replace);
        
        return input;
    }

    /**
     * 
     * @param {any} str
     * @param {any} v
     * @param {any} r
     */
    myFunction(str, v, r) {

        str = str.replaceAll('{' + v + '}', r);

        //var patt1 = /{([^}]*)two}/g;
        var patt1 = new RegExp("{\\[\(\[\^}\]\*\)\\]" + this.escapeRegExp(v) + "}", "g");
        var patt2 = new RegExp("{\\[\(\[\^}\]\*\)\\]" + this.escapeRegExp(v) + "}");

        var result1 = str.matchAll(patt1);
        let y = result1.next();
        while (!y.done) {
            let _r = '';
            if (y.value[1].length > r.length) {
                _r = y.value[1];
                let _ar = _r.split('');
                let z = y.value[1].length - r.length
                r.split('').forEach(x => {
                    _ar[z] = x;
                    z++;
                })
                _r = _ar.join('');
            } else {
                _r = r;
            }

            str = str.replace(patt2, _r);
            y = result1.next();
        }

        return str;
    }

    /**
     * 
     * @param {any} string
     */
    escapeRegExp(string) {
        let rtn = '';
        rtn = string ? string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
        return rtn; // $& means the whole matched string
    }

    //https://stackoverflow.com/questions/11422513/evaluate-an-equation-in-javascript-without-eval
    /**
     * Evaluates a numerical expression as a string and returns a Number
     * Follows standard PEMDAS operation ordering
     * @param {String} expr Numerical expression input
     * @returns {Number} Result of expression
     */
    evaluate(expr) {
        let self = this;
        if (isNaN(Number(expr))) {
            if (this.parens.test(expr)) {
                let newExpr = expr.replace(this.parens, function (match, subExpr) {
                    return self.evaluate(subExpr);
                });
                return self.evaluate(newExpr);
            }
            else if (this.exp.test(expr)) {
                let newExpr = expr.replace(this.exp, function (match, base, pow) {
                    return Math.pow(Number(base), Number(pow));
                });
                return self.evaluate(newExpr);
            }
            else if (this.mul.test(expr)) {
                let newExpr = expr.replace(this.mul, function (match, a, b) {
                    return Number(a) * Number(b);
                });
                return self.evaluate(newExpr);
            }
            else if (this.div.test(expr)) {
                let newExpr = expr.replace(this.div, function (match, a, b) {
                    if (b != 0)
                        return Number(a) / Number(b);
                    else
                        throw new Error('Division by zero');
                });
                return self.evaluate(newExpr);
            }
            else if (this.add.test(expr)) {
                let newExpr = expr.replace(this.add, function (match, a, b) {
                    return Number(a) + Number(b);
                });
                return self.evaluate(newExpr);
            }
            else if (this.sub.test(expr)) {
                let newExpr = expr.replace(this.sub, function (match, a, b) {
                    return Number(a) - Number(b);
                });
                return self.evaluate(newExpr);
            }
            else {
                return expr;
            }
        }
        return Number(expr);
    }

    /**
     * 
     * @param {any} pn
     * @param {any} pg
     * @param {any} qty
     * @param {any} pl
     */
    calcPLDisc(pn, pg, qty, pl)
    {
        let rtn = null;

        pl.filter(x => x[0] == pn).forEach(x => {
            if (qty >= parseInt(x[1]))
            {
                rtn = [parseFloat(x[2]), parseFloat(x[3])];
            }
        });
        if (rtn) { return rtn; }

        pl.filter(x => x[0] == pg).forEach(x => {
            if (qty >= parseInt(x[1])) {
                rtn = [parseFloat(x[2]), parseFloat(x[3])];
            }
        });

        return rtn;
    }

    /** */
    async componentWillUpdate() {

    }

    /**
     * Deletes a part from the part creator cart
     * @param {any} id
     */
    async delPart(id) {
        
        let s = this.state;
        let p = this.params;
        let pc = s.data[0].id;

        // Clear the PCs config list
        let cl = this.configlist;
        this.configlist = cl.filter(x => x.pcprofile != id);

        let sl = s.selections;
        for (const prop in sl)
        {
            if (prop.startsWith(id)) {
                //sl[prop] = '';
                if (!delete sl[prop]) { throw new Error(); }
            }
        }

        // remove the pc from the array
        let sel = s.data.filter(d => !d.parent)[0];
        let removed_iid = '';
        {
            let removed = this.newdata.find(d => d.id == id);
            removed_iid = removed.iid;
        }
        this.newdata = this.newdata.filter(d => d.id != id);

        s.data = this.newdata

        let foundiid = {}
        foundiid = s.data.find(d => d.iid == removed_iid);

        let found = {}
        let e_id = '';
        // loop through the includes and make sure there is at least one of each
        includesFilter(s,s.data[0]).forEach(e => {
            found = s.data.find(d => d.iid == e.id);
            if (!found) {
                e_id = e.id;
            };
        });

        //let rtn = this.reCalcOutput(pc, s, p, '', '');
        //this.setState(rtn);
        //return;

        // try/catch because of "undefined is not iterable" which cannot be traced
        //ADD AN INSTANCE OF THAT IID.
        if (e_id) {
            await this.includesRunner(false, s, e_id);

            // set state
            this.setState(s);
        } else {
            this.setProfile(foundiid.id, { id: foundiid.iid }, false, '', 0, null)

            // recalculate the output
            let rtn = this.reCalcOutput(pc, s, p, '', '');
            rtn = await this.fixPrice(rtn, p);

            // set state
            this.setState(rtn);
        }
    }

    /**
     * Deletes a part from the part creator cart
     * @param {any} id
     */
    async refPart(dat) {
        let id = dat.id;

        let cl = this.configlist;
        this.configlist = cl.filter(x => x.pcprofile != id);
        
        //let sel = this.state.data.filter(d => !d.parent)[0];
        let sel = this.state.data.find(d => !d.parent);

        for (let i = 0; i < this.newdata.length; i++) {
            //this.newdata.forEach(async (e,i) => {

            let e = this.newdata[i];

            if (e.id == id) {
                let idat = e.idat;

                let newid = this.uuidv4();

                let selectedObj = this.state.selectedObj;
                selectedObj[idat.id] = newid;
                this.setState({ selectedObj });

                let rtn = newid;
                if (!idat.id) this.setState({ selected: newid });

                let parent = e.parent;
                let maxqty = e.maxqty;
                let binding = e.binding;
                let tags = e.tags;
                let unseltitle = e.unseltitle;
                let inittemplate = e.inittemplate;

                let newdata = await this.populateData2(dat.orgid, newid, idat, parent, maxqty, binding, tags, unseltitle, inittemplate, i);
            }
            //});
        }   


    }

    /**
     * Sets the quantity of a part creator part
     * @param {any} id
     * @param {any} val
     */
    async setQty(id, val)
    {
        this.setState(async (s, p) => {
            if (val < 1) val = 1;

            let _d = s.data.find(d => d.id == id);
            _d.qty = val;
            let rtn = this.reCalcOutput(id, s, p, '', '', '', '');
            //rtn = await this.fixPrice(rtn, p);
            return rtn;
        });
    }

    /**
     * Occurs as the user types letters into the search field
     * @param {any} dat - The group id
     * @param {any} val - The search value
     */
    async schChg(pc, dat, val) {
        this.setState(async (s, p) => {

            let rtn = this.reCalcOutput(pc, s, p, '', '', dat, val);
            //rtn = await this.fixPrice(rtn, p);
            return rtn;

        });
    }

    /**
     * Occurs when a user chooses an option
     * @param {any} g - the group id
     * @param {any} i - the id of the chosen value
     */
    async textChange(pc, g, i) {

        if (this.timers[pc + '_' + g]) clearTimeout(this.timers[pc + '_' + g]);
        this.timers[pc + '_' + g] = setTimeout(() => { this.textBlur(pc, g, ''); }, 500);

        if (!this.state._selections) this.state._selections = {};
        this.state._selections[pc + '_' + g] = i;
        let rtn = this.state;
        this.setState(rtn);
    }

    /**
     * Occurs when a user chooses an option
     * @param {any} g - the group id
     * @param {any} i - the id of the chosen value
     */
    async textBlur(pc, g, i) {
        if (this.timers['pre_' + pc + '_' + g]) clearTimeout(this.timers['pre_' + pc + '_' + g]);

        if (!this.state._selections) this.state._selections = {};
        this.handleClick(pc, g, this.state._selections[pc + '_' + g]);
    }

    /**
     * Occurs when a user chooses an option
     * @param {any} g - the group id
     * @param {any} i - the id of the chosen value
     */
    async handleClick(pc, g, i) {

        let this_state = this.state;

        let rtn = this.reCalcOutput(pc, this_state, this.params, g, i);
        rtn = await this.fixPrice(rtn, this.params);
        let hit = false;

        rtn.data[0].configgroup.forEach(x => {
            let zid = rtn.data[0].id;
            let xid = x.id;

            let sval = rtn.selections[zid + '_' + xid];
            if (sval && sval == "?" && x.nonevalue == 'NA') {
                rtn.selections[zid + '_' + xid] = '';
                hit = true;
            }

        });

        this_state = rtn;

        if (hit) {
            let rtn = this.reCalcOutput(pc, this_state, this.params, g, i);
            rtn = await this.fixPrice(rtn, this.params);
        }

        this.setState(rtn);
    }

    /**
     * Clears the selected value of a group
     * @param {any} g - the group id
     * @param {any} v - the value
     */
    async clear(pc, g,v)
    {
        let rtn = this.reCalcOutput(pc, this.state, this.params, g, v);
        rtn = await this.fixPrice(rtn, this.params);



        if (this.reset) {
            this.reset = false;
            //rtn = JSON.parse(JSON.stringify(this.basestate));
            //window.location.reload();
            

            if (this.newdata[0].id == pc) {
                this.props.reset('');
            } else {
                this.delPart(pc);
            }

        } else {
            this.setState(rtn);
        }
    }

    /**
     * 
     * @param {any} pc
     * @param {any} def
     */
    async invalidAction(pc, def) {
        invalidAction(def, this, pc, this.state);

        let rtn = this.reCalcOutput(pc, this.state, this.params, '', '');
        rtn = await this.fixPrice(rtn, this.params);
        this.setState(rtn);
    }

    /**
     * 
     * @param {any} pc
     * @param {any} def
     */
    async addToSystem(pc, def) {
        //invalidAction(def, this, pc, this.state);

        let _pc = this.state.data.find(e => e.id == pc);
        _pc.sysadded = 1;

        let rtn = this.reCalcOutput(pc, this.state, this.params, '', '');
        rtn = await this.fixPrice(rtn, this.params);
        this.setState(rtn);
    }

    /**
     * 
     * @param {any} pc
     * @param {any} group
     */
    async warningGrpAction(pc, group) {

        this.setOptionValX(pc, this.state, '', '', group.invalidArg2, '', group.invalidArg3);

        if (group.clearlist) {
            var gcl = group.clearlist.split(',');
            gcl.forEach(x => this.setOptionValX(pc, this.state, '', '', '', '', x.trim()))
        }

        group.invalidActionTxt = "";
        group.invalidAction = "";
        group.invalidArg1 = "";
        group.invalidArg2 = "";
        group.invalidArg3 = "";

        //let _c1 = {}; this.getOptionValueWithSC(pc, s, "C1", (g, o) => { _c1 = o; });
        //let _c2 = {}; this.getOptionValueWithSC(pc, s, "C2", (g, o) => { _c2 = o; });

        //self.setOptionVal(pc, s.data, s.selections, '', '', _c2.name, '', 'C1');
        //self.setOptionVal(pc, s.data, s.selections, '', '', _c1.name, '', 'C2');

        let rtn = this.reCalcOutput(pc, this.state, this.params, '', '');
        rtn = await this.fixPrice(rtn, this.params);
        this.setState(rtn);
    }

    /**
     * Triggered when the user adds a filter tag to a group
     * @param {any} g - the group id
     * @param {any} v - the tag value
     */
    async tagsChg(pc, g,v) {
        this.setState(async (s, p) => {

            let rtn = this.reCalcOutput(pc, s, p, '', '', null, null, g, v);
            //rtn = await this.fixPrice(rtn, p);
            return rtn;

        });
    }

    /**
     * Triggered when the user deletes a filter tag from a group
     * @param {any} g - the group id
     * @param {any} v - the tag value
     */
    async tagsDel(pc, g,v) {
        this.setState(async (s, p) => {

            let rtn = this.reCalcOutput(pc, s, p, '', '', null, null, g, v, true);
            //rtn = await this.fixPrice(rtn, p);
            return rtn;

        });
    }

    /**
     * 
     * @param {any} s
     * @param {any} p
     */
    async fixPrice(s,p)
    {
        for (let index = 0; index < s.data.length; index++) {
            let dat = s.data[index];
            //state.data.forEach(await (dat) => {
            // Some parts need to have thier price looked up from the database
            if (!(dat.invalid || dat.disabled) && (dat.uselistprice || dat.useexcelprice)) {
                if (!this.partlookup[dat.partnum]) {

                    let prepare = dat.partnum.replaceAll('/', '~');
                    //prepare = btoa(dat.partnum).replaceAll('/', '_').replaceAll('+', '-');
                    if (prepare) {
                        let uri = this.SERVER_URL + 'PCProfileImpl/getpart/' + prepare;
                        if (dat.useexcelprice) uri = this.SERVER_URL + 'PCProfileImpl/getpartcsv/' + prepare;

                        let newpart = { price: 0 };
                        let response = await fetch(uri);
                        let dt = await response.json();
                        newpart.price = dt.price;

                        this.partlookup[dat.partnum] = newpart;
                    }
                }

                let outprice = 0;
                if (this.partlookup[dat.partnum] && this.partlookup[dat.partnum]) {
                    outprice = this.partlookup[dat.partnum].price;
                }
                this.calcDiscounts(dat, outprice);
            }
        }

        return s;
    }

    /**
     * Calculate the discounts
     * @param {any} partcreator
     * @param {any} outprice
     */
    calcDiscounts(partcreator, outprice)
    {
        // Get the price that may have been saved from an excel lookup
        // doing this again because the calc is called without fixPrice on occasion
        if (this.partlookup[partcreator.partnum] && this.partlookup[partcreator.partnum]) {
            outprice = this.partlookup[partcreator.partnum].price;
        }

        // __price is the flat starting price to use in calculations
        let mult = this.curr?.cintlMult || 1.0;
        let _outprice = outprice * mult;
        let __price = _outprice;

        // get the price list discount
        partcreator.qtydisc = 0;
        let cpl = this.calcPLDisc(partcreator.partnum, partcreator.prodcode, partcreator.qty, this.pricelist)
        if (cpl) {
            let _qtydisc = 0;
            if (cpl[0]) {
                _qtydisc = _outprice * (cpl[0] / 100);
            } else {
                _qtydisc = _outprice - cpl[1];
            }
            __price = _outprice - fixedTo(_qtydisc, 2);
            partcreator.qtydisc = fixedTo(_qtydisc, 2);
        }

        // get the flat percentage discount
        let _flatdisc = __price * ((this.flatDiscPct) / 100);
        partcreator.flatdisc = _flatdisc;
        partcreator.price = _outprice;
    }

    /**
     * Calculate the discounts
     * @param {any} partcreator
     * @param {any} outprice
     */
    calcDiscounts2(obj, outprice) {
        // Get the price that may have been saved from an excel lookup
        // doing this again because the calc is called without fixPrice on occasion
        //if (this.partlookup[obj.partnum] && this.partlookup[obj.partnum]) {
        //    outprice = this.partlookup[partcreator.partnum].price;
        //}

        // __price is the flat starting price to use in calculations
        let mult = this.curr?.cintlMult || 1.0;
        let _outprice = outprice * mult;
        let __price = _outprice;

        // get the price list discount
        obj.qtydisc = 0;
        let cpl = this.calcPLDisc(obj.partnum, obj.prodcode, obj.qty, this.pricelist)
        if (cpl) {
            let _qtydisc = 0;
            if (cpl[0]) {
                _qtydisc = _outprice * (cpl[0] / 100);
            } else {
                _qtydisc = _outprice - cpl[1];
            }
            __price = _outprice - fixedTo(_qtydisc,2);
            obj.qtydisc = fixedTo(_qtydisc, 2);
        }

        // get the flat percentage discount
        let _flatdisc = __price * ((this.flatDiscPct) / 100);
        obj.flatdisc = _flatdisc;
        obj.price = _outprice;
    }

    /**
     * Disables incompatable options when an option is selected
     * @param {any} s
     * @param {any} p
     */
    disableSelections(pc,st,p)
    {
        let s = st.selections;

        // get the current selection
        let i = s[p];

        let ele = this.getConfigList(st, pc).find(f => f.id == i);
        let ar = [];
        if (ele) ar.push(this.getConfigList(st, pc).find(f => f.id == i));
        ar.forEach(e => {

            

            // loop the current selections block list
            e.bl.forEach(g => {
                // find a blocked item and block it
                this.getConfigList(st, pc).filter(h => h.id == g.val).forEach(j => {
                    if (j.pcprofile == e.pcprofile) {
                        j.openclose += 1;
                    }
                });
            });

            // custom filters completly override the built in blocking logic
            this.getGroup(pc, st, e.parent, g => {
                internalFilter("SC3_FSR_FILTER", pc, st, g, e, this);
            });

            // loop the current selections price block list
            e.bp.forEach(g => {
                // find a blocked item and block it
                this.getConfigList(st, pc).filter(h => h.id == g.val && h.pcprofile == e.pcprofile).forEach(j => {
                    j.ord = 0;
                });
            });



        });

        // if you want to clear all items except the selected one
        // this is where that will happen
        this.getConfigList(st, pc).forEach(c => {
            if (i && c.pcprofile + '_' + c.configgroup == p && i != c.id) {
                //let inittemplateOverride = false;
                //st.data.filter(e => e.id == c.pcprofile).forEach(dat => {
                //    if (dat.inittemplate) {
                //        let inittemplate = dat.inittemplate.replaceAll(' ', '');
                //        let _inittemplate = inittemplate.split(':');
                //        if (_inittemplate[0] && _inittemplate.length > 2) {
                //            this.getOptionValueWithSC(dat.id, st, _inittemplate[0], (g, o) => {
                //                let vals = _inittemplate[2].split(',');
                //                if (!o.name || vals.includes(o.name)) {
                //                    inittemplateOverride = true;
                //                    //o.template = _inittemplate[1];
                //                    //this.fillTemplate(pc, s, g, o, false, false, x, d);
                //                }
                //            });
                //        }
                //    }
                //});

                //if (!inittemplateOverride) {
                c.openclose = -100;
                //}
            }
        });
    }

    //#endregion

    //#region Known PN Logic Selection

    /**
     * As the known PN is typed in this field sets the state variable
     * @param {any} dat
     * @param {any} val
     */
    async setKnow(dat, val) {
        let v = '';
        await this.setState((s, p) => {
            s.data.forEach(d => {
                if (dat.id == d.id) {
                    v = d.know;
                    d.know = val;
                }
            });
            return { data: s.data };
        });
        return v;
    }

    /**
     * Handles the submit button after you have typed a part number
     * @param {any} dat
     */
    async handelKnowPN(dat) {
        let v = await this.setKnow(dat, '');
        this.props.reset(v);

        //
        //await parsePN(dat, v, this);

        //let rtn = await this.fixPrice(this.state, this.params)
        //this.setState(rtn);
    }

    

    //#endregion

    //#region Render Functions Section

    //#region Basic Rendering

    /** The main render function */
    render() {

        let contents;

        //console.log(this.state.selections);

        // For PL Data we will just show the list of images
        if (this.params.mode && this.params.mode == 'pldata')
        {
            var pldata = this.state.pldata || [];
            //return (<div>{}</div>);
            return pldata.map((item, index) => (
                    <img key={index} src={'https://connect.ctconline.com/uploads/'+item.id + '/' + item.name} style={{width:'100%'}}/>
                ));
        }

        if (this.params.mode && this.params.mode == 'json') {
            if (this.state.noprofile) {
                let _dat = '{"partnum": "","partdesc": "JSON not available","prodcode": "","invalid": true,"price": 0,"configs": [],"parttemp": "","type": "Other"}';
                return (<div id="json_out">{_dat}</div>);
            }
        }

        if (this.params.mode && this.params.mode == 'image') {
            if (this.state.noprofile) return 'Image not available';
        }
        if (this.params.mode && this.params.mode == 'imageplus') {
            if (this.state.noprofile) return 'Image not available';
        }
        if (this.params.mode && this.params.mode == 'imagecomponents') {
            if (this.state.noprofile) return 'Image not available';
        }
        if (this.params.mode && this.params.mode == 'noprofile') {
            if (this.state.noprofile) return 'Error, could not render part creator';
        }

        const rootElement = document.getElementById('root');
        const params = QueryString.parse(window.location.search);
        let root_pc = params.ctcpc || rootElement.getAttribute('pc');

        // if no profile selected show the profile screen
        if (!this.state.selected) {

            if (this.state.loadingp) {
                contents = this.renderLoadingRing();
            } else {
                if (root_pc) {

                    // if not loaded, then show the loading screen
                    contents = <>
                        <div style={{ textAlign: 'left', marginTop: '20px' }}>
                            <h1>Sorry, we've encountered an error.</h1>
                            <p>We apologize for the inconvenience, but it seems like an error has occurred while
                                building your product. Not to worry, though we're here to help!</p>
                            <p>Please try the following steps to resolve the issue:</p>
                            <ol>
                                <li><strong>Refresh your browser:</strong> Give your browser a quick refresh by clicking the circular arrow icon or pressing the F5 key on your keyboard. This often resolves minor hiccups.</li>
                                <li><strong>Clear your browser's cache:</strong> Sometimes, cached data can cause issues. Go to your browser settings and clear the cache, then refresh the page.</li>
                                <li><strong>Check your internet connection:</strong> Ensure you have a stable internet connection to avoid any interruptions.</li>
                            </ol>
                            <p>If the problem persists after trying these steps, please don't hesitate to reach out to our
                                friendly support team at
                                <a href="mailto:CTC Customer Service <ctcgenmailbox@ctconline.com>">CTC Customer Service</a>
                                or by calling <a href="tel:5859245900">585-924-5900</a>. We'll work quickly to get things
                                back on track so you can continue building your perfect product.</p>
                            <p>Thank you for your patience, and we apologize for any inconvenience this may have caused.</p>
                        </div>
                    </>;

                } else {

                    // if not loaded, then show the loading screen
                    contents = this.renderData(this.state);

                }
            }

        } else {
            // else show the part creator screen
            // if not loaded, then show the loading screen
            contents = this.state.loading
                ? this.renderLoadingRing()
                : this.state.waiting
                    ? this.renderInfoRing(this.state.waiting)
                    : this.renderPartCreator(this.state);

        }

        // output the UI
        return (
            <div>
                {contents}
            </div>
        );
    }

    /** */
    renderLoadingRing() {
        return this.renderInfoRing("Loading...")
    }

    /**
     * 
     * @param {any} text
     */
    renderInfoRing(text) {
        return (
            <div style={{ width: '100%', textAlign: 'center', margin: '15px' }}>
                <h1 style={{ fontFamily: 'arial', fontSize: '50px' }}>{text}</h1>
                <div className="lds-ring" style={{ margin: 'auto' }}><div></div><div></div><div></div><div></div></div>
            </div>
        );
    }

    /**
     * The UI render function
     * @param {any} state
     */
    renderData(state) {
        this.classes = useStyles;


        return this.props_pc_embed ? (
            <React.Fragment>
                <div className="flex-container">
                    <div className="flex-item">Know&nbsp;your&nbsp;Part&nbsp;Number? Type&nbsp;it&nbsp;here:</div>
                    <div className="flex-item"><Input id="ski" style={{ width: '100%' }} value={state.know}
                        onChange={(e) => this.setKnow2(e.target.value)} /></div>
                    <div className="flex-item"><Button id="skb" className={themeButton}
                        onClick={(e) => this.handelKnowPN2()}>Submit</Button></div>
                </div>
                <Grid container spacing={1} style={{ paddingTop: '15px' }}>

                    {state.profiles.sort((a, b) => {
                        if (a.name < b.name) { return -1; }
                        if (a.name > b.name) { return 1; }
                        return 0;
                    }).map(dat =>
                        <Grid item xs={12} key={dat.id}>

                            <ActionCard
                                onClick={(e) => this.setProfile(dat.id, { id: '', name: '' }, true, '', 0, e)}
                                title={dat.name}
                                theme={themeClass}></ActionCard>
                        </Grid>
                    )}
                </Grid>
            </React.Fragment>
        ) : null;
    }

    /**
     * Some predefined conditions for manipulating strings - used in adjusting the opcode before transmitting json
     * @param {any} cfg - The config
     * @param {any} op - the operation to perform
     * @param {any} param1 - the parameter of the operation
     */
    opCodeFix(cfg, op, param1)
    {
        if (!cfg.val) return;
        try {
            const flags = "g";
            const p1 = this.escapeRegex(param1);
            if (op == "TRIMSTART" || op == "TRIM") {
                cfg.val = cfg.val.replace(new RegExp("^[" + p1 + "]+", flags), '');
            }
            if (op == "TRIMEND" || op == "TRIM") {
                cfg.val = cfg.val.replace(new RegExp("[" + p1 + "]+$", flags), '');
            }
            if (op == "PADSTART") {
                cfg.val = cfg.val.padStart(param1.length, param1);
            }
            if (op == "PADEND") {
                cfg.val = cfg.val.padEnd(param1.length, param1);
            }
            if (op == "CONCATSTART") {
                cfg.val = param1 + cfg.val;
            }
            if (op == "CONCATEND") {
                cfg.val = param1 + cfg.val;
            }
            if (op == "REGEXREMOVE") {
                cfg.val = this.removeRegExMatch(cfg.val, param1);
            }
            if (op == "REGEXKEEP") {
                cfg.val = this.leaveRegExMatch(cfg.val, param1);
            }
        } catch (e)
        { console.log(e); }
        const asdf = 0;
    }

    /**
     * Escapes regular strings for regex use
     * @param {any} string
     */
    escapeRegex(string) {
        return string.replace(/[\[\](){}?*+\^$\\.|\-]/g, "\\$&");
    }

    /**
     * Unused - but may be useful in future if needed to block the <01> typed in front of probe data
     * @param {any} str
     * @param {any} srex
     */
    removeRegExMatch(str, srex) {
        if (srex) {
            var a = srex.split("/");
            let modifiers = a.pop(); a.shift();
            let pattern = a.join("/");
            let rex = new RegExp(pattern, modifiers);

            return str.replace(rex, "");
        }
        return str;
    }

    leaveRegExMatch(str, srex) {
        let result = '';
        if (srex) {
            var a = srex.split("/");
            let modifiers = a.pop(); a.shift();
            let pattern = a.join("/");
            let rex = new RegExp(pattern, modifiers);

            let match = rex.exec(str);
            while (match != null) {
                // matched text: match[0]
                // match start: match.index
                // capturing group n: match[n]
                result += match[1];
                match = rex.exec(str);
            }
        }
        return result;
    }

    //#endregion

    //#region PC Rendering

    addAnotherButtons = [];
    addAnotherVar = [];
    nextButtons = [];
    nextButtonRendered = false;

    //#region Main PC Render Process
    // https://connectiontechnology-my.sharepoint.com/:u:/g/personal/smclarney_ctconline_com/EftkFLKBn_ZOozonH7ddmL4B0Rxn5YDlJBblyZ2jGyvRew?e=eFtrmf

    /**
     * Render the Part Creator
     * @param {any} state
     */
    renderPartCreator(state) {

        let pc = state.data[0].id;

        // Css class given to a product type
        const cssclass = state.data[0].configgroup[0].cssclass || state.data[0].configgroup[1].cssclass;

        // Get the first config group that has at least one config with linktext03 (product line)
        // If none exist, use the first config group
        let configgroup = state.data[0].configgroup.find(cg => cg.configs.find(c => c.linktext03));

        if (!configgroup) configgroup = state.data[0].configgroup[0];

        // Get the selected configuration by id
        const selected = configgroup.configs.find(conf => conf.id === state.selections[`${state.data[0].id}_${configgroup.id}`]);

        if (selected) {
            // Attempt to get the config for a selected part
            // If the config can't be found, use the product type's css class
            let partConfig = configgroup.configs.find(conf => conf.name === selected.name);
            let prdline = partConfig && partConfig.linktext03 ? partConfig.linktext03.substr(0, 3).toLowerCase() : cssclass;

            // Use the product line theme if available        
            // Otherwise default to ctc red theme
            themeClass = prdline || 'ctc';

        } else {
            // still change the theme if the css for a product type is set and a product is not selected
            // if cssclass is nonsense it will default to ctc
            themeClass = cssclass;
        }

        activeTheme = themeClass === 'connect' ? connectTheme
            : themeClass === 'tmp' ? tmpTheme
            : themeClass === 'pro' ? proTheme
            : ctcTheme;
        themeButton = themeClass + '-btn';

        //#region compile the json output
        let json = {};
        let anyinvalid = false;
        let __anyinvalid = false;

        state.data.forEach(dat => {

            // determine if there is anything invalid about the current PC
            let _invalidMsg = dat.invalidMsg ? true : false;
            anyinvalid = dat.invalid || dat.disabled || anyinvalid || _invalidMsg;

            let _y = [];
            let y = [];
            let w = "";
            let classification = "";
            let classificationNotes = "";
            let mcid = '';
            let disabledtext = '';

            // determine if the PC uses a pseudomain (an alternate main component)
            let pseudomain = false;
            dat.configgroup.forEach(x => {
                if (x.mainpseudo) { pseudomain = pseudomain || x.mainpseudo }
            });

            // for each config
            dat.configgroup.forEach(x => {
                let i = x;

                // build a config
                let cfg = {};
                let _cfg = {};

                // record the name
                cfg.name = x.name;

                // Determine if this component is the main component
                if (!pseudomain) {
                    cfg.maincomp = x.maincomp || false;
                } else {
                    cfg.maincomp = x.mainpseudo || false;
                }

                // determine if the component should be treated a 'pull as component' for the back end PC
                cfg.pullascomp = x.pullascomp || false;

                // record the shortcode
                cfg.shortcode = x.shortcode;

                // get the selection of the current config
                let c = x.configs.find(y => state.selections[x.pcprofile + '_' + x.id] == y.id);
                cfg.val = c ? c.name : '';
                cfg.prodcode = c ? c.prodcode : '';

                // record the main component product code
                if (x.maincomp) {
                    w = cfg.prodcode;
                    mcid = x.id;
                    classification = c?.stocktext;
                }

                // if no classification has been filled in,fill in a default
                if (!classification) classification = 'Build To Order';

                // fill in hardcoded notes
                if (classification?.toLowerCase() == "build to order") classificationNotes = "(Final Sale)";

                // get any disabled text of the current selection
                if (c && c.disabledtext) {
                    disabledtext += c.disabledtext;
                }

                // if the input is a text field or dropdown or nothing the value is the data in the selection array
                if (x.type == '3' || x.type == '4' || cfg.val == '?') { // || x.type == '6' 
                    cfg.val = state.selections[x.pcprofile + '_' + x.id]
                }

                // if the field/group is of type calc
                if (x.type == '6') {
                    cfg.val = calcSC(x.setscript, this, x, dat, state);
                }

                _cfg = { ...cfg };

                // apply the altshortcode if there is one
                let altshortcode = x.altshortcode;
                if (altshortcode && altshortcode.trim()) _cfg.shortcode = altshortcode.trim();

                // apply the opcode fixes
                let optcodefixes = [];
                let _optcodefixes = x.optcodefixes?x.optcodefixes:'[]';
                optcodefixes = JSON.parse(_optcodefixes);
                
                if (optcodefixes.length > 0) {
                    optcodefixes.forEach(ocf => this.opCodeFix(_cfg, ocf.key, ocf.val));
                }

                // push the assembled config to the output
                y.push(cfg);
                _y.push(_cfg);
            });

            // trim any ';' off the end of the description
            let _partdesc = this.trim(dat.partdesc, ';');

            // if the known part number does not match the calc part number
            // mark invalid as true
            if (this.kpn && this.kpn != dat.partnum) { anyinvalid = true; }
            if (disabledtext) {
                _partdesc = disabledtext;
                anyinvalid = true;
            }

            // another invalid field based on 0 price
            let _anyinvalid = !dat.price && !dat.anyzero ? true : false;

            if (!checkRequired(this, pc, state, dat, y)) {
                anyinvalid = true;
                _anyinvalid = true;
                __anyinvalid = true;
            }

            // more cleanup on the part description
            _partdesc = this.trim(_partdesc, ' ');
            _partdesc = this.trim(_partdesc, ';');
            _partdesc = this.trim(_partdesc, ' ');
            _partdesc = this.trim(_partdesc, ';');
            _partdesc = this.trim(_partdesc, ' ');

            // if the part is valid get the price otherwise price is 0
            let _price = !anyinvalid && !_anyinvalid ? dat.price : 0;
            _price = Math.round(100 * _price) / 100;

            // Compile the json response
            let z = {
                partnum: dat.partnum,
                partdesc: _partdesc,
                prodcode: w,
                invalid: anyinvalid || _anyinvalid,
                price: _price,
                configs: _y,
                parttemp: dat.parttemp.replaceAll('\r', '').replaceAll('\n', ''),
                type: dat.name,
                classification: classification,
                classifnotes: classificationNotes
            }
            json = z;

        });

        // if the mode is JSON, output the JSON
        if (this.params.mode && this.params.mode == 'json') {

            return (
                <div id="json_out">{JSON.stringify(json)}</div>
            );
        }


        let total = 0;
        let total2 = 0;
        this.classes = useStyles;

        // If the mode is image, output an image
        if (this.params.mode && this.params.mode == 'image') {

            let y = [];
            state.data.forEach((dat, i) => {
                y.push(this.getPrdRenderSections(state, i, i, dat, total, total2, anyinvalid, __anyinvalid, (disabled) => null, false, false));
            });

            return (
                json.invalid ?
                    <div>Part Creator could not render a part.</div> :
                    <div id="img_out" style={{ maxWidth: '700px', margin: 'auto' }}>{y.map(y => y["imagestacked"])}</div>
            );
        }

        // if the mode is image plus output the image and description
        if (this.params.mode && this.params.mode == 'imageplus') {

            let y = [];
            state.data.forEach((dat, i) => {
                y.push(this.getPrdRenderSections(state, i, i, dat, total, total2, anyinvalid, __anyinvalid, (disabled) => null, false, false));
            });

            let z = [];
            if (state.data[0].renderinfo) {
                state.data[0].renderinfo.forEach((dat, i) => {
                    if (dat.partimage) {
                        z.push(
                            <div className="col-12 col-sm-4" style={{ padding: '5px' }}>
                                <div className="p-3" style={{ border: '1px solid black', borderRadius: '10px', fontSize: '10px' }}>
                                    {dat.option} - {dat.description}
                                <div style={{ height: '100px', width: '100%', overflow: 'hidden', textAlign: 'center' }}>
                                    <img src={'https://www.ctconline.com' + dat.partimage} />
                                </div>
                            </div>
                            </div>);
                    }
                });
            }

            return (
                json.invalid ?
                    <div>Part Creator could not render a part.</div> :
                    <div id="img_out" style={{ maxWidth: '700px', margin: 'auto' }}>
                        {y.map(y => y["cart"])}
                        {y.map(y => y["imagerot"])}
                        {z.length < 1 ? null : <div className="container">
                            Components:
                        <div className="row">{z}</div>
                        </div>}
                    </div>
            );
        }

        if (this.params.mode && this.params.mode == 'imagecomponents') {

            let y = [];
            state.data.forEach((dat, i) => {
                y.push(this.getPrdRenderSections(state, i, i, dat, total, total2, anyinvalid, __anyinvalid, (disabled) => null, false, false));
            });

            let z = [];
            if (state.data[0].renderinfo) {
                state.data[0].renderinfo.forEach((dat, i) => {
                    if (dat.partimage) {
                        z.push(
                            <div className="col-12 col-sm-4" style={{ padding: '5px' }}>
                                <div className="p-3" style={{ border: '1px solid black', borderRadius: '10px', fontSize: '10px' }}>
                                    {dat.option} - {dat.description}
                                    <div style={{ height: '100px', width: '100%', overflow: 'hidden', textAlign: 'center' }}>
                                        <img src={'https://www.ctconline.com' + dat.partimage} />
                                    </div>
                                </div>
                            </div>);
                    }
                });
            }

            return (
                json.invalid ?
                    <div>Part Creator could not render a part.</div> :
                    <div id="img_out" style={{ maxWidth: '700px', margin: 'auto' }}>
                        {y.map(y => y["imagestacked"])}
                        {z.length < 1 ? null : <div className="container">
                            Components:
                        <div className="row">{z}</div>
                        </div>}
                    </div>
            );
        }
        //#endregion

        let parts = this.compileRequestedParts();
        window.pcparts = parts;

        // get the includes
        let l = includesFilter(state,state.data[0]).filter(x => x.cpcprofile).length;


        // if there are includes
        if (l > 0) {
            this.includespassed = true;

            // the continue result from the lead in questions
            let rtnObj = {};
            rtnObj.cont = true;
            rtnObj.codes = [];

            // Process the lead in questions
            let y = this.renderLeadInQuestions(state, state.data[0], rtnObj);

            // output the screen
            return (
                <div>
                    {!this.state.popup ? null :
                        <Alert severity="warning" onClose={() => this.setState({ popup: '' })}>{this.state.popup}</Alert>
                    }
                    
                    {/** The progress stepper at the top of the screen */}
                    <ThemeProvider theme={activeTheme}>
                        <Stepper activeStep={this.state.activeStep} connector={<PCStepConnector />} className={themeClass} alternativeLabel>
                            {this.steps.map((label, i) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={PCStepIcon} style={{ cursor: 'pointer' }} node={label}
                                        onClick={(e, v) => this.setActiveStep(e,v,i)}>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    </ThemeProvider>
                    <div>
                        
                        {/** Step 0 is the main part creator */}
                        {this.state.activeStep === 0 ? (
                            <div>
                                {this.renderMainTab(state, 0, total, total2, __anyinvalid, anyinvalid, false, (disabled) =>
                                    <div style={{ margin: '25px' }}>
                                        {rtnObj.hasLQ ?
                                            <Button onClick={(e, v) => this.setState({ activeStep: this.state.activeStep + 1 })}
                                                variant="contained" className={themeButton} style={{ width: '100%' }}>Next</Button>
                                            :
                                            <Button onClick={(e, v) => this.incStepGenIncludes()} disabled={disabled}
                                                variant="contained" className={themeButton} style={{ width: '100%' }}>Continue</Button>
                                        }
                                    </div>
                                )}
                            </div>
                        ) : null}

                        {/** Step 1 is the main recommended parts screen */}
                        {this.state.activeStep === 1 ? (
                            <div>
                                {this.renderRecommendTab(state, total, total2, __anyinvalid, anyinvalid)}
                            </div>
                        ) : null}

                        {/** Step N+1 is is any tabulated recommended parts screens */}
                        {this.state.activeStep > 1 && this.state.activeStep < this.steps.length - 1 ? (
                            <div>
                                {this.renderOtherTab(state, total, total2, __anyinvalid, anyinvalid, state.activeStep)}
                            </div>
                        ) : null}

                        {/** The last screen is add to cart */}
                        {this.state.activeStep === this.steps.length - 1 ? (
                            <div>
                                {this.renderCheckoutScreen(state, -1, total, total2, __anyinvalid, anyinvalid, false, (disabled) => null)}
                                { !__anyinvalid ? this.renderCheckoutButtons(state, true) : null }
                            </div>
                        ) : null}

                    </div>
                </div>
            );
        } else {

            // if there arent any include screens to show, just show the main part creator
            return (
                <div>
                    {this.renderMainTab(state, 0, total, total2, __anyinvalid, anyinvalid, true, (disabled) => null)}
                </div>
            );
        }
    }

    setActiveStep(e,v,i)
    {
        let x = (
            this.state.data[0].name == 'Vibration Pole' ||
            //this.state.data[0].name == 'Sensor Beta' ||
            //this.state.data[0].name == 'LP Beta' ||
            false) ? 1 : 0;
        if(x==1 && this.state.activeStep > i)
        {
            this.setState({ popup: "For this product, you must start over to make edits to previous steps. Please press refresh in the browser to start over." });
            return;
        }
        this.setState({ activeStep: i });
    }

    /**
     * This function renders the individual blocks of the part creator
     * @param {any} state
     * @param {any} index
     * @param {any} i
     * @param {any} dat
     * @param {any} total
     * @param {any} total2
     * @param {any} anyinvalid
     * @param {any} __anyinvalid
     * @param {any} buttons
     * @param {any} showcart
     * @param {any} useselected
     * @param {any} layoutstyle
     * @param {any} inc
     */
    getPrdRenderSections(state, index, i, dat, total, total2, anyinvalid, __anyinvalid, buttons, showcart, useselected, layoutstyle, inc) {
        let y = {};
        let pc = state.data[0].id;
        let s = state;

        let x = 0;

        // The main component is the component marked "main component", or if that
        // component is hidden, then it is the first non hidden component
        let mc = dat.configgroup.find(c => c.maincomp);
        if (mc && mc.alttitle == 'HIDE') {
            mc = dat.configgroup.find(c => c.alttitle != 'HIDE')
        }

        // Get the value of the main component
        let v = state.selections[dat.id + '_' + mc.id];
        let isMainFilled = '';// v;

        // Get the selected object within this include tab
        let this_state_selected = this.state.selectedObj[dat.iid];

        // determine if anything is invalid or has a warning
        let _anyinvalid = !dat.price && !dat.anyzero ? true : false;
        let _invalidMsg = dat.invalidMsg ? true : false;

        let _warningMsg = dat.warningMsg ? true : false;
        __anyinvalid = _anyinvalid || __anyinvalid || _invalidMsg;

        // Determine if an init template has been passed by the include tab
        let inittemplateOverride = false;
        if (dat.inittemplate) {
            let inittemplate = dat.inittemplate.replaceAll(' ', '');

            // SCE:4:SCC-PREWIRE
            // In the include if the value of SC @0 is empty or equal to a
            // value in the comma separated list @2, then use temlate @1

            let _inittemplate = inittemplate.split(':');
            if (_inittemplate[0] && _inittemplate.length > 2) {
                this.getOptionValueWithSC(dat.id, s, _inittemplate[0], (g, o) => {
                    let vals = _inittemplate[2].split(',');
                    if (!o.name || vals.includes(o.name)) {
                        inittemplateOverride = true;
                    }
                });
            }
        }

        // if there is no main component selected, and the init template is not overridden
        // mark anyinvalid true
        if (!state.selections[dat.id + '_' + mc.id] && !inittemplateOverride) {
            dat.invalid = true;
            anyinvalid = true;
        }



        // Get an image for the product
        let _1optwrn = false;
        let props_src = dat.image;
        if (props_src) props_src = "https://www.ctconline.com" + props_src;

        // get a description for the product
        let _partdesc = this.trim(dat.partdesc, ';');
        _partdesc = this.trim(_partdesc, ' ');
        _partdesc = this.trim(_partdesc, ';');
        _partdesc = this.trim(_partdesc, ' ');
        _partdesc = this.trim(_partdesc, ';');
        _partdesc = this.trim(_partdesc, ' ');

        // Is this the last one
        this.steps_last = dat.iid == this.steps_iid[this.steps_iid.length - 1];

        // Get the lead in questions
        let rtnObj = {};
        rtnObj.cont = true;
        rtnObj.codes = [];
        let _liq = this.renderLeadInQuestions(state, state.data[0], rtnObj);
        let liq =
            <>
                {this.getStyle(1) && !inc && buttons(dat.invalid) ? _liq : null}

                {this.getStyle(1) && this.nextButtons.length > 0 ?
                    <>{inc ? null :
                        !dat.invalid && buttons(dat.invalid) ? null :
                            <>
                                <Card spacing={1} className={'smain-selector'} style={{
                                    border: '1px solid black',
                                    marginBottom: '15px',
                                    backgroundColor: 'whitesmoke'
                                }}>
                                    <div style={{ padding: '10px', backgroundColor: 'whitesmoke' }}>
                                        <Grid item sm={12} style={{ backgroundColor: 'whitesmoke' }}>
                                            <div style={{ backgroundColor: 'whitesmoke' }}>
                                                <Grid container spacing={1} style={{ backgroundColor: 'whitesmoke' }}>
                                                    Next Steps:
                                                    {!dat.sysadded ? null : <>{this.addAnotherButtons}</>}
                                                    {this.setNextButtonRendered(dat.invalid && buttons(dat.invalid))}
                                                </Grid>
                                            </div>
                                        </Grid>
                                    </div>
                                </Card>
                            </>
                    }</> : null}
            </>

        // get the image
        let img = this.renderImage(state, i, "2");
        let imgrot = this.renderImage(state, i, "3");

        y["dat"] = dat;
        y["imageflat"] = this.renderImage(state, i, "1");
        y["leadinquestions"] = liq;
        y["imagestacked"] = img;
        y["imagerot"] = imgrot;        
        y["selector"] = this.renderSelector(dat, this_state_selected, state, useselected);
        y["diagnostic"] = this.renderDiagnostic(state, total, total2);

        y["cart"] =
            this.renderCart(
                dat, state, i, this_state_selected, _partdesc, _invalidMsg,
                anyinvalid, _anyinvalid, __anyinvalid, _1optwrn, buttons, showcart,
                index != -1, false, !useselected, layoutstyle, inc, liq, img, false, false);
        y["cartsmall"] =
            this.renderCart(
                dat, state, i, this_state_selected, _partdesc, _invalidMsg,
                anyinvalid, _anyinvalid, __anyinvalid, _1optwrn, buttons, showcart,
                index != -1, false, !useselected, layoutstyle, inc, liq, img, true, true);
        y["cart2"] =
            this.renderCartTabbedCheckout(dat, state, i, this_state_selected, _partdesc, _invalidMsg,
                anyinvalid, _anyinvalid, __anyinvalid, _1optwrn, buttons, showcart,
                index != -1, false, !useselected, layoutstyle, inc);
        y["cartnoimg"] =
            this.renderCart(
                dat, state, i, this_state_selected, _partdesc, _invalidMsg,
                anyinvalid, _anyinvalid, __anyinvalid, _1optwrn, buttons, showcart,
                index != -1, false, !useselected, layoutstyle, inc, liq, img, false, true);
        return y;
    }

    /**
     * The UI render function
     * @param {any} state
     */
    renderMainTab(state, index, total, total2, __anyinvalid, anyinvalid, showcart, buttons) {

        let y = [];

        state.data.forEach((dat, i) => {
            if (i != index && index != -1) return null;
            y.push(this.getPrdRenderSections(state, index, i, dat, total, total2, anyinvalid, __anyinvalid, buttons, showcart, false));
        });

        let z = this.renderMany(index, y);

        return (
            <React.Fragment>
                { z}
            </React.Fragment>
        );
    }

    /**
     * The UI render function
     * @param {any} state
     */
    renderRecommendTab(state, total, total2, __anyinvalid, anyinvalid) {

        let y = [];
        let rtnObj = {};

        if (state.data[0].includes[0].cpcprofile == "NA") return;

        y.push(
            <React.Fragment>
                {state.data.map((dat, i) =>
                    <React.Fragment key={dat.id}>
                        {i == 0 ? this.renderIncludes(state, dat, total, total2, __anyinvalid, anyinvalid, false, rtnObj) : null}
                    </React.Fragment>
                )}
            </React.Fragment>
        );

        let buttonOutput = null;
        let ip = this.includespassed;
        if (rtnObj.hasLQ)
        {
            // This was commented out as to not have buttons at the bottom of the recomme
            //if (rtnObj.ans) 
            //{
            //    if (rtnObj.ans == '-1')
            //    {
            //        buttonOutput =
            //                <Button onClick={(e, v) => this.setState({ activeStep: this.state.activeStep + 1 })}
            //            disabled={!ip} variant="contained" color="primary">Finish</Button>
            //    } else
            //    {
            //        buttonOutput =
            //            <Button onClick={(e, v) => this.incStepGenIncludes()}
            //                disabled={!ip} variant="contained" color="primary">Continue</Button>
            //    }
            //}
            //else
            //{
            //    buttonOutput =
            //        <Button onClick={(e, v) => this.setState({ activeStep: this.state.activeStep + 1 })}
            //        disabled={!ip} variant="contained" color="primary">Finish</Button>
            //}
        }
        else
        {
            buttonOutput =
                <Button onClick={(e, v) => this.setState({ activeStep: this.state.activeStep + 1 })}
                disabled={!ip} variant="contained" className={themeButton}>Finish</Button>
        }


        y.push(
            <Grid container spacing={3}>{ip}
                <Grid item xs>
                    <Button onClick={(e, v) => this.setActiveStep(e, v, this.state.activeStep - 1)} color='light'
                    ><ChevronLeft className={themeClass}/> Back to Previous Step</Button>
                </Grid>
                <Grid item xs style={{ textAlign: 'right' }}>
                    {buttonOutput}
                </Grid>
            </Grid>
        );

        return y.map(x => x);
    }

    /**
     * Renders the includes in the event of a non-tabbed recommendataion process
     * @param {any} state
     * @param {any} d
     */
    renderIncludes(state, d, tooltip, total, total2, __anyinvalid, anyinvalid, rtnObj) {

        //let y = [];
        //let rtnObj = {};
        rtnObj.cont = true;
        rtnObj.codes = [];
        let y = this.renderLeadInQuestions(state, state.data[0], rtnObj);

        // If we shouldnt continue just show the lead in questions
        if (!rtnObj.cont || this.steps.length > 3) {
            return y;
        }


        //if () this.setProfile(inc.id, dat, true, d.id, _qty - tot, e)
        //return (
        includesFilter(state,d).forEach(dat => {
            let _y = this.renderAnInclude(state, d, dat, rtnObj, tooltip, total, total2, __anyinvalid, anyinvalid);
            y.push.apply(y, _y);
        });

        return y;

    }

    /**
     * Renders an include tab of a tabbed recommendataion process
     * @param {any} state
     * @param {any} total
     * @param {any} total2
     * @param {any} __anyinvalid
     * @param {any} anyinvalid
     * @param {any} idx
     */
    renderOtherTab(state, total, total2, __anyinvalid, anyinvalid, idx) {
        let y = [];
        let z = [];

        // Is this the last one
        let last = idx == this.steps.length - 2;

        // the continue result from the lead in questions
        let rtnObj = {};
        rtnObj.cont = true;
        rtnObj.codes = [];
        let _y = this.renderLeadInQuestions(state, state.data[0], rtnObj);

        let incs = [];
        includesFilter(state,state.data[0]).forEach(dat => {
            // The code for this include
            let code = dat.code;

            // the answers matching code value
            let ans_code = rtnObj.codes.find(c => c.id == code)

            // if there are no codes or we found a match
            if (ans_code) {
                incs.push(dat);
            }


        });

        // BUTTONS


        // Calculate whether the current selection is invalid
        // to determine which buttons to show.
        let thisinc = incs[idx - 2];
        let asfd = this.state.selectedObj[thisinc.id];
        let selection = this.state.data.find(e => e.id == asfd)
        let sec_inv = selection ? selection.invalid : false;

        // Set up the text names for checkout buttons
        let nextName = "Proceed to Checkout";
        let nextName2 = "Proceed to Checkout";
        let blockNext = false;
        incs.forEach((dat, i) => {
            if (idx == i + 2) {
                if (dat.type == '2')
                {
                    blockNext = true;
                }
                let _y = this.renderAnInclude(state, state.data[0], dat, rtnObj, total, total, total2, __anyinvalid, anyinvalid);

                // This is a fix where the last include was not showing the corect buttons
                // when we are on the last include, we defer the adding of the rendered include until later
                // see code toward the bottom of this function.
                //if (!last)
                y.push.apply(y, _y);
            }
            if (idx + 1 == i + 2) {
                nextName = <>Add {dat.name}</>
                nextName2 = <>Skip To {dat.name}</>
            }
        });

        //#region Buttons
        if (!state.loadingi) {
            let ip = this.includespassed;

            let nextTheme = 'green-button';
            if (nextName == 'Proceed to Checkout')
            {
                nextTheme = 'blue-button';
            }

            let next =
                <Button onClick={(e, v) => this.setState({ activeStep: this.state.activeStep + 1 })} style={{ margin: '5px', width: '100%' }}
                    className={nextTheme}>{nextName}</Button>
            let next2 =
                <Button onClick={(e, v) => this.setState({ activeStep: this.state.activeStep + 1 })} style={{ margin: '5px', height: '100%' }}
                    className={nextTheme}>{nextName2}</Button>

            let checkout =
                <>{nextName == 'Proceed to Checkout' ? null :
                    <Button onClick={(e, v) => this.setState({ activeStep: incs.length + 2 })} style={{ margin: '5px', width: '100%' }} 
                        variant="contained" className={'blue-button'}>
                        <small>I don't need anything else</small><br /> Proceed to Checkout
                    </Button>
                }</>
            let checkout2 =
                <>{nextName == 'Proceed to Checkout' ? null :
                    <Button onClick={(e, v) => this.setState({ activeStep: incs.length + 2 })} style={{ margin: '5px', height: '100%' }}
                        variant="contained" className={'blue-button'}>
                        <small>I don't need anything else</small><br /> Proceed to Checkout
                    </Button>
                }</>

            let previous =
                <Button onClick={(e, v) => this.setActiveStep(e, v, this.state.activeStep - 1)} style={{ margin: '5px'  }}
                    className={'back-button'}>
                    Back to Previous Step</Button>

            if (ip || !blockNext) {
                // Nothing
            } else {
                next = <Button onClick={(e, v) => this.setState({ activeStep: this.state.activeStep + 1 })} style={{ margin: '5px' }}
                    disabled={true} className={'green-button'}>{nextName}</Button>
            }



            // if statement ensures that we only ad the buttons once
            //if (!this.buttonsAlreadyPushed)
            {
                this.nextButtons = [];
                this.nextButtons.push(next);
                this.nextButtons.push(<hr style={{ width: '90%' }} />);
                this.nextButtons.push(checkout);
                this.buttonsAlreadyPushed = true;
            }

            if (this.getStyle(0)) {
                z.push(
                    <Grid container spacing={3}>{ip}
                        <Grid item xs={6}>{previous}</Grid>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>{next}</Grid>
                        <Grid item xs={12}>{checkout}</Grid>
                    </Grid>
                );
            }
            else
            {


                // only show this if the next button hasnt already been rendered.
                if (sec_inv)
                z.push(
                    <Grid container spacing={3}>{ip}
                        <Grid item xs={6}>{previous}</Grid>
                        <Grid item xs={6} style={{ textAlign: 'right' }}>
                            {next2}
                            {checkout2}
                        </Grid>
                    </Grid>
                );
            }

            y = [];

            // This is a fix where the last include was not showing the corect buttons
            // when we are on the last include, we defer the adding of the rendered include until now
            //if (last)
            {
                incs.forEach((dat, i) => {
                    if (idx == i + 2) {
                        let _y = this.renderAnInclude(state, state.data[0], dat, rtnObj, total, total, total2, __anyinvalid, anyinvalid);
                        y.push.apply(y, _y);
                    }
                });
            }
        }
        //#endregion

        return z.concat(y);
    }

    /**
     * More Rendering an include tab of a tabbed recommendataion process
     * @param {any} state
     * @param {any} d
     * @param {any} dat
     * @param {any} rtnObj
     * @param {any} tooltip
     * @param {any} total
     * @param {any} total2
     * @param {any} __anyinvalid
     * @param {any} anyinvalid
     */
    renderAnInclude(state, d, dat, rtnObj, tooltip, total, total2, __anyinvalid, anyinvalid) {

        let y = [];
        this.addAnotherVar = [];
        this.addAnotherButtons = [];

        if (state.loadingi) {
            y.push(
                <div>{this.renderInfoRing("Loading Recommendations...")}</div>
            );
            return y.map(x => x);
        }

        // get the partent qty
        let d_qty = d.qty;
        let layoutstyle = dat.layoutstyle;

        // get the quantity of product to recommend
        let fqty = dat.qty;
        let qty = dat.qty;
        if (dat.qtyfld) {
            this.getOptionValue(d.id, state, dat.qtyfld, (x, y) => {
                qty = y.name;
            });
        }

        // ge the id of the part creator group to add
        //let inc = state.profiles.filter(x => dat.cpcprofile === x.name)[0];
        let inc = state.profiles.find(x => dat.cpcprofile === x.name);

        // retrieve how much qty has already been used.
        let tot = 0;
        this.state.data.filter(d => d.iid == dat.id).forEach(g => {
            tot += g.qty;
        });


        let is = [];
        let dats = [];
        state.data.forEach((d, i) => {
            if (d.iid == dat.id) {
                this.includespassed = this.includespassed && !d.invalid;
                is.push(i);
                dats.push(d);
            }
        });

        let cartAvail = true;
        if (layoutstyle == '1') {
            let _y = [];
            is.forEach((_i, ii) => {
                let _d = dats[ii];
                let __d = dats.length > ii ? dats[ii + 1] : null;
                _y.push(this.getPrdRenderSections(state, _i, _i, _d, total, total2, anyinvalid, __anyinvalid, () => null, false, true, layoutstyle, __d));
            });
            let z = this.renderMany(100, _y);

            _y.forEach(yy => cartAvail = cartAvail && !yy["dat"].invalid);

            let this_state_selected = this.state.selectedObj[dat.iid];

            var header_text = dat.header_text;
            if (header_text && header_text.startsWith('<|')) {
                header_text = this.injectVars(state, d, header_text, {});
            }

            y.push(
                <MediaCard>
                    {header_text ? <div style={{ padding: '0px 15px 20px 15px', fontSize: 'x-large' }}>{header_text}</div> : null}
                    {z}
                </MediaCard>
            );
        } else if (layoutstyle == '2') {

        } else {
            is.forEach((_i, ii) => {
                let _y = [];
                let _d = dats[ii];
                let __d = dats.length > ii ? dats[ii + 1] : null;
                _y.push(this.getPrdRenderSections(state, _i, _i, _d, total, total2, anyinvalid, __anyinvalid, () => null, false, false, layoutstyle, __d));
                let z = this.renderMany(100, _y);

                _y.forEach(yy => cartAvail = cartAvail && !yy["dat"].invalid);

                y.push(z);
            });
        }

        // The code for this include
        let code = dat.code;

        // the answers matching code value
        let ans_code = rtnObj.codes.find(c => c.id == code);

        // if there are no codes or we found a match
        if (rtnObj.codes.length == 0 || ans_code) {
            // attach the answer data onto the include data so it can be used later.
            dat.ans = ans_code;
            let binding = this.getNested(ans_code, 'binding');


            if (qty && cartAvail) {
                let _qty = parseInt(qty) * d_qty;

                // As long as there is quantity left to add
                // And the suggested part has not been declined
                if (tot < _qty) {
                    if (!dat.declined) {

                        if (dat.type == '2') {
                            this.includespassed = this.includespassed && false;
                        }

                        let unseltitle = dat.unseltitle;
                        let inittemplate = dat.inittemplate;
                        let add1_all = dat.add1_all;
                        let default_add1 = dat.default_add1;
                        let default_all = dat.default_all;

                        let qtytxt = 'Adding ' + (_qty - tot) + (tot == 0 ? '' : ' more') + ' ' + dat.name + ' is recommended.'
                        let notitle = dat.notitle;


                        let addtext = dat.addby1txt;
                        if (tot > 0 && dat.addsubsequenttxt) addtext = dat.addsubsequenttxt;

                        // BUTTONS

                        if (dat.reason && tooltip && false) {
                            this.addAnotherButtons.push(
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>{dat.reason}</React.Fragment>
                                    }
                                >
                                    <Button style={{ margin: '5px', width: '100%' }} className={'green-button'} variant="contained"
                                        onClick={(e) => this.setProfile(inc.id, dat, true, d.id, _qty - tot, e)}>{dat.name} TEST1</Button>
                                </HtmlTooltip>
                            );
                        } else {
                            if (dat.addby1txt) {
                                if (dat.add1_all) {
                                    this.addAnotherButtons.push(
                                        <Button
                                            style={{ margin: '5px', width: '100%' }} className={'green-button'} variant="contained"
                                            onClick={(e) => this.setProfiles(inc.id, dat, true, d.id, 1, e, binding, null,
                                                _qty - tot, unseltitle, inittemplate)}>{addtext}</Button>);
                                } else {
                                    this.addAnotherButtons.push(
                                        <Button
                                            style={{ margin: '5px', width: '100%' }} className={'green-button'} variant="contained"
                                            onClick={(e) => this.setProfile(inc.id, dat, true, d.id, 1, e, binding, null,
                                                unseltitle, inittemplate)}>{addtext}</Button>);
                                }
                            }
                            if (dat.addalltxt) {
                                this.addAnotherButtons.push(<Button
                                    style={{ margin: '5px', width: '100%' }} className={'green-button'} variant="contained"
                                    onClick={(e) => this.setProfile(inc.id, dat, true, d.id, _qty - tot, e)}>{dat.addalltxt}</Button>);
                            }
                            if (dat.type == '2') {
                                this.addAnotherButtons.push(<Button
                                    style={{ margin: '5px', width: '100%' }} className={'green-button'} variant="contained"
                                    onClick={(e) => this.setProfile(inc.id, dat, true, d.id, -1, e)}>{dat.declinetxt}</Button>);
                            }
                        }

                        this.addAnotherVar.push(
                            <React.Fragment>

                                <Grid container spacing={1} style={{ padding: '4px' }}>
                                    <MediaCard
                                        style={{
                                            width: '100%', border: '1px solid black',
                                            padding: '15px', background: 'linear-gradient(45deg, rgba(103,103,103,.5) 5%, rgba(167,167,167,.5) 20%, rgba(85,85,85,.5) 37%, rgba(161,160,160,.5) 55%, rgba(102,102,102,.5) 78%, rgba(212,212,212,.5) 100%)'
                                        }}
                                        title={
                                            notitle ? '' :
                                                default_add1 || default_all ? '' :
                                                    'Adding ' + (_qty - tot) + (tot == 0 ? '' : ' more') + ' ' + dat.name + ' is recommended.'
                                        }
                                        clear={''}
                                        infobox={''}
                                        helpInfo={''}
                                        sch={null}>
                                        {default_all ? this.renderLoadingRing() :
                                            <Grid item xs={12} key={dat.id}>
                                                {dat.reason && tooltip && false ?
                                                    <HtmlTooltip
                                                        title={
                                                            <React.Fragment>{dat.reason}</React.Fragment>
                                                        }
                                                    >
                                                        <Button style={{ width: '100%' }} variant="outlined" className={themeClass}
                                                            onClick={(e) => this.setProfile(inc.id, dat, true, d.id, _qty - tot, e)}>{dat.name} TEST1</Button>
                                                    </HtmlTooltip>
                                                    :
                                                    <div style={{ padding: '5px' }}>
                                                        {!dat.reason ? null :
                                                            <span>
                                                                {dat.reason}<hr />
                                                            </span>
                                                        }
                                                        {!dat.addby1txt ? null :

                                                            dat.add1_all ?
                                                                <Button style={{
                                                                    width: '100%', marginBottom: '5px',
                                                                    backgroundColor: 'white', color: 'black', height: '50px'
                                                                }} variant="outlined"
                                                                    onClick={(e) => this.setProfiles(inc.id, dat, true, d.id, 1, e, binding, null,
                                                                        _qty - tot, unseltitle, inittemplate)}>{addtext}</Button>
                                                                :
                                                                <Button style={{
                                                                    width: '100%', marginBottom: '5px',
                                                                    backgroundColor: 'white', color: 'black', height: '50px',
                                                                }} variant="outlined"
                                                                    onClick={(e) => this.setProfile(inc.id, dat, true, d.id, 1, e, binding, null,
                                                                        unseltitle, inittemplate)}>{addtext}</Button>
                                                        }
                                                        {!dat.addalltxt ? null :
                                                            <Button style={{
                                                                width: '100%', marginBottom: '5px',
                                                                backgroundColor: 'white', height: '50px'
                                                            }} variant="outlined" className={themeButton}
                                                                onClick={(e) => this.setProfile(inc.id, dat, true, d.id, _qty - tot, e)}>{dat.addalltxt}</Button>}
                                                        {dat.type != '2' ? null :
                                                            <Button style={{
                                                                width: '100%', marginBottom: '5px',
                                                                backgroundColor: 'white', height: '50px'
                                                            }} variant="outlined" className={themeButton}
                                                                onClick={(e) => this.setProfile(inc.id, dat, true, d.id, -1, e)}>{dat.declinetxt}</Button>}
                                                    </div>
                                                }

                                            </Grid>
                                        }
                                    </MediaCard>
                                </Grid>
                            </React.Fragment>
                        )
                    } else {

                        let qtytxt = 'Adding ' + (_qty - tot) + (tot == 0 ? '' : ' more') + ' ' + dat.name + ' is recommended.'

                        let notitle = dat.notitle;

                        let undotxt = dat.undotxt || 'undo';

                        this.addAnotherVar.push(
                            <React.Fragment>

                                <Grid container spacing={1} style={{ padding: '4px' }}>
                                    <MediaCard
                                        style={{
                                            width: '100%', border: '1px solid black',
                                            padding: '15px', background: 'linear-gradient(45deg, rgba(103,103,103,.5) 5%, rgba(167,167,167,.5) 20%, rgba(85,85,85,.5) 37%, rgba(161,160,160,.5) 55%, rgba(102,102,102,.5) 78%, rgba(212,212,212,.5) 100%)'
                                        }}
                                        title={notitle ? '' : qtytxt}
                                        clear={''}
                                        infobox={''}
                                        helpInfo={''}
                                        sch={null}>
                                        <Grid item xs={12} key={dat.id}>
                                            {dat.reason && tooltip && false ?
                                                <HtmlTooltip
                                                    title={
                                                        <React.Fragment>{dat.reason}</React.Fragment>
                                                    }
                                                >
                                                    <Button style={{ width: '100%' }} variant="outlined" className={themeButton}
                                                        onClick={(e) => this.setProfile(inc.id, dat, true, d.id, _qty - tot, e)}>{dat.name}</Button>
                                                </HtmlTooltip>
                                                :
                                                <div style={{ padding: '5px' }}>
                                                    {!dat.reason ? null :
                                                        <span>
                                                            {dat.reason}<hr />
                                                        </span>
                                                    }
                                                    {!dat.addby1txt ? null :
                                                        <Button style={{
                                                            width: '100%', marginBottom: '5px',
                                                            backgroundColor: 'white', height: '50px'
                                                        }} variant="outlined" className={themeButton}
                                                            onClick={(e) => this.setProfile(inc.id, dat, true, d.id, 0, e)}>{undotxt}</Button>}
                                                </div>
                                            }

                                        </Grid>
                                    </MediaCard>
                                </Grid>
                            </React.Fragment>
                        )
                    }
                }
            }

            if (this.getStyle(0)) {
                y.push(
                    <React.Fragment>
                        {this.addAnotherVar}
                        <br />
                    </React.Fragment>

                );
            }
        }



        return y.map(x => x);
    }

    /**
     * 
     * @param {any} state
     * @param {any} index
     * @param {any} total
     * @param {any} total2
     * @param {any} __anyinvalid
     * @param {any} anyinvalid
     * @param {any} showcart
     * @param {any} buttons
     */
    renderCheckoutScreen(state, index, total, total2, __anyinvalid, anyinvalid, showcart, buttons) {

        let y = [];

        state.data.forEach((dat, i) => {
            if (i != index && index != -1) return null;
            if (dat.invalid || dat.disabled) { } else {
                y.push(this.getPrdRenderSections(state, index, i, dat, total, total2, anyinvalid, __anyinvalid, buttons, showcart, false));
            }
        });

        let z = this.renderMany2(index, y);

        return (
            <React.Fragment>
                { z}
            </React.Fragment>
        );

        //return (
        //    <React.Fragment>
        //        { this.renderSingle(_dat[0], index, y[0])}
        //    </React.Fragment>
    }

    // Future enhancements
    //test() { return 'hello' }
    //// https://stackoverflow.com/questions/29182244/convert-a-string-to-a-template-string
    //// this is a safe way to create dynamic template strings
    //index(obj, is, value) {
    //    if (typeof is == 'string')
    //        is = is.split('.');
    //    if (is.length == 1 && value !== undefined)
    //        return obj[is[0]] = value;
    //    else if (is.length == 0)
    //        return obj;
    //    else
    //        return this.index(obj[is[0]], is.slice(1), value);
    //}
    //renderString(str, obj) {
    //    return str.replace(/\$\{.+?\}/g, (match) => { return this.index(obj, match) })
    //}


    /**
     * 
     * @param {any} index
     * @param {any} y
     */
    renderMany(index, y) {

        //let selectorWidth = 12;
        //let cartWidth = 0;

        let selectorWidth = 8;
        let cartWidth = 4;

        let selection = y.find(z => z.dat.id == this.state.selectedObj[y[0].dat.iid]);
        let sec_inv = selection ? selection.dat.invalid : false;

        if (y.length == 1 && sec_inv) {
            selectorWidth = 12;
            cartWidth = 0;
        }

        if (y.length > 1 && sec_inv) {
            selectorWidth = 10;
            cartWidth = 2;
        }


        let mc = null;

        let pseudomain = false;
        y[0]?.dat?.configgroup.forEach(x => {
            if (x.mainpseudo) {
                pseudomain = pseudomain || x.mainpseudo;
            }
        });

        //if (!pseudomain) {
            mc = y[0]?.dat?.configgroup.find(c => c.maincomp);
        //} else {
        //    mc = y[0].dat.configgroup.find(c => c.mainpseudo);
        //}

        if (mc && mc.alttitle == 'HIDE') {
            mc = y[0]?.dat?.configgroup.find(c => c.alttitle != 'HIDE')
        }

        let mc_o = null;
        this.getOptionValue2(this.state.data[0]?.id, this.state, mc?.id, (g, o) => {
            mc_o = o;
        })

        // hard-coded warranties, can these be moved elsewhere?
        const ctcWarranty = "This product is proudly backed by the CTC Line&apos;s industry-leading Unconditional Lifetime Warranty. <br /> <br />" +
            "Should this product fail for any reason at any time, CTC will repair or replace the product, free of charge."
        const proWarranty = "This product is proudly backed by the PRO Line&apos;s Lifetime Warranty on Materials and Workmanship. <br /><br />" +
            "Should your PRO Line product fail at any time for reasons related to its construction, CTC will repair or replace your product free of charge.";
        const tmpWarranty = "This product is proudly backed by the TMP Line&apos;s 5 year warranty on materials and workmanship for standard sensors, " +
            "or 3 year warranty on materials and workmanship for all accessories, cables, connectors, custom products, and private - labeled products.";

        // Default to CTC warranty
        let warrantyImgSrc = "https://www.ctconline.com/assets/2018/pcimages/Warranty/ctc-warranty.png";
        let warrantyText = ctcWarranty;

        // Set warranty based on product line theme
        if (themeClass === "pro") {
            warrantyImgSrc = "https://www.ctconline.com/assets/2018/pcimages/Warranty/pro-warranty.png";
            warrantyText = proWarranty;
        } else if (themeClass === "tmp") {
            warrantyImgSrc = "https://www.ctconline.com/assets/2018/pcimages/Warranty/tmp-warranty.png";
            warrantyText = tmpWarranty;
        }

        // If the "Other Text" field if filled in, replace the warranty text with it 
        warrantyText = mc_o.othertext || warrantyText;

        if (index == 0 && !sec_inv && !this.DIAG && 
            (this.state.data[0].name == 'Sensor Beta' || this.state.data[0].name == 'LP Beta' ||
            this.state.data[0].name == 'Vibration Pole' || this.state.data[0].name == 'PXD')
        )
        {
            //const _html = "<b>Example ${sec_inv} string</b>";
            //const html = mc_o.othertext;//_html;//this.renderString(_html);

            return (
                <Grid container spacing={1} style={{ paddingBottom: '10px' }}>
                    <Grid item xs={12} md={8}>
                        <div className="cflex-container" style={{height:'100%'}}>
                            <div className="cflex-item">{y.map(y => y["cartnoimg"])}</div>
                            {/*<div className="cflex-item" style={{ display: 'flex', alignItems: 'start' }}>*/}
                            {/*    <img src={ warrantyImgSrc } style={{ width: '200px', zIndex: '10' }} />*/}
                            {/*    <MediaCard className="summary-area sselected" style={{ marginLeft: '-6px', marginTop: '10px', fontSize: '12px' }}>*/}
                            {/*        <p>{ReactHtmlParser(warrantyText)}</p>*/}
                            {/*    </MediaCard>*/}
                            {/*</div>*/}
                        </div>
                    </Grid>
                    <Grid item xs={12} md={4} style={{ zIndex: '1' }}>
                        {y.map(y => y["imagestacked"])}
                    </Grid>
                    {y.map(y => index == 0 && cartWidth != 0 ? y["leadinquestions"] : null)}
                </Grid>
            );
        }

        return (
            <React.Fragment>

                {index != 0 ? null :
                    y.map(y =>
                        <div className="flex-container" key={y.dat.id}>
                            <div className="flex-item">Know&nbsp;your&nbsp;Part&nbsp;Number? Type&nbsp;it&nbsp;here:</div>
                            <div className="flex-item"><Input style={{ width: '100%' }} value={y["dat"].know} onChange={(e) => this.setKnow(y["dat"], e.target.value)} /></div>
                            <div className="flex-item"><Button className={themeButton} onClick={(e) => this.handelKnowPN(y["dat"])}>Submit</Button></div>
                        </div>)}

                {index == -1 ? null : y.map(y => y["imageflat"])}

                <Grid container spacing={1} style={{ paddingBottom: '10px' }}>

                    {/*As long as we arent on the confirm screen show the selector and diagnostic*/}
                    {index == -1 ? null :
                        <Grid item sm={selectorWidth} style={{ zIndex: '1' }}>
                            {y.map(y => {
                                return (
                                    <div key={index}>
                                        {y["selector"]}
                                        {y["diagnostic"]}
                                    </div>
                                );
                            }
                            )}



                        </Grid>
                    }

                    {/*Adjust the size of the cart view based on the screen*/}
                    {cartWidth == 0 ? null :
                        <React.Fragment>

                            <Grid id="ctcpccart" item sm={cartWidth} className={'summary-grid transitions'}>

                                {y.map(y => {
                                    return (
                                        <React.Fragment key={index}>
                                            {!sec_inv ? y["cart"] : y["cartsmall"]}
                                            {index == 100 && !sec_inv ? y["leadinquestions"] : null}
                                        </React.Fragment>
                                    );
                                })}
                            
                            </Grid>

                            {/*Warranty box*/}
                            {/*<Grid item sm={selectorWidth} className="summary-grid">*/}
                            {/*    <div style={{ paddingTop: '1em', display: 'flex', alignItems: 'start' }}>*/}
                            {/*        <img src={warrantyImgSrc} style={{ width: '200px', zIndex: '10' }} />*/}
                            {/*        <MediaCard className="summary-area sselected" style={{ marginLeft: '-6px', marginTop: '10px', fontSize: '12px' }}>*/}
                            {/*            <p>{ReactHtmlParser(warrantyText)}</p>*/}
                            {/*        </MediaCard>*/}
                            {/*    </div>*/}
                            {/*</Grid>*/}

                        </React.Fragment>
                    }

                    {/*As long as we are on the confirm screen show the right aligned picture*/}
                    {index == -1 ?
                        <Grid item sm={3} style={{ zIndex: '1' }}>
                            {y.map(y => y["imagestacked"])}
                        </Grid>
                        : null
                    }
                </Grid>
                {y.map(y => index == 0 && cartWidth != 0 ? y["leadinquestions"] : null)}
            </React.Fragment>
        );
    }

    /**
     * 
     * @param {any} index
     * @param {any} y
     */
    renderMany2(index, y) {

        let hasImages = false;
        let adtlparts = [];
        y.forEach(y => {
            if (y["imagestacked"]) {
                y["imagestacked"].forEach(is => {
                    //if (is) hasImages = true;
                });
            }

            let _parts = [];
            addToCart(y.dat.partnum, y.dat.qty, y.dat.id, y.dat.parent, _parts);

            if (_parts.length > 1) {
                _parts.forEach((p, i) => {
                    if (i != 0) {
                        let adtlpart = {};
                        let arp = p.split(':');
                        adtlpart.name = arp[0];
                        adtlpart.dtl = null;
                        adtlparts.push(adtlpart);
                    }
                });
            }
        });

        let changed = false;
        let state_extraparts = this.state.extraparts;
        if (!state_extraparts) {
            changed = true;
            this.setState(((s, p) => {
                return { extraparts: adtlparts };
            }));
        } else
        {
            let newpart = false;
            let newextraparts = state_extraparts
            adtlparts.forEach(a => {
                let px = newextraparts.find(e => e.name == a.name);
                if (!px) {
                    newextraparts.push(a);
                    newpart = true;
                }
            });
            if (newpart) {
                changed = true;
                this.setState(((s, p) => {
                    return { extraparts: newextraparts };
                }));
            }
        }
        if (changed) return null;

        state_extraparts.forEach(ex => {
            if (!ex.loading && !ex.dtl)
            {
                changed = true;
                ex.loading = true;

                var myHeaders = new Headers();
                myHeaders.append("content-type", "application/json;charset=UTF-8");
                var raw = "{\"id\":\"053d341b-f56b-12ae-663b-2b9a47fa5a80\",\"partnumber\":\"" + ex.name +"\"}";
                var requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: raw,
                    redirect: 'follow'
                };
                fetch("https://portal.ctconline.com/api/PartCreatorImpl", requestOptions)
                    .then(async response => {
                        let rtext = await response.text();
                        let dtl = JSON.parse(rtext);

                        try {
                            let pn = dtl[0].partnumber;
                            let cc = 0;
                            if (pn) {
                                this.setState(((s, p) => {
                                    var v = s.extraparts.find(sex => sex.name == pn)

                                    if (!v) {
                                        v = s.extraparts.find(sex => sex.name == ex.name)
                                        v.error = true;
                                        return { extraparts: s.extraparts };
                                    }

                                    v.dtl = dtl;
                                    return { extraparts: s.extraparts };
                                }));
                            }
                        } catch (e) { console.log(e); }
                    })
                    .then(result => console.log(result))
                    .catch(error => console.log('error', error));

            }
        });

        if (changed) {
            this.setState(((s, p) => {
                return { extraparts: state_extraparts };
            }));
        }
        if (changed) return null;



        return (
            <React.Fragment>

                <Grid id="ctcpccart" container spacing={1}>

                    {y.map(yx => {
                        let _parts = []; addToCart(yx.dat.partnum, yx.dat.qty, yx.dat.id, yx.dat.parent, _parts);

                        return (
                            <React.Fragment>
                                {/*Adjust the size of the cart view based on the screen*/}
                                <Grid item sm={!hasImages ? 12 : 9} className={'summary-grid transitions'}>
                                    {yx["cart2"]}

                                    {_parts.length == 0 ? null : _parts.map((p, i) => {
                                        let arp = p.split(':');
                                        if (i == 0) return;

                                        let px = state_extraparts.find(ex => ex.name == arp[0]);

                                        if (px.dtl) {
                                            let _px = px.dtl[0];
                                            _px.prodcode = _px.type
                                            _px.partnum = _px.partnumber
                                            _px.qty = parseFloat(arp[1]);
                                            this.calcDiscounts2(_px, parseFloat(_px.price))
                                        }

                                        return (<React.Fragment key={i}>
                                            {!px.dtl ? this.renderCartItem({ partnum: arp[0] }, true, px.error) : this.renderCartItem(px.dtl[0])}
                                        </React.Fragment>);
                                     })}

                                </Grid>

                                {/*As long as we are on the confirm screen show the right aligned picture*/}
                                {!hasImages ? null :
                                    < Grid item sm={3} style={{ zIndex: '1' }}>
                                        {yx["imagestacked"]}
                                    </Grid>
                                }
                            </React.Fragment>
                        );
                    })}
                </Grid>
            </React.Fragment>
        );
    }

    renderCartItem(dat, loading, error)
    {
        let block_qty = true;
        let _partdesc = dat.description;
        let _anyinvalid = false;
        let __anyinvalid = false;
        let _invalidMsg = false;

        if (error) {
            return (
                <MediaCard style={{ border: '1px solid black' }}
                    className={'summary-area'}>
                    <div style={{ fontWeight: 'bold', paddingBottom: '15px' }}>
                        {dat.partnum} - Error could not build - Contact CTC<br />&nbsp;
                    </div>
                </MediaCard>
            );
        }

        if (loading) {
            return (
                <MediaCard style={{ border: '1px solid black' }}
                    className={'summary-area'}>
                    <div style={{ fontWeight: 'bold', paddingBottom:'15px' }}>
                        {dat.partnum} - Loading<br />&nbsp;
                    </div>
                </MediaCard>
            );
        }

        let curr = this.curr;
        let symbol1 = curr.symbolBeforeAmount ? curr.symbol : '';
        let symbol2 = curr.symbolBeforeAmount ? '' : ' ' + curr.symbol;
        let mult = curr.cconversion;
        let iso = curr.isoCode;
        let txtDisp = iso == 'USD' ? 'none' : '';
        let astrix = iso == 'USD' ? '(USD) ' : '(*'+iso+') ';

        let dat_places = curr.decimalPlaces;

        let dat_price = fixedTo(dat.price, dat_places);
        let dat_qtydisc = fixedTo(dat.qtydisc, dat_places);
        let dat_flatdisc = fixedTo(dat.flatdisc, dat_places);
        let dat_final = fixedTo(dat.price - dat.qtydisc - dat.flatdisc, dat_places);
        let dat_total = dat_final * dat.qty;

        let outprice_us = "(USD) $" + fixedTo(dat_price, 2);
        let outqdisc_us = "(USD) $" + fixedTo(dat_qtydisc, 2);
        let outfdisc_us = "(USD) $" + fixedTo(dat_flatdisc, 2);
        let outfinal_us = "(USD) $" + fixedTo(dat_final, 2);
        let outtotal_us = "(USD) $" + fixedTo(dat_total, 2);

        dat_price = dat_price * mult;
        dat_qtydisc = dat_qtydisc * mult;
        dat_flatdisc = dat_flatdisc * mult;
        dat_final = dat_final * mult;
        dat_total = dat_total * mult;

        // Calculate the price
        let outprice = astrix + symbol1 + fixedTo(dat_price, dat_places) + symbol2;
        let outqdisc = astrix + symbol1 + fixedTo(dat_qtydisc, dat_places) + symbol2;
        let outfdisc = astrix + symbol1 + fixedTo(dat_flatdisc, dat_places) + symbol2;
        let outfinal = astrix + symbol1 + fixedTo(dat_final, dat_places) + symbol2;
        let outtotal =
            astrix + symbol1 + fixedTo(dat_total, dat_places) + symbol2;

        return (
            <MediaCard style={{ border: '1px solid black' }}
                className={'summary-area'}>
                <div style={{ fontWeight: 'bold' }}>
                    {dat.partnum}
                </div>
                <div>
                    {_partdesc ?
                        <div style={{ marginBottom: '15px', fontSize: '12px' }}>
                            {_partdesc}
                        </div> : null}
                    {!this.showprices ? null :
                        (_anyinvalid || __anyinvalid || _invalidMsg ? null :
                            <React.Fragment>
                                <Grid container spacing={0} style={{ borderTop: '1px solid gray' }}>
                                    <Grid item xs>Price</Grid>
                                    <Grid item xs style={{ textAlign: 'right' }}>
                                        {outprice_us}<br />
                                        <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outprice}</span>
                                    </Grid>
                                </Grid>
                                {dat.qtydisc === 0 ? null :
                                    <Grid container spacing={0}>
                                        <Grid item xs>PL Discount</Grid>
                                        <Grid item xs style={{ textAlign: 'right' }}>
                                            {outqdisc_us}<br />
                                            <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outqdisc}</span>
                                        </Grid>
                                    </Grid>
                                }
                                {dat.flatdisc === 0 ? null :
                                    <Grid container spacing={0}>
                                        <Grid item xs>Flat Discount</Grid>
                                        <Grid item xs style={{ textAlign: 'right' }}>
                                            {outfdisc_us}<br />
                                            <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outfdisc}</span>
                                        </Grid>
                                    </Grid>
                                }
                                {dat.flatdisc === 0 && dat.qtydisc === 0 ? null :
                                    <Grid container spacing={0}>
                                        <Grid item xs style={{ fontWeight: 'bold' }}>Your Price</Grid>
                                        <Grid item xs style={{ textAlign: 'right' }}>
                                            {outfinal_us}<br />
                                            <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outfinal}</span>
                                        </Grid>
                                    </Grid>
                                }
                            </React.Fragment>
                        )
                    }
                </div>

                <Grid container spacing={0} style={{
                    //borderBottom: '1px solid gray',
                    paddingBottom: '15px'
                }}>
                    {!this.showprices ?
                        (!this.request && !this.quote && !this.order ? null :
                            <>
                                <Grid item xs style={{ fontWeight: 'bold' }}>
                                    Qty:{dat.qty}
                                </Grid>

                                <Grid item xs style={{ fontWeight: 'bold', textAlign: 'right' }}>
                                    {this.props_showmsg ? "Please login to view pricing" : null}
                                </Grid>
                            </>
                        )
                        :
                        <React.Fragment>
                            <Grid item xs style={{ fontWeight: 'bold' }}>
                                Qty:{dat.qty}
                            </Grid>

                            <Grid item xs style={{ textAlign: 'right' }}>
                                Total: {outtotal_us}<br />
                                <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outtotal}</span>
                            </Grid>

                            {/*<Grid item xs={12} style={{ fontSize: '65%', textAlign: 'right' }}>
                                *Prices do not include duties, taxes & shipping
                            </Grid>*/}

                        </React.Fragment>
                    }
                </Grid>
            </MediaCard>);
    }

    //#endregion

    //#region Supporting Rendering
    /**
     * 
     * @param {any} state
     * @param {any} d
     * @param {any} total
     * @param {any} total2
     * @param {any} __anyinvalid
     * @param {any} anyinvalid
     * @param {any} rtnObj
     */
    renderLeadInQuestions(state, d, rtnObj) {
        rtnObj.hasLQ = false;
        let y = [];

        let _defaults = '';
        let defaults = [];

        let _leadInQuestions = '';
        let _leadInAnswers = '';
        let _leadInAnswerCodes = '';

        let leadInQuestions = [];
        let leadInAnswers = [];
        let leadInAnswerCodes = [];

        if (d.name == "Sensor Beta" || d.name == "LP Beta" ||
            d.name == "Vibration Pole" || d.name == "PXD") {

            _defaults = `{
                "magnettypes":"MAGFLAT,MAGCURVED,MHQUICK,MHFINS,MHPROBES,MHPADS,MHSTUDS,MHBOLTS,MHSPECIALTY,MHZERK",
                "magnetparts":"",
                "boxtypes":"",
                "boxparts":"",
                "acctype":"TOOLS,DATADAPTER,ADAPTERS,ADHESIVES,MHKITS,MHPROTECT,BARRIERS",
                "accpart":"",
                "betype":"BARRIERENC",
                "bepart":"",
                "batype":"BARRIERS",
                "bapart":""
            }`;

            try {
                defaults = JSON.parse(_defaults);
            } catch { }

            _leadInAnswerCodes = d.lead_in_answer_codes;

            _leadInAnswers = d.lead_in_answers;

            _leadInQuestions = d.lead_in_questions;
        }

        if (_leadInQuestions) {
            let _lq = this.injectVars(state, d, _leadInQuestions, defaults);//.injectVars(_leadInQuestions);
            let _lan = this.injectVars(state, d, _leadInAnswers, defaults);//.injectVars(_leadInQuestions);
            let _lac = this.injectVars(state, d, _leadInAnswerCodes, defaults);//.injectVars(_leadInQuestions);

            try {
                leadInQuestions = JSON.parse(_lq);
                leadInAnswers = JSON.parse(_lan);
                leadInAnswerCodes = JSON.parse(_lac);
            } catch (e) {
                console.log(_lac);
                throw (e);
            }

            if (leadInQuestions.length > 0) {
                rtnObj.hasLQ = true;
                // Filter the lead in questions based on 
                // product selection
                leadInQuestions = leadInQuestions.filter(e => {
                    let rtn = true;
                    e.conditions.forEach(ce => {
                        if (ce.conditiono == 'includes') {
                            rtn = rtn && d[ce.conditionf].includes(ce.conditionv);
                        }
                        if (ce.conditiono == '!includes') {
                            rtn = rtn && !d[ce.conditionf].includes(ce.conditionv);
                        }
                        if (ce.conditiono == 'startswith') {
                            rtn = rtn && d[ce.conditionf].startsWith(ce.conditionv);
                        }
                        if (ce.conditiono == 'startswithlist') {
                            let _rtn = false;
                            let args = ce.conditionv.split(',');
                            args.forEach(a => {
                                _rtn = _rtn || d[ce.conditionf].startsWith(a);
                            });
                            rtn = rtn && _rtn;
                        }
                        if (!ce.conditiono) {
                            rtn = rtn && true;
                        }
                        if (ce.conditiono == 'endswith') {
                            rtn = rtn && d[ce.conditionf].endsWith(ce.conditionv);
                        }
                        if (ce.conditiono == 'endswithlist') {
                            let _rtn = false;
                            let args = ce.conditionv.split(',');
                            args.forEach(a => {
                                _rtn = _rtn || d[ce.conditionf].endsWith(a);
                            });
                            rtn = rtn && _rtn;
                        }

                        if (ce.conditiono == 'shortcode') {
                            let _rtn = false;
                            let args = ce.conditionv;
                            this.getOptionValueWithSC(state.data[0].id, state, ce.conditionf, (g, o)=> {
                                if (o.name == args) _rtn = true;
                            });
                            rtn = rtn && _rtn;
                        }

                        if (!ce.conditiono) {
                            rtn = rtn && true;
                        }
                    });
                    return rtn;
                });

                // if there were no options, return else
                if (leadInQuestions.length == 0)
                {
                    leadInQuestions = leadInQuestions.filter(e => {
                        let rtn = true;
                        e.conditions.forEach(ce => {
                            if (ce.conditiono == 'else') {
                                rtn = rtn && d[ce.conditionf].includes(ce.conditionv);
                            }
                        });
                        return rtn;
                    });
                }

                // filter to get only the first set of questions
                leadInQuestions = leadInQuestions.filter((e, i) => i == 0);

                // Write the questions to the screen
                leadInQuestions.forEach(lq => {

                    if (lq.answerids) {
                        lq.answerids.forEach(lid => {
                            if (Array.isArray(leadInAnswers)) {
                                let newans = leadInAnswers.find(lia => lia._id == lid);
                                if (newans) lq.answers.push(newans);
                            }
                        });
                    }

                    lq.answers.forEach(a => {
                        if (a.codeids) {
                            a.codeids.forEach(cid => {
                                if (Array.isArray(leadInAnswerCodes)) {
                                    let newcode = leadInAnswerCodes.find(liac => liac._id == cid);
                                    if (newcode) a.codes.push(newcode);
                                }
                            });
                        }
                    });

                    let answer = d.leadInQuestions ? d.leadInQuestions[lq.id] || '' : '';
                    rtnObj.ans = answer;

                    let lqimage = 'https://ctconline.com/assets/2018/pcimages/overview-button-image.png';
                    if (lq.image) lqimage = 'https://ctconline.com/assets/2018/pcimages/'+lq.image;

                    y.push(
                        <Card spacing={1} className={'main-selector'} style={{
                            border: '1px solid black',
                            marginBottom: '15px'
                        }}>
                            <CardContent style={{ padding: '5px' }}>

                                <Grid item sm={12}>
                                    <MediaCard title={lq.question}
                                        clear={(e) => this.answerLeadInQuestions(lq.id, d.id, '')}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <img src={lqimage} style={{ width: '90%' }} />
                                        </div>
                                        <div style={{ padding: '15px' }}>{lq.info}</div>
                                        <div style={{ padding: '0 15px 15px 15px' }}>{lq.info2}</div>
                                        <Grid container spacing={1}>
                                            {lq.answers.map(a => {
                                                let disabled = a.id != answer && answer != '';
                                                let icon = a.text === "Permanent" ? "PermanentMonitoring.png" :
                                                    a.text === "Portable" ? "PortableMeasurement.png" :
                                                        "ShoppingCart.png";
                                                let iconPath = "https://ctconline.com/assets/2018/pcimages/Icons/" + icon;

                                                let cols = Math.floor(12 / lq.answers.length);

                                                return (
                                                    <Grid item xs={12} md={cols} key={a.id} style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'stretch'
                                                    }}>
                                                        {disabled ? null :
                                                            <ActionCard onClick={(e) => this.answerLeadInQuestions(lq.id, d.id, a.id)}
                                                                selected={a.id == answer}
                                                                title={
                                                                    <span>
                                                                        <img src={iconPath} style={{ width: '30px', marginRight: '1em' }} />
                                                                        {a.text}
                                                                    </span>
                                                                }
                                                                disabled={disabled}
                                                                role='lead-in'
                                                                theme={themeClass}>
                                                            </ActionCard>
                                                        }
                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </MediaCard>
                                </Grid>
                            </CardContent>
                        </Card>
                    );
                });
            }
        }

        // This block of code evaluates the 'when' clauses of the override
        // variables - this is been used to target specific connectors when a specific sensor is selected for the 
        // virbration pole.
        leadInQuestions.forEach(y => {
            y.answers.forEach(z => {
                z.codes?.forEach(w => {
                    w.ovr.forEach(x => {
                        x.configs?.forEach(v => {
                            let when = "";
                            if (v?.when) {
                                when = v.when;
                                let winc = when.split(':')[0];
                                if (winc) {
                                    let wpn = when.split(':')[1]?.split(',');

                                    let seid = state.data[0].includes.find(i => i.code == winc)?.id;
                                    let sepn = state.data.find(x => x.iid == seid)?.partnum;

                                    let cable = state.data[0].includes.find(i => i.code == w.id);
                                    let data_cable = state.data.find(d => d.iid == cable.id);
                                    let data_cable_cg = data_cable?.configgroup.find(cg => cg.shortcode == x.group);
                                    if (data_cable && data_cable_cg && !state.selections[data_cable.id + '_' + data_cable_cg.id]) {

                                        let val = data_cable_cg.configs?.find(cg => {
                                            let _wpn = cg.when?.split(':')[1]?.split(',');
                                            return _wpn.includes(sepn);
                                        });
                                        if (val) {
                                            this.handleClick(data_cable.id, data_cable_cg.id, val.id);
                                        }
                                    }
                                }
                            }
                        });
                    });
                });
            });
        });

        // make sure there is at least something selected
        // if not dont continue
        leadInQuestions.forEach(e => {
            if (!d.leadInQuestions || !d.leadInQuestions[e.id]) {
                rtnObj.cont = false;
            }
        });

        // check the continue property of the selection
        leadInQuestions.forEach(e => {
            if (d.leadInQuestions && d.leadInQuestions[e.id]) {
                let ans = e.answers.find(a => a.id == d.leadInQuestions[e.id]);
                rtnObj.cont = ans.cont;
                rtnObj.codes = ans.codes;
            }
        });

        this.steps = ['Configure Your Part', 'Recommendations'];
        this.steps_iid = [];
        if (state.data[0].includes[0].cpcprofile == "NA") this.steps = ['Configure Your Part'];

        includesFilter(state, d).forEach(dat => {
            // The code for this include
            let code = dat.code;

            // the answers matching code value
            let ans_code = rtnObj.codes.find(c => c.id == code)

            // if there are no codes or we found a match
            if (ans_code) {
                this.steps.push(dat.name);
                this.steps_iid.push(dat.id);
            }


        });
        this.steps.push("Finish");

        // If we shouldnt continue just show the lead in questions
        //if (!cont) {
        return y;
        //}
    }

    /**
     * 
     * @param {any} dat
     * @param {any} this_state_selected
     * @param {any} state
     * @param {any} useselected
     */
    renderSelector(dat, this_state_selected, state, useselected) {

        let binding = this.props_binding;
        if (dat.idat.binding) {
            binding = dat.idat.binding;
        }
        
        return (
            dat.id != this_state_selected && useselected ? null :

                <Card spacing={1} className={'main-selector'} style={{ border: '1px solid black', height:'100%' }}>
                    <CardContent style={{ padding: '5px' }}>
                        <Grid item sm={12}>
                            {dat.iname ? <h4 style={{ paddingTop: '15px' }}>{dat.iname}</h4> : null}
                        </Grid>

                        
                        <Grid item sm={12}>
                            <FetchGroups id={dat.id} data={dat}
                                pc={this.props_pc}
                                parts={this.props_parts}
                                filt={this.props_filt}
                                binding={binding}
                                tags={this.props_tags}
                                cols={this.props.cols}
                                selections={state.selections}
                                _selections={state._selections}
                                template={dat.parttemp}
                                comptemplate={dat.ctemplate}
                                colstemplate={dat.colstemp}
                                onClick={(g, i) => this.handleClick(dat.id, g, i)}
                                textChange={(g, i) => this.textChange(dat.id, g, i)}
                                textBlur={(g, i) => this.textBlur(dat.id, g, i)}
                                schChg={(i, v) => this.schChg(dat.id, i, v)}
                                clear={(i, v) => (this.state.data[0].id == dat.id) ? this.clear(dat.id, i, v) : this.refPart(dat) }
                                tagsChg={(i, v) => this.tagsChg(dat.id, i, v)}
                                tagsDel={(i, v) => this.tagsDel(dat.id, i, v)}
                                theme={themeClass}
                            />

                        </Grid>
                    </CardContent>
                </Card>
        );
    }

    /**
     * 
     * @param {any} state
     * @param {any} total
     * @param {any} total2
     */
    renderDiagnostic(state, total, total2) {
        return (!this.DIAG ? null :
            <div>
                <table cellPadding="5" style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td>Name</td>
                            <td>Short Code</td>
                            <td>Option</td>
                            <td>Step</td>
                            <td>Qty</td>
                            <td>Price</td>
                            <td style={{ textAlign: 'right' }}>Total</td>
                        </tr>
                        {state.data.map((dat, i) =>
                            dat.priceinfo &&
                            dat.priceinfo.map((pi) => {

                                let pi_tot_price = dat.priceinfo2.length > 0 ? 0 : pi.tot_price;

                                total += pi_tot_price;

                                return (<>
                                    <tr key={pi.shortcode}>
                                        <td>{pi.property}</td>
                                        <td>{pi.shortcode}</td>
                                        <td>{pi.option}</td>
                                        <td>{pi.procstep}</td>
                                        <td>{pi.qty + ''}</td>
                                        <td>{pi.price + ''}</td>
                                        <td style={{ textAlign: 'right' }}>{pi_tot_price + ''}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7">{pi.gid} | {pi.bl}<hr /></td>
                                    </tr>
                                    </>
                                )
                            })
                        )}
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style={{ textAlign: 'right' }}>{total}</td>
                        </tr>
                    </tbody>
                </table>

                {state.data.map((dat, i) =>
                    <React.Fragment key={i}>
                        {!dat.priceinfo2 || dat.priceinfo2.length == 0 ? null :
                            <table cellPadding="5" style={{ width: '100%' }}>
                                <tbody>
                                    <tr>
                                        <td>Note</td>
                                        <td style={{ textAlign: 'right' }}>Total</td>
                                    </tr>

                                    {
                                        dat.priceinfo2.map((pi) => {
                                            total2 += pi.price;

                                            return (
                                                <tr>
                                                    <td>{pi.note}</td>
                                                    <td style={{ textAlign: 'right' }}>{pi.price}</td>
                                                </tr>
                                            )
                                        })
                                    }

                                    <tr>
                                        <td></td>
                                        <td style={{ textAlign: 'right' }}>{total2}</td>
                                    </tr>
                                </tbody>
                            </table>
                        }
                    </React.Fragment>
                )}
            </div>
        );
    }

    /**
     * 
     * @param {any} s
     * @param {any} index
     * @param {any} pos
     */
    renderImage(s, index, pos) {
        return (s.data.map((dat, i) => {

            if (i != index && index != -1) return null;

            let x = 0;
            //let mc = dat.configgroup.filter(c => c.maincomp)[0];
            let mc = dat.configgroup.find(c => c.maincomp);
            if (mc && mc.alttitle == 'HIDE') {
                //mc = dat.configgroup.filter(c => c.alttitle != 'HIDE')[0]
                mc = dat.configgroup.find(c => c.alttitle != 'HIDE');
            }

            let v = s.selections[dat.id + '_' + mc.id];
            let isMainFilled = v;

            let this_state_selected = this.state.selected;
            this_state_selected = dat.id;

            let _renderTemplate = ''


            if (s.data[0].name == "Cable" ||
                s.data[0].name == "Sensor" ||
                s.data[0].name == "LP Sensor" ||
                s.data[0].name == "LP Sensor v2") {
                _renderTemplate = `{
                    "position":"1",
                    "style":"linear",
                    "template":[
                        {"name":"Sensor"},
                        {"name":"Connector 1"},
                        {"name":"Color Coding", "width":"75px", "height":"11px", "pheight":"27px"},
                        {"name":"Cable","style":"bgfill","size":"2"},
                        {"name":"Safety Feature"},
                        {"name":"Cable","style":"bgfill","size":"1"},
                        {"name":"Cable","style":"bgfill","size":"2"},
                        {"name":"Color Coding", "width":"75px", "height":"11px", "pheight":"27px","rot":"180"},    
                        {"name":"Connector 2","rot":"180"}, 
                        {"name":"Connector","rot":"180"}
                    ]}`;// #CA.limg #CA.px
            }

            if (s.data[0].name == "WS") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"WS","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }

            if (s.data[0].name == "Sensor" ||
                s.data[0].name == "Sensor Beta") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"Sensor","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }

            if (s.data[0].name == "LP Sensor" ||
                s.data[0].name == "LP Beta" ||
                s.data[0].name == "LP Sensor v2") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"LP","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }

            if (s.data[0].name == "Box") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"Enclosure Type","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }

            if (s.data[0].name == "Relay System") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"Enclosure Type","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }

            if (s.data[0].name == "SCE" || s.data[0].name == "SCE Copy") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"Size and Material","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }

            if (s.data[0].name == "PXD" || s.data[0].name == "SCD Copy") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"Material","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }


            if (s.data[0].name == "DM7200 Prox Mount" || s.data[0].name == "DM7200 Prox Mount") {
                _renderTemplate = `{
                    "position":"2",
                    "style":"stacked",
                    "template":[
                        {"name":"Mount","style":"bgfill"}
                    ]}`;// #CA.limg #CA.px
            }

            let _c1 = {}; this.getOptionValueWithSC(dat.id, s, "C1", (g, o) => { _c1 = o; });

            let jRenderTemplate = { position: 0 };
            if (_renderTemplate) {
                jRenderTemplate = JSON.parse(_renderTemplate);
            }

            let _pos = pos; if (_pos && _pos == '3') _pos = '1';
            if (jRenderTemplate.position != _pos) {
                return null;
            }

            let cbg = '';
            let renimage = '';
            let prelayers = {};
            let layers = [];
            if (dat.renderinfo && jRenderTemplate.template) {
                jRenderTemplate.template.forEach(a => {
                    dat.renderinfo.filter(x => x.property == a.name).forEach((pi) => {
                        let style = a.style ? a.style : 'NA';

                        renimage = pi.renimage;
                        let _image = '';
                        if (renimage == 'On' || this.IMGDIAG) {

                            if (style == 'bgfill') {
                                cbg = pi.image;

                                if (pi.layers) {
                                    try {
                                        if (pi.layers.startsWith('{')) {
                                            let view = dat.ImageView;;
                                            prelayers = JSON.parse(pi.layers);
                                            layers = prelayers[view];
                                            if (!layers) layers = prelayers[Object.keys(prelayers)[0]];
                                        }
                                        else {
                                            layers = JSON.parse(pi.layers);
                                            let q = 0;
                                        }
                                    } catch (e) {
                                        let err = e;
                                    }
                                }
                            }
                        }
                    });
                });
                //if (!(cbg == 'On' || this.IMGDIAG)) return null;


                let basefolder = 'https://www.ctconline.com';

                let rs = String.fromCharCode(30);

                if (jRenderTemplate.style == "stacked") {

                    let _layers = []
                    layers.forEach(e => {

                        let evals = e.val.replaceAll('\'', '').split(',');

                        // match the short code of the current selected PC option (I.E. box large / small)
                        let opt = this.getRenderInfoShortCode(dat, e.sc)

                        if (evals.includes(opt.option)) {

                            cbg = '/assets/2018/XFER/' + e.img;

                            if (!e.layers) e.layers = [];

                            // for each of the layers defined on the option
                            e.layers.forEach(l => {

                                // get other short codes that will activate this layer
                                let scs = [];
                                if (l.sc) scs = l.sc.replaceAll('\'', '').split(',');
                                let bcs = [];
                                if (l.bc) bcs = l.bc.replaceAll('\'', '').split(',');

                                // get the values of those other short codes that will activate this layer
                                // this block will convert the possible values to js array sets
                                // (I.E. "4,['A','B','C','E'] will become ['4'],['A','B','C','E']")
                                let values = l.values.map(v => {
                                    v = v.replaceAll('\'', '');
                                    v = v.replace(/,(?=[^\[\]]*\])/g, rs);
                                    v = v.replaceAll('[', '').replaceAll(']', '');
                                    let _v = v.split(',');
                                    return _v.map(w => w.split(rs));
                                }) || [];


                                // the final result starts as false, and will go true as soon
                                // as at least one condition is true.
                                let rslt = false;

                                // for each of the matching possiblities
                                values.forEach((value, i) => {

                                    // this variable is to tally the truth of each condition.
                                    // for to code to result in true, both conditions must be true.
                                    // as soon as a false is encountered the variable goes to false.
                                    let _rslt = true;

                                    // the scs must have at least 1 entry
                                    if (scs.length > 0) {

                                        // loop each foreign short code
                                        scs.forEach((sc, j) => {

                                            // get the value of the foreign short code
                                            let _opt = this.getRenderInfoShortCode(dat, sc);
                                            let fval = _opt.option;

                                            // check it the foreign value is valid
                                            if (value[j] && value[j].includes(fval)) {
                                                // Nothing, leave the true alone
                                            } else {
                                                // if the sc value does not match
                                                _rslt = false;
                                            }
                                        });
                                    } else {
                                        // if there were no scs
                                        // the bcs must have at least 1 entry
                                        if (bcs.length > 0) {
                                            let _rslt2 = true;

                                            // loop each BLOCKED short code
                                            bcs.forEach((sc, j) => {
                                                // get the value of the foreign short code
                                                let _opt = this.getRenderInfoShortCode(dat, sc);
                                                let fval = _opt.option;

                                                // check it the foreign value is valid
                                                if (value[j] && value[j].includes(fval)) {
                                                    // Nothing, leave the true alone
                                                } else {
                                                    // if the sc value does not match
                                                    _rslt2 = false;
                                                }
                                            });

                                            // the block list works just like the allow list just exact opposite.
                                            _rslt = !_rslt2;
                                        } else {
                                            // if are no SCs to match
                                            _rslt = false;
                                        }

                                    }

                                    // at the level above, the final result will be
                                    // a valid match to any of the conditions listed.
                                    rslt = rslt || _rslt;
                                });

                                // finally push the 'activate' result up to the layer
                                l.v = rslt;
                            });
                            _layers = e.layers;
                        }
                    })

                    let filename = cbg && cbg.split('.')[0];

                    let output = '';
                    _layers.forEach(e => {
                        output = (e.v ? `url('` + basefolder + filename + '/' + e.img + `'),` : ``) + output
                    });

                    if (!cbg) return null;
                    return (
                        <React.Fragment>
                            <div style={{
                                width: '100%',
                                backgroundSize: '100%',
                                paddingBottom: '100%',
                                backgroundImage: output + `
				        url('` + basefolder + cbg + `')`
                            }}></div>

                            <div style={{ textAlign: 'center', marginTop: '10px', marginBottom: '10px' }}>Views:<br />
                                {Object.keys(prelayers).map(x => {
                                    let obj = prelayers[x];
                                    return (
                                        <React.Fragment>
                                            <Button variant="outlined" className={themeButton} size="small"
                                                style={{ marginTop: '5px', marginRight: '5px' }}
                                                onClick={(e, v) => this.setImageView(e, v, index, x)}>
                                                {x}
                                            </Button>
                                        </React.Fragment>
                                    );
                                }
                                )}
                            </div>
                        </React.Fragment>
                    );

                }
                else {
                    let cable_info = dat.renderinfo.find(e => e.shortcode == 'CB');
                    let con1 = dat.renderinfo.find(e => e.shortcode == 'C1')?.option;
                    let con2 = dat.renderinfo.find(e => e.shortcode == 'C2')?.option;
                    let alen = dat.renderinfo.find(e => e.shortcode == 'A')?.option;
                    let clen = dat.renderinfo.find(e => e.shortcode == 'L')?.option;
                    let cc = dat.renderinfo.find(e => e.shortcode == 'C')?.option;
                    let sf = dat.renderinfo.find(e => e.shortcode == 'SF')?.option;
                    let sfflip = false;

                    // Regular expression pattern
                    let pattern = /^[Cc]\d+$/;

                    // Test the string against the pattern
                    // figure out if the first connector is a DC connector
                    if (con1 && pattern.test(con1)) {
                        sfflip = true;
                    }
                    if (isBNC(con1) && (con2 == 'Z' || con2 == 'L')) {
                        sfflip = true;
                    }

                    // get cable info for diameter and cable PN
                    let cable = cable_info?.option;
                    let dia = cable_info?.diameter;
                    if (!dia) dia = "100";
                    let subdia = "90";

                    // if either connector is L switch it to include the cable.
                    // the right connector gets a _R desgination
                    if (con1 == "L") con1 = cable + "_L";
                    if (con2 == "L") { con2 = cable + "_LR"; } else { con2 = con2 ? con2 + '_R' : ""; }

                    if (!cable || !con1 || !con2) {
                        return null;
                    }

                    // remove this line to turn on cable images
                    //if (!this.IMGDIAG) { return null; }

                    // get the cable angle left, right, straight left, right images
                    let cal = cable + "_AL";
                    let csl = cable + "_SL";
                    let car = cable + "_AR";
                    let csr = cable + "_SR";

                    // determine whether we have armor, if so add end caps
                    let acl = "";
                    let acr = "";
                    let sub = "";
                    let armor = false;
                    if (dat.parttemp.toLowerCase().includes("{armor")) armor = true;
                    if (armor) { acl = cable + "_ACL"; acr = cable + "_ACR"; sub = cable + "_SUB";  }

                    // determine whether we are coiled
                    let coiled = false;
                    if (dat.parttemp.toLowerCase().includes("{coiled")) coiled = true;

                    // Determine whether we have color coding 
                    let cc1 = "";
                    let cc1r = "";
                    let cc2 = "";
                    let cc2r = "";
                    cc1 = cc.length > 1 ? cc[0] : "";
                    cc2 = cc.length > 1 ? cc[1] : "";
                    cc1 = cc1 ? cc1 + dia : "";
                    cc2 = cc2 ? cc2 + dia : "";
                    cc1r = cc1 ? cc1 + '_R' : "";
                    cc2r = cc2 ? cc2 + '_R' : "";

                    // Determine if we have a safety feature
                    sf = sf == "?" ? "" : sf;
                    let sfc = sf ? (sf == "SF" ? "CB103" : "CB105") : "";

                    // Determine whether the left hand side is L
                    let rightL = false;
                    if (con2.endsWith("_LR") || con2 == "Z_R") rightL = true;

                    // Determine if the lengths are equal
                    let equal = false;
                    if (alen == clen) equal = true;

                    // Adjust the CC for the sub armor cable on the right
                    let ccposright = armor && equal && !sf;
                    if (!ccposright) {
                        let _cc1 = cc.length > 1 ? cc[0] : "";
                        let _cc2 = cc.length > 1 ? cc[1] : "";

                        cc1r = _cc1 ? _cc1 + subdia + '_LR' : "";
                        cc2r = _cc2 ? _cc2 + subdia + '_LR' : "";
                    }
                    // If we have a safety feature adjust the color codes on the right
                    if (sfc) {
                        let _cc1 = cc.length > 1 ? cc[0] : "";
                        let _cc2 = cc.length > 1 ? cc[1] : "";

                        cc1r = _cc1 ? _cc1 + subdia + '_R' : "";
                        cc2r = _cc2 ? _cc2 + subdia + '_R' : "";
                    }

                    // If we have a SF and end in L, switch the image to the SF cable with L
                    if (sfc && rightL) con2 = sfc + "_LR";

                    // Determine whether the left hand side is L
                    let leftL = false;
                    if (con1.endsWith("_L") || con1 == "Z") leftL = true;

                    // Adjust the CC for the sub armor cable on the left
                    if (!armor || equal || !leftL) {
                        // Nothing
                    }
                    else
                    {
                        let _cc1 = cc.length > 1 ? cc[0] : "";
                        let _cc2 = cc.length > 1 ? cc[1] : "";
                        cc1 = _cc1 ? _cc1 + subdia : "";
                        cc2 = _cc2 ? _cc2 + subdia : "";
                    }

                    if (pos == 1) {
                        return (
                            <>
                                <div className="io-table" style={{ height: '163px' }}>

                                    <RenderCableOutput {...{
                                        leftL, armor, equal, sfflip, coiled, cable, ccposright, rightL,
                                        con1, csl, cc1, cc2, acl, sfc, sf, cal, cc1r, cc2r, acr, car, csr, con2,
                                        IMGDIAG: this.IMGDIAG
                                    }} />


                                </div>
                            </>

                        );
                    }

                    if (pos == 3) {
                        return (<>
                            <div style={{ width: "100%", overflow: "hidden", paddingTop: '50px', }}>
                                <div className="io-table" style={{
                                    width: '3000px',
                                }}>

                                    <RenderCableOutput {...{
                                        style: {
                                            width: '3000px',
                                        },
                                        leftL, armor, equal, sfflip, coiled, cable, ccposright, rightL,
                                        con1, csl, cc1, cc2, acl, sfc, sf, cal, cc1r, cc2r, acr, car, csr, con2,
                                        IMGDIAG: this.IMGDIAG
                                    }} />

                                </div>
                            </div>
                            <div style={{
                                width: "100%", overflow: "hidden", 
                                MozTransform: 'scale(-1, 1)',
                                WebkitTransform: 'scale(-1, 1)',
                                OTransform: 'scale(-1, 1)',
                                MsTransform: 'scale(-1, 1)',
                                transform: 'scale(-1, 1)'
                            }}>
                                <div className="io-table" style={{
                                    width: '3000px',
                                }}>

                                    <RenderCableOutput {...{
                                        style: {
                                            width: '3000px',

                                            MozTransform: 'scale(-1, 1)',
                                            WebkitTransform: 'scale(-1, 1)',
                                            OTransform: 'scale(-1, 1)',
                                            MsTransform: 'scale(-1, 1)',
                                            transform: 'scale(-1, 1)'
                                        },
                                        leftL, armor, equal, sfflip, coiled, cable, ccposright, rightL,
                                        con1, csl, cc1, cc2, acl, sfc, sf, cal, cc1r, cc2r, acr, car, csr, con2,
                                        IMGDIAG: this.IMGDIAG
                                    }} />




                                </div>
                            </div>

                        </>);
                    }


                }
            }
        }));
    }



    /**
     * 
     * @param {any} state
     * @param {any} d
     * @param {any} jsondata
     * @param {any} defaults
     */
    injectVars(state, d, jsondata, defaults) {
        // #region Parsing and inserting foreign variables
        let _leadInQuestions = jsondata.replaceAll("<|", '~~~').replaceAll("|>", '~~~');
        let lq = _leadInQuestions.split('~~~');
        let _lq = '';
        lq.forEach((l, i) => {
            if (i % 2 == 0) {
                _lq += l;
            }
            else {
                let _a = l.split('|');

                let before = _a[0];
                let after = '';

                let vpath = _a[1];

                let defaultval = '';
                if (_a.length > 2 && _a[2]) {
                    defaultval = defaults[_a[2]];
                }

                let vx = this.getVariableValue(state, d, before, vpath, after, defaultval);
                // replace all newlines with spaces - https://stackoverflow.com/questions/9849754/
                var new_vx = vx.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, " ");

                _lq += new_vx;
            }
        });
        return _lq;
        // #endregion
    }

    //#endregion

    //#region Supporting Render Cart
    /**
     * The normal cart that shows on any of the inprocess tabs or main tab
     * @param {any} state
     * @param {any} includes
     */
    renderCart(dat, state, i, this_state_selected, _partdesc, _invalidMsg,
        anyinvalid, _anyinvalid, __anyinvalid, _1optwrn, buttons, showcart,
        showimage, back, notUseSelected, layoutstyle, inc, liq, img, sm, justcart) {

        if (notUseSelected) {
            this_state_selected = dat.id;
        }

        let block_delete = false;
        let allow_reset = false;
        let block_qty = false;
        let next_btn = false;

        //if (dat) {
        block_delete = dat.block_delete;
        allow_reset = dat.allow_reset;
        block_qty = dat.block_qty;
        next_btn = dat.next_btn;
        //}

        let ci = this.renderCartInners(dat, this_state_selected, _partdesc,
            _anyinvalid, __anyinvalid, _invalidMsg, _1optwrn, block_qty, inc, false, sm);
        if (!ci) return null;

        let rtn = null;
        if (justcart) {
            rtn = <div top={0} key={i}>
                <React.Fragment key={dat.id}>
                    <MediaCard cardcolor={layoutstyle == 1 ? 'none' : null}
                        //style={{ marginTop: '15px' }}
                        title={ci[0]}
                        clear={() => this.props.reset('')}
                        refresh={dat.parent && allow_reset ? () => { this.refPart(dat); } : null}
                        cleartext={'X'}
                        className={'summary-area' + (dat.id != this_state_selected ? ' unsselected' : ' sselected')}>
                        {ci[1]}
                    </MediaCard>
                </React.Fragment>
                {this.getStyle(0) ? buttons(dat.invalid) : null}
                {anyinvalid || !showcart ? null :
                    (!__anyinvalid ? this.renderCheckoutButtons(state, back) : null)
                }
            </div>
        } else {
            rtn = <div top={0} key={i}>
                <React.Fragment key={dat.id}>
                    <MediaCard cardcolor={layoutstyle == 1 ? 'none' : null}
                        //style={{ marginTop: '15px' }}
                        title={ci[0]}
                        clear={dat.parent && !block_delete ? () => { this.delPart(dat.id); } : null}
                        refresh={dat.parent && allow_reset ? () => { this.refPart(dat); } : null}
                        cleartext={'X'}
                        className={'summary-area' + (dat.id != this_state_selected ? ' unsselected' : ' sselected')}>
                        {ci[1]}
                    </MediaCard>
                </React.Fragment>
                {this.getStyle(0) ? buttons(dat.invalid) : null}
                {anyinvalid || !showcart ? null :
                    (!__anyinvalid ? this.renderCheckoutButtons(state, back) : null)
                }
                {showimage ? img : liq}
            </div>
        }

        return rtn;

    }

    /**
     * The Cart that is shown at the checkout screen in the tabbed process
     * @param {any} dat
     * @param {any} state
     * @param {any} i
     * @param {any} this_state_selected
     * @param {any} _partdesc
     * @param {any} _invalidMsg
     * @param {any} anyinvalid
     * @param {any} _anyinvalid
     * @param {any} __anyinvalid
     * @param {any} _1optwrn
     * @param {any} buttons
     * @param {any} showcart
     * @param {any} showimage
     * @param {any} back
     * @param {any} notUseSelected
     * @param {any} layoutstyle
     * @param {any} inc
     */
    renderCartTabbedCheckout(dat, state, i, this_state_selected, _partdesc, _invalidMsg,
        anyinvalid, _anyinvalid, __anyinvalid, _1optwrn, buttons, showcart, showimage, back, notUseSelected, layoutstyle, inc) {

        this_state_selected = dat.id;

        let ci = this.renderCartInners(dat, this_state_selected, _partdesc, _anyinvalid, __anyinvalid, _invalidMsg, _1optwrn, true, inc, true);
        if (!ci) return null;

        return (
            <div enabled={true} top={0}>
                <React.Fragment key={dat.id}>
                    {showimage ? this.renderImage(state, i, "2") : null}
                    <MediaCard cardcolor={layoutstyle == 1 ? 'none' : null}
                        title={ci[0]}
                        className={'summary-area' + (dat.id != this_state_selected ? ' unsselected' : ' sselected')}>
                        {ci[1]}
                    </MediaCard>
                </React.Fragment>
                {anyinvalid || !showcart ? null :
                    (!__anyinvalid ? this.renderCheckoutButtons(state, back) : null)
                }
            </div>
        );

    }

    /**
     * 
     * @param {any} dat
     * @param {any} this_state_selected
     * @param {any} _partdesc
     * @param {any} _anyinvalid
     * @param {any} _invalidMsg
     * @param {any} _1optwrn
     * @param {any} block_qty
     * @param {any} inc
     */
    renderCartInners(dat, this_state_selected, _partdesc, _anyinvalid, __anyinvalid, _invalidMsg, _1optwrn, block_qty, inc, cart2, sm) {

        if (this.getStyle(1) && cart2 && dat.idat.id && !dat.sysadded) return;

        let y = [];

        // The code block for the small cart
        if (sm) {
            if (dat.invalid || dat.disabled) {

                // The header text if invalid
                y.push(
                    <div style={{ fontWeight: 'bold', fontSize: '13px', paddingTop: '26px' }}>
                        <a href="" onClick={(e) => this.setProfile(dat.id, { id: dat.iid },
                            false, '', 0, e)}>
                            {(dat.invalid || dat.disabled ? dat.unseltitle : dat.partnum) || dat.parttemp}</a>
                    </div>
                );
            } else {
 
                // The header text if valid (nowrap)  whiteSpace: 'nowrap',
                y.push(
                    <div style={{ fontWeight: 'bold', fontSize: '13px', paddingTop: '26px' }}>
                        <a href="" onClick={(e) => this.setProfile(dat.id, { id: dat.iid },
                            false, '', 0, e)}>
                            {(dat.invalid || dat.disabled ? dat.unseltitle : dat.partnum) || dat.parttemp}</a>
                    </div>
                );
            }

            return y;
        }

        // If not the small cart
        // The header text
        y.push(
            <div style={{ fontWeight: 'bold' }}>


                <a href="" onClick={(e) => this.setProfile(dat.id, { id: dat.iid },
                    false, '', 0, e)}>
                    {(dat.invalid || dat.disabled ? dat.unseltitle : dat.partnum) || dat.parttemp}</a>
            </div>
        );

        // undoing the global anyinvalid for includes
        // as items were showing up as invaid until all required pns were filled in (I.E. SCs in a SCE)
        if (dat.iid) __anyinvalid = false;

        let curr = this.curr;
        let symbol1 = curr.symbolBeforeAmount ? curr.symbol : '';
        let symbol2 = curr.symbolBeforeAmount ? '' : ' ' + curr.symbol;
        let mult = curr.cconversion;
        let iso = curr.isoCode;
        let txtDisp = iso == 'USD' ? 'none' : '';
        let astrix = iso == 'USD' ? '(USD) ' : '(*' + iso + ') ';

        let dat_places = curr.decimalPlaces;

        let dat_price = fixedTo(dat.price, dat_places);
        let dat_qtydisc = fixedTo(dat.qtydisc, dat_places);
        let dat_flatdisc = fixedTo(dat.flatdisc, dat_places);
        let dat_final = fixedTo(dat.price - dat.qtydisc - dat.flatdisc, dat_places);
        let dat_total = dat_final * dat.qty;

        let outprice_us = "(USD) $" + fixedTo(dat_price, 2);
        let outqdisc_us = "(USD) $" + fixedTo(dat_qtydisc, 2);
        let outfdisc_us = "(USD) $" + fixedTo(dat_flatdisc, 2);
        let outfinal_us = "(USD) $" + fixedTo(dat_final, 2);
        let outtotal_us = "(USD) $" + fixedTo(dat_total, 2);

        dat_price = dat_price * mult;
        dat_qtydisc = dat_qtydisc * mult;
        dat_flatdisc = dat_flatdisc * mult;
        dat_final = dat_final * mult;
        dat_total = dat_total * mult;

        // Calculate the price
        let outprice = astrix + symbol1 + fixedTo(dat_price, dat_places) + symbol2;
        let outqdisc = astrix + symbol1 + fixedTo(dat_qtydisc, dat_places) + symbol2;
        let outfdisc = astrix + symbol1 + fixedTo(dat_flatdisc, dat_places) + symbol2;
        let outfinal = astrix + symbol1 + fixedTo(dat_final, dat_places) + symbol2;
        let outtotal =
            astrix + symbol1 + fixedTo(dat_total, dat_places) + symbol2;

        // The body, shopping cart buttons and prices
        y.push(
            <React.Fragment >
                <div style={{ marginBottom: '15px', fontSize: '12px' }}>{dat.invalid || dat.disabled ? dat.unseltxt : null}</div>
                {
                    // As long as it's valid
                    dat.invalid || dat.disabled ? null :
                        <React.Fragment>
                            {
                                // And also selected
                                dat.id != this_state_selected ? null :
                                    <React.Fragment>

                                        {/*Show the description, price and discounts*/}
                                        <div>
                                            {_partdesc ?
                                                <div style={{ marginBottom: '15px', fontSize: '12px' }}>
                                                    {_partdesc}
                                                </div> : null}
                                            {!this.showprices ? null :
                                                (_anyinvalid || __anyinvalid || _invalidMsg ? null :
                                                    <React.Fragment>
                                                        <Grid container spacing={0} style={{ borderTop: '1px solid gray' }}>
                                                            <Grid item xs>Price</Grid>
                                                            <Grid item xs style={{ textAlign: 'right' }}>
                                                                {outprice_us}<br />
                                                                <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outprice}</span>
                                                            </Grid>
                                                        </Grid>
                                                        {dat.qtydisc === 0 ? null :
                                                            <Grid container spacing={0}>
                                                                <Grid item xs>PL Discount</Grid>
                                                                <Grid item xs style={{ textAlign: 'right' }}>
                                                                    {outqdisc_us}<br />
                                                                    <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outqdisc}</span>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                        {dat.flatdisc === 0 ? null :
                                                            <Grid container spacing={0}>
                                                                <Grid item xs>Flat Discount</Grid>
                                                                <Grid item xs style={{ textAlign: 'right' }}>
                                                                    {outfdisc_us}<br />
                                                                    <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outfdisc}</span>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                        {dat.flatdisc === 0 && dat.qtydisc === 0 ? null :
                                                            <Grid container spacing={0}>
                                                                <Grid item xs style={{ fontWeight: 'bold' }}>Your Price</Grid>
                                                                <Grid item xs style={{ fontWeight: 'bold', textAlign: 'right' }}>
                                                                    {outfinal_us}<br />
                                                                    <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outfinal}</span>
                                                                </Grid>
                                                            </Grid>
                                                        }
                                                    </React.Fragment>
                                                )
                                            }
                                        </div>

                                        {/*Show warnings and the total, add to system button*/}
                                        <Grid container spacing={0} style={{
                                            //borderBottom: '1px solid gray',
                                            paddingBottom: '15px'
                                        }}>
                                            {_anyinvalid ? // || __anyinvalid?
                                                <Alert severity="warning">
                                                    This part has encountered an error.
                                                    Please contact CTC for more info.
                                                            </Alert>
                                                : null
                                            }
                                            {dat.configgroup.map(x => {
                                                let _warningMsg = x.warningMsg ? true : false;

                                                let rtn = (
                                                    _warningMsg && !_1optwrn ?
                                                        <div style={{ width: '100%' }}>
                                                            <Alert severity="warning">
                                                                {x.warningMsg}
                                                                <br />
                                                                {x.invalidActionTxt ?
                                                                    <Button onClick={(e) => this.warningGrpAction(dat.id, x)}>
                                                                        {x.invalidActionTxt}
                                                                    </Button> : null}
                                                            </Alert><hr />
                                                        </div>
                                                        : null);
                                                if (_warningMsg) {
                                                    _1optwrn = true;
                                                }
                                                return rtn;
                                            })}
                                            {_invalidMsg ?
                                                <Alert severity="warning">
                                                    {dat.invalidMsg}
                                                    <br />
                                                    <Button onClick={(e) => this.invalidAction(dat.id, dat.invalidAction)}>
                                                        {dat.invalidActionTxt}
                                                    </Button>
                                                </Alert>
                                                : null
                                            }
                                            {_anyinvalid || __anyinvalid || _invalidMsg ?
                                                null :
                                                (!this.showprices ?
                                                    (!this.request && !this.quote && !this.order ? null :
                                                        <>
                                                            <Grid item xs style={{ fontWeight: 'bold'}}>
                                                                Qty:&nbsp;
                                                                {block_qty || dat.id != this_state_selected ? dat.qty :
                                                                    <input type="number" value={dat.qty}
                                                                        onChange={(e) => { this.setQty(dat.id, e.target.value) }}
                                                                        style={{ textAlign: 'right', width: '100px' }}
                                                                    />}
                                                            </Grid>

                                                            <Grid item xs style={{ fontWeight: 'bold', textAlign: 'right' }}>
                                                                { this.props_showmsg?"Please login to view pricing":null}
                                                            </Grid>
                                                        </>
                                                    )
                                                    :
                                                    <React.Fragment>
                                                        <Grid item xs style={{ fontWeight: 'bold' }}>
                                                            Qty:&nbsp;{block_qty || dat.id != this_state_selected ? dat.qty :
                                                                <input type="number" value={dat.qty}
                                                                    onChange={(e) => { this.setQty(dat.id, e.target.value) }}
                                                                    style={{ textAlign: 'right', width: '100px' }}
                                                                />}
                                                        </Grid>


                                                        <Grid item xs style={{ fontWeight: 'bold', textAlign: 'right' }}>
                                                            Total: {outtotal_us}<br />
                                                            <span style={{ display: txtDisp, fontSize: 'x-small', top: '-7px', position: 'relative' }}>{outtotal}</span>
                                                        </Grid>
                                                        

                                                        {/*<Grid item xs={12} style={{ fontSize: '65%', textAlign: 'justify' }}>
                                                            *Prices do not include duties, taxes & shipping
                                                        </Grid>*/}

                                                    </React.Fragment>
                                                )
                                            }

                                            {/* the "pseudo add" block is only shown for valid include parts (not on the summary) for style 1*/}
                                            {_anyinvalid || __anyinvalid || _invalidMsg ?
                                                null :
                                                <>{!dat.idat || !dat.idat.id || cart2 || this.getStyle(0) ? null :
                                                    <Grid item xs={12} style={{ paddingTop: '25px', textAlign: 'center', color: 'green' }}>
                                                        {dat.sysadded ?
                                                            <div><CheckIcon /> Added</div> :
                                                            <Button style={{ width: '100%' }} variant="outlined" color="success"
                                                                onClick={(e) => this.addToSystem(dat.id)}>
                                                                Add to System</Button>
                                                        }
                                                    </Grid>
                                                }</>
                                            }
                                        </Grid>

                                        {
                                            // A "continue next "button for the SCE (non-tabbed) view
                                            !inc || this.getStyle(1) ? null :
                                                <div style={{ width: '100%', textAlign: 'right' }}><Button variant="contained" className={themeButton}
                                                    onClick={(e) => this.setProfile(inc.id, { id: dat.iid }, false, '', 0, e)}>Continue to Next Step</Button></div>
                                        }

                                    </React.Fragment>
                            }
                        </React.Fragment>

                }
            </React.Fragment>
        );

        return y;
    }

    /**
     * 
     * @param {any} state
     * @param {any} includes
     */
    renderCheckoutButtons(state, back) {

        let curr = this.curr;
        let symbol1 = curr.symbolBeforeAmount ? curr.symbol : '';
        let symbol2 = curr.symbolBeforeAmount ? '' : ' ' + curr.symbol;
        let mult = curr.cconversion;
        let iso = curr.isoCode;
        let txtDisp = iso == 'USD' ? 'none' : '';

        // Check that all the suplemental parts have loaded
        let allLoaded = true;
        state.data.forEach(yx => {
            let _parts = []; addToCart(yx.partnum, yx.qty, yx.id, yx.parent, _parts);

            if (_parts.length == 0) {
                allLoaded = true;
            } else {

                _parts.forEach((p, i) => {
                    let arp = p.split(':');
                    if (i == 0) return;

                    let px = state.extraparts?.find(ex => ex.name == arp[0]);
                    allLoaded = allLoaded && (px?.dtl ? true : false);
                });
            }
        });


        return (
            <React.Fragment>

                <div style={{
                    borderRadius: '5px',
                    border: '1px solid black',
                    xborderTop:'0px',
                    padding: '5px',
                    xpaddingTop: '0',
                    xposition: 'relative',
                    xtop: '-22px',
                    background: 'rgb(245 245 245)',
                    xborderTopLeftRadius: '0',
                    xborderTopRightRadius: '0'
                }}>
                    <div style={{
                        backgroundColor: '#d6d6d6',
                        padding: '5px'
                    }}>
                    <Grid item xs={12} style={{
                        fontSize: '75%', textAlign: 'justify', paddingBottom: '30px',
                        fontWeight: 'bold'
                    }}>
                        *Prices do not include duties, taxes & shipping
                        <span style={{ display: txtDisp, fontWeight: 'bold' }}>
                            <br /><br />
                            All parts listed on the Connection Technology Center (CTC) website are priced in U.S. Dollars (USD),
                            ensuring consistency in pricing regardless of the buyer's location. International customers should be
                            aware that the final cost in their local currency may vary based on exchange rates, applicable bank
                            or payment processing fees, local taxes, tariffs and duties, freight, etc. All exchange rates are
                            refreshed on our website approximately every 5 minutes.
                            <br /><br />
                            Additionally, all sales are final in USD, meaning that payments to CTC must be made in U.S. Dollars.
                            Any currency fluctuations after transactions are completed will not affect the amount due. Customers
                            are encouraged to verify exchange rates and consider any potential fees prior to making a purchase.
                        </span>
                    </Grid>
                    </div>
                </div>

                <Grid container spacing={1} style={{ padding: '15px' }}>



                    {back ?
                        <Grid item xs><Button onClick={(e, v) => this.setActiveStep(e, v, this.state.activeStep - 1)} color="light"
                        ><ChevronLeft className={themeClass} /> Back to Previous Step</Button></Grid>
                        : null}
                    {this.cart && this.showprices ?
                        <Grid item xs><Button style={{ width: '100%' }} variant="contained" disabled={!allLoaded}
                            className={themeButton} onClick={(e) => this.addCart()}>Add To Cart</Button></Grid>
                        : null}
                    {this.quote ?
                        <Grid item xs><Button style={{ width: '100%' }} variant="contained" disabled={!allLoaded}
                            className={themeButton} onClick={(e) => this.addQuote()}>Add To Quote</Button></Grid>
                        : null}
                    {this.request ?
                        <React.Fragment>
                            {!state.email.state || state.email.state == '' ?
                                <Grid item xs><Button style={{ width: '100%' }} variant="contained"
                                    className={themeButton} onClick={(e) => this.setupEmail()}>Request Info</Button></Grid>
                                : null}
                            {state.email.state == 'email' ?
                                <Grid item xs>
                                    Name:
                            <input style={{ width: '100%' }} type="text" value={state.email.name}
                                        onChange={(e) => this.setField('name', e.target.value)} />
                            Email:
                            <input style={{ width: '100%' }} type="text" value={state.email.email}
                                        onChange={(e) => this.setField('email', e.target.value)} />
                            Phone:
                            <input style={{ width: '100%' }} type="text" value={state.email.phone}
                                        onChange={(e) => this.setField('phone', e.target.value)} />
                                    <hr />
                                    <Button style={{ width: '100%' }} variant="contained"
                                        className={themeButton} onClick={(e) => this.sentEmail()}>Send Request</Button></Grid>
                                : null}
                            {state.email.state == 'sent' ?
                                <Grid item xs>
                                    Request Sent, we will be in touch as soon as possible!
                            <Button style={{ width: '100%' }} variant="contained"
                                        className={themeButton} onClick={(e) => this.startEmail()}>Request Again</Button></Grid>
                                : null}

                            {state.email.state == 'error' ?
                                <Grid item xs>
                                    We appologize, our application has encountered an error.
                            <Button style={{ width: '100%' }} variant="contained"
                                        className={themeButton} onClick={(e) => this.startEmail()}>Try Again</Button></Grid>
                                : null}
                        </React.Fragment>
                        : null}
                </Grid>
            </React.Fragment>
        );
    }

    //#endregion

    //#region Supporting Functions
    /**
     * 
     * @param {any} render
     */
    setNextButtonRendered(render)
    {
        this.nextButtonRendered = !(render == null);
        return this.nextButtons;
    }

    /**
     * 
     * @param {any} style
     */
    getStyle(style)
    {
        let x = 0;
        x = (this.state.data[0].name == 'Vibration Pole' ||
            this.state.data[0].name == 'Sensor Beta' ||
            this.state.data[0].name == 'LP Beta') ? 1 : 0;
        return style == x;
    }
    
    /**
     * 
     * @param {any} state
     * @param {any} d
     * @param {any} before
     * @param {any} vpath
     * @param {any} after
     * @param {any} defaultval
     */
    getVariableValue(state, d, before, vpath, after, defaultval) {
        let _lq = '';

        let _l = vpath.split('.');
        let _l0 = _l[0];
        this.getOptionValueWithSC(d.id, state, _l0, (g, o) => {

            let _o = []; try { _o = JSON.parse(o.keyvaluelist); } catch { }
            _o.forEach(__o => {

                o[__o.key.replaceAll(' ', '')] = __o.val
            });

            _l = _l.filter((a, b) => b > 0);
            let obj = this.getNested(o, _l);
            if (
                typeof obj === 'object' &&
                !Array.isArray(obj) &&
                obj !== null
            ) {
                _lq += '';
            } else {
                if (!obj) {
                    _lq += defaultval ? before + defaultval + after : '';
                } else {
                    _lq += obj ? before + obj + after : '';
                }
            }
        });

        return _lq;
    }

    /**
     * 
     * @param {any} dat
     * @param {any} index
     * @param {any} y
     */
    renderSingle(dat, index, y) {
        return (

            <React.Fragment key={dat.id}>
                {index != 0 ? null :
                    <div className="flex-container">
                        <div className="flex-item">Know&nbsp;your&nbsp;Part&nbsp;Number? Type&nbsp;it&nbsp;here:</div>
                        <div className="flex-item"><Input style={{ width: '100%' }} value={dat.know} onChange={(e) => this.setKnow(dat, e.target.value)} /></div>
                        <div className="flex-item"><Button className={themeButton} onClick={(e) => this.handelKnowPN(dat)}>Submit</Button></div>
                    </div>}



                {index == -1 ? null : y["imageflat"]}

                <Grid container spacing={1}>

                    {/*As long as we arent on the confirm screen show the selector and diagnostic*/}
                    {index == -1 ? null :
                        <Grid item sm={8} style={{ zIndex: '1' }}>

                            {y["selector"]}

                            {y["leadinquestions"]}

                            {y["diagnostic"]}

                        </Grid>
                    }

                    {/*Adjust the size of the cart view based on the screen*/}
                    <Grid item sm={index == -1 ? 9 : 4} className={'summary-grid transitions'}>

                        {y["cart"]}

                    </Grid>

                    {/*As long as we are on the confirm screen show the right aligned picture*/}
                    {index == -1 ?
                        <Grid item sm={3} style={{ zIndex: '1' }}>
                            {y["imagestacked"]}
                        </Grid>
                        : null
                    }
                </Grid>
            </React.Fragment>
        );
    }

    /**
     * 
     * @param {any} dat
     * @param {any} sc
     */
    getRenderInfoShortCode(dat, sc) {
        let opt = dat.renderinfo.find(x => x.shortcode.toLowerCase() == sc.toLowerCase());
        if (!opt) {
            opt = { option: '' };
        }
        return opt;
    }

    //#endregion

    //#endregion

    // #endregion

    //#region Events

    /**
     * 
     * @param {any} e
     * @param {any} v
     * @param {any} index
     * @param {any} x
     */
    async setImageView(e, v, index, x) {
        e.preventDefault();
        await this.setState((s, p) => {
            s.data[index].ImageView = x;
            return { data: s.data };
        });
    }

    /** */
    async incStepGenIncludes() {
        //let state = this.includesRunner(true);
        //state.activeStep = state.activeStep + 1

        await this.includesRunner(false);

        this.setState({ activeStep: this.state.activeStep + 1 });
    }



    /**
     * 
     * @param {any} loading
     */
    async includesRunner(loading, s, inc_id) {
        let state = s || this.state;
        let d = state.data[0];

        await Promise.all(includesFilter(state,d).map(async dat => {
            // get the partent qty
            let d_qty = d.qty;

            // get the quantity of product to recommend
            let fqty = dat.qty;
            let qty = dat.qty;
            if (dat.qtyfld) {
                this.getOptionValue(d.id, state, dat.qtyfld, (x, y) => {
                    qty = y.name;
                });
            }

            // ge the id of the part creator group to add
            //let inc = state.profiles.filter(x => dat.cpcprofile === x.name)[0];
            let inc = state.profiles.find(x => dat.cpcprofile === x.name);

            // retrieve how much qty has already been used.
            let tot = 0;
            this.state.data.filter(d => d.iid == dat.id).forEach(g => {
                tot += g.qty;
            });

            if (qty) {
                let _qty = parseInt(qty) * d_qty;

                // As long as there is quantity left to add
                // And the suggested part has not been declined
                if (tot < _qty) {
                    if (!dat.declined) {

                        this.includespassed = this.includespassed && false;

                        let unseltitle = dat.unseltitle;
                        let inittemplate = dat.inittemplate;
                        let add1_all = dat.add1_all;
                        let default_add1 = dat.default_add1;
                        let default_all = dat.default_all;

                        // the continue result from the lead in questions
                        let rtnObj = {};
                        rtnObj.cont = true;
                        rtnObj.codes = [];

                        // Process the lead in questions
                        let _y = this.renderLeadInQuestions(state, state.data[0], rtnObj);
                        let ans_code = rtnObj.codes.find(c => c.id == dat.code);
                        let binding = this.getNested(ans_code, 'binding');

                        // Assign the answer code onto the include object
                        dat.ans = ans_code;


                        if (!inc_id || inc_id == dat.id) {
                            if (default_add1 && (!this.alreadyran || inc_id)) {
                                if (add1_all) {
                                    await this.setProfiles(inc.id, dat, true, d.id, 1, null, binding, null, _qty - tot, unseltitle, inittemplate);
                                } else {

                                    await this.setProfile(inc.id, dat, true, d.id, 1, null, binding, null, unseltitle, inittemplate);
                                }
                            } else if (default_all) {

                            }
                        }
                    }
                }
            }
        }));
        this.alreadyran = true;
    }
    alreadyran = false;
    // #endregion

    // #region Getter and Setter Methods

    getConfigList(s, pc) {
        return this.getConfigListD(s.data, pc)
    }

    getConfigListD(data, pc) {
        let cl = data.find(d => (d.id == pc))
        if (cl) return cl.configlist;
        else return this.configlist;

        //return this.configlist;
        //return data.find(d => (d.id == pc)).configlist;
    }

    /**
     *
     * @param {any} s - The state variable.
     * @param {any} name - The name of the group to retrieve the value from.
     * @param {any} cb - The callback method to send the group and value to.
     */
    getGroup(pc, s, id, cb) {
        let group = {};
        let option = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.id == id);
                group = _g || { name: '', type: '1' };
            }
        });

        cb(group);
    }

    /**
     *
     * @param {any} s - The state variable.
     * @param {any} name - The name of the group to retrieve the value from.
     * @param {any} cb - The callback method to send the group and value to.
     */
    getGroupID(pc, s, name, cb) {
        let group = {};
        let option = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.name == name);
                group = _g || { name: '', type: '1' };
            }
        });

        cb(group);
    }

    /**
     *
     * @param {any} s - The state variable.
     * @param {any} shortcode - The shortcode of the group to retrieve the value from.
     * @param {any} cb - The callback method to send the group and value to.
     */
    getGroupWithShortCode(pc, s, shortcode, cb) {
        let group = {};
        let option = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.shortcode == shortcode);
                group = _g || { name: '', type: '1' };
            }
        });

        cb(group);
    }

    /**
     *
     * @param {any} s - The state variable.
     * @param {any} name - The name of the group to retrieve the value from.
     * @param {any} cb - The callback method to send the group and value to.
     */
    getOptionValue(pc, s, name, cb) {
        let group = {};
        let option = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.name == name);
                group = _g || { name: '', type: '1' };
            }
        });

        let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[pc + '_' + group.id]);
        option = _o || { name: '', grouptitle: '', ord: 0 };

        if (group.type == '3' || group.type == '4') {
            option = { name: s.selections[pc + '_' + group.id], grouptitle: s.selections[pc + '_' +group.id], ord: 0 };
        }


        cb(group, option);
    }

    /**
     * 
     * @param {any} s - The state variable.
     * @param {any} id - The id of the group to retrieve the value from.
     * @param {any} cb - The callback method to send the group and value to.
     */
    getOptionValue2(pc, s, id, cb) {
        let group = {};
        let option = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.id == id);
                group = _g || { name: '', type: '1' };
            }

        });

        let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[pc + '_' + id]);
        option = _o || { name: '', grouptitle: '', ord: 0 };

        if (group.type == '3' || group.type == '4') {
            option = { name: s.selections[pc + '_' +group.id], grouptitle: s.selections[pc + '_' +group.id], ord: 0 };
        }

        cb(group, option);
    }

    /**
     * 
     * @param {any} s - The state variable.
     * @param {any} id - The id of the group to retrieve the value from.
     * @param {any} cb - The callback method to send the group and value to.
     */
    getOptionValue3(s, id, cb) {
        let _pc = id.split('_');
        let pc = _pc[0];
        id = _pc[1];

        let group = {};
        let option = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.id == id);
                group = _g || { name: '', type: '1' };
            }
        });

        let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[pc + '_' + id]);
        option = _o || { name: '', grouptitle: '', ord: 0 };

        if (group.type == '3' || group.type == '4') {
            option = { name: s.selections[pc + '_' + group.id], grouptitle: s.selections[pc + '_' + group.id], ord: 0 };
        }

        cb(group, option);
    }

    /**
     * 
     * @param {any} s - The state variable.
     * @param {any} sc - The shortcode of the group to retrieve the value from.
     * @param {any} cb - The callback method to send the group and value to.
     */
    getOptionValueWithSC(pc, s, sc, cb) {
        let group = {};
        let option = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.shortcode == sc);
                group = _g || { name: '', type: '1' };
            }
        });

        let _o = this.getConfigList(s, pc).find(f => f.id == s.selections[pc + '_' + group.id]);
        option = _o || { name: '', grouptitle: '', ord: 0 };

        if (group.type == '3' || group.type == '4') {
            option = { name: s.selections[pc + '_' + group.id], grouptitle: s.selections[pc + '_' + group.id], ord: 0 };
        }

        cb(group, option);
    }

    /**
     * 
     * @param {any} s - The react state
     * @param {any} name - The name of the group who's property to set
     * @param {any} prop - The name of the property to set
     * @param {any} val - The value to set
     */
    setGroupProp(pc, s, name, prop, val) {
        let group = {};

        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.name == name);
                group = _g || { name: '', type: '1' };
            }
        });
        group[prop] = val;
    }

    /**
     * 
     * @param {any} s - The state variable.
     * @param {any} name - The name of the group to set the value of
     * @param {any} val - The value to set
     */
    setOptionValue(pc, s, name, val) {
        let group = {};
        s.data.forEach(d => {
            if (d.id == pc) {
                let _g = d.configgroup.find(f => f.name == name);
                group = _g || { name: '', type: '1' };
            }
        });
        this.setOptionValue2(pc, group, val);
    }

    /**
     * 
     * @param {any} s - The statye data.
     * @param {any} group - The group object to set the value of
     * @param {any} val - The value to set
     */
    setOptionValue2(pc, s, group, val) {
        this.setSelections(s, pc, group.id, val);

        if (!s._selections) s._selections = {};
        s._selections[pc + '_' + group.id] = val;
    }

    /**
     *
     * @param {any} data - The state data.
     * @param {any} selections - the state selections.
     * @param {any} id - The id of the group to set the value of.
     * @param {any} val - The name (non-id) value to set.
     */
    setOptionVal(pc, data, selections, _selections, id, name, val, vid, sc) {
        let group = {};
        let option = {};

        if (id) {
            data.forEach(d => {
                if (pc == d.id) {
                    let _g = d.configgroup.find(f => f.id == id);
                    group = _g || { name: '', type: '1' };
                }
            });
        }

        if (name) {
            data.forEach(d => {
                if (pc == d.id) {
                    let _g = d.configgroup.find(f => f.name == name);
                    group = _g || { name: '', type: '1' };
                }
            });
        }

        if (sc) {
            data.forEach(d => {
                if (pc == d.id) {
                    let _g = d.configgroup.find(f => f.shortcode == sc);
                    group = _g || { name: '', type: '1' };
                }
            });
        }

        let rtn = {};
        if (group.id) {
            if (group.type == '3' || group.type == '4' || val == '?') {
                this.setSelectionsS(selections, pc, group.id, val);

                _selections[pc + '_' + group.id] = val;
                rtn = { id:group.id, v:val };
            }
            else {
                if (!vid && val) {
                    let _o = this.getConfigListD(data, pc).find(f => f.configgroup == group.id && f.name == val && f.pcprofile == pc);

                    option = _o || { name: '', grouptitle: '', ord: 0 };

                    this.setSelectionsS(selections, pc, group.id, option.id);

                    _selections[pc + '_' + group.id] = val;
                    rtn = { id:group.id, v:option.id };
                } else
                {
                    this.setSelectionsS(selections, pc, group.id, vid);

                    _selections[pc + '_' + group.id] = val;
                    rtn = { id:group.id, v:vid };
                }
            }
        }
        return rtn;
    }

    /**
     *
     * @param {any} data - The state data.
     * @param {any} selections - the state selections.
     * @param {any} id - The id of the group to set the value of.
     * @param {any} val - The name (non-id) value to set.
     */
    setOptionValX(pc, s, id, name, val, vid, sc) {
        if (!s._selections) s._selections = {};
        this.setOptionVal(pc, s.data, s.selections, s._selections, id, name, val, vid, sc);
    }

    // Selection Setters

    /**
     * 
     * @param {any} state
     * @param {any} pcid
     * @param {any} grpid
     * @param {any} val
     */
    setSelections(state, pcid, grpid, val) {
        this.setSelectionsX(state.selections, pcid + '_' + grpid, val);
    }

    /**
     * 
     * @param {any} state
     * @param {any} property
     * @param {any} val
     */
    setSelectionsP(state, property, val) {
        this.setSelectionsX(state.selections, property, val);
    }

    /**
     * 
     * @param {any} selections
     * @param {any} pcid
     * @param {any} grpid
     * @param {any} val
     */
    setSelectionsS(selections, pcid, grpid, val) {
        this.setSelectionsX(selections, pcid + '_' + grpid, val);
    }

    /**
     * 
     * @param {any} selections
     * @param {any} property
     * @param {any} val
     */
    setSelectionsX(selections, property, val) {
        selections[property] = val
    }

    // #endregion

    //#region utility

    /**
     * Generate a GUID
     * */
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    /**
     * Trim characters from the end and begining
     * @param {any} s The string to trim
     * @param {any} c The character to trim off
     */
    trim(s, c) {
        if (c === "]") c = "\\]";
        if (c === "\\") c = "\\\\";
        return s.replace(new RegExp(
            "^[" + c + "]+|[" + c + "]+$", "g"
        ), "");
    }

    /** Generate a hash code for the string provided*/
    hashCode(str) {
        var hash = 0, i, chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
            chr = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };

    //#endregion

    //#region DEPRECAED

    /**
     * DEPRECATED
     * @param {any} s
     * @param {any} p
     */
    tallySelections(s, p) {
        // get the current selection
        let i = s[p];
        this.configlist.filter(f => f.id == i).forEach(e => {

        });
    }

    //#endregion
}